!(function (e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = e.document
              ? t(e, !0)
              : function (e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return t(e);
                })
        : t(e);
})("undefined" != typeof window ? window : this, function (C, e) {
    "use strict";
    var t = [],
        r = Object.getPrototypeOf,
        s = t.slice,
        g = t.flat
            ? function (e) {
                  return t.flat.call(e);
              }
            : function (e) {
                  return t.concat.apply([], e);
              },
        u = t.push,
        i = t.indexOf,
        n = {},
        o = n.toString,
        v = n.hasOwnProperty,
        a = v.toString,
        l = a.call(Object),
        y = {},
        m = function (e) {
            return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
        },
        x = function (e) {
            return null != e && e === e.window;
        },
        E = C.document,
        c = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function b(e, t, n) {
        var r,
            i,
            o = (n = n || E).createElement("script");
        if (((o.text = e), t)) for (r in c) (i = t[r] || (t.getAttribute && t.getAttribute(r))) && o.setAttribute(r, i);
        n.head.appendChild(o).parentNode.removeChild(o);
    }
    function w(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? n[o.call(e)] || "object" : typeof e;
    }
    var f = "3.6.0",
        S = function (e, t) {
            return new S.fn.init(e, t);
        };
    function p(e) {
        var t = !!e && "length" in e && e.length,
            n = w(e);
        return !m(e) && !x(e) && ("array" === n || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
    }
    (S.fn = S.prototype = {
        jquery: f,
        constructor: S,
        length: 0,
        toArray: function () {
            return s.call(this);
        },
        get: function (e) {
            return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function (e) {
            var t = S.merge(this.constructor(), e);
            return (t.prevObject = this), t;
        },
        each: function (e) {
            return S.each(this, e);
        },
        map: function (n) {
            return this.pushStack(
                S.map(this, function (e, t) {
                    return n.call(e, t, e);
                })
            );
        },
        slice: function () {
            return this.pushStack(s.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        even: function () {
            return this.pushStack(
                S.grep(this, function (e, t) {
                    return (t + 1) % 2;
                })
            );
        },
        odd: function () {
            return this.pushStack(
                S.grep(this, function (e, t) {
                    return t % 2;
                })
            );
        },
        eq: function (e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: u,
        sort: t.sort,
        splice: t.splice,
    }),
        (S.extend = S.fn.extend = function () {
            var e,
                t,
                n,
                r,
                i,
                o,
                a = arguments[0] || {},
                s = 1,
                u = arguments.length,
                l = !1;
            for ("boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++), "object" == typeof a || m(a) || (a = {}), s === u && ((a = this), s--); s < u; s++)
                if (null != (e = arguments[s]))
                    for (t in e)
                        (r = e[t]),
                            "__proto__" !== t &&
                                a !== r &&
                                (l && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                                    ? ((n = a[t]), (o = i && !Array.isArray(n) ? [] : i || S.isPlainObject(n) ? n : {}), (i = !1), (a[t] = S.extend(l, o, r)))
                                    : void 0 !== r && (a[t] = r));
            return a;
        }),
        S.extend({
            expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e);
            },
            noop: function () {},
            isPlainObject: function (e) {
                var t, n;
                return !(!e || "[object Object]" !== o.call(e)) && (!(t = r(e)) || ("function" == typeof (n = v.call(t, "constructor") && t.constructor) && a.call(n) === l));
            },
            isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
            },
            globalEval: function (e, t, n) {
                b(e, { nonce: t && t.nonce }, n);
            },
            each: function (e, t) {
                var n,
                    r = 0;
                if (p(e)) {
                    for (n = e.length; r < n; r++) if (!1 === t.call(e[r], r, e[r])) break;
                } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
            },
            makeArray: function (e, t) {
                var n = t || [];
                return null != e && (p(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
            },
            inArray: function (e, t, n) {
                return null == t ? -1 : i.call(t, e, n);
            },
            merge: function (e, t) {
                for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
                return (e.length = i), e;
            },
            grep: function (e, t, n) {
                for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) !t(e[i], i) !== a && r.push(e[i]);
                return r;
            },
            map: function (e, t, n) {
                var r,
                    i,
                    o = 0,
                    a = [];
                if (p(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && a.push(i);
                else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
                return g(a);
            },
            guid: 1,
            support: y,
        }),
        "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
        S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            n["[object " + t + "]"] = t.toLowerCase();
        });
    var d = (function (n) {
        var e,
            d,
            b,
            o,
            i,
            h,
            f,
            g,
            w,
            u,
            l,
            T,
            C,
            a,
            E,
            v,
            s,
            c,
            y,
            S = "sizzle" + 1 * new Date(),
            p = n.document,
            k = 0,
            r = 0,
            m = ue(),
            x = ue(),
            A = ue(),
            N = ue(),
            j = function (e, t) {
                return e === t && (l = !0), 0;
            },
            D = {}.hasOwnProperty,
            t = [],
            q = t.pop,
            L = t.push,
            H = t.push,
            O = t.slice,
            P = function (e, t) {
                for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
                return -1;
            },
            R = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            M = "[\\x20\\t\\r\\n\\f]",
            I = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            W = "\\[" + M + "*(" + I + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + M + "*\\]",
            F = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + W + ")*)|.*)\\)|)",
            B = new RegExp(M + "+", "g"),
            $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
            _ = new RegExp("^" + M + "*," + M + "*"),
            z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
            U = new RegExp(M + "|>"),
            X = new RegExp(F),
            V = new RegExp("^" + I + "$"),
            G = {
                ID: new RegExp("^#(" + I + ")"),
                CLASS: new RegExp("^\\.(" + I + ")"),
                TAG: new RegExp("^(" + I + "|[*])"),
                ATTR: new RegExp("^" + W),
                PSEUDO: new RegExp("^" + F),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + R + ")$", "i"),
                needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i"),
            },
            Y = /HTML$/i,
            Q = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            K = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
            ne = function (e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
            },
            re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie = function (e, t) {
                return t ? ("\0" === e ? "\ufffd" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
            },
            oe = function () {
                T();
            },
            ae = be(
                function (e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            H.apply((t = O.call(p.childNodes)), p.childNodes), t[p.childNodes.length].nodeType;
        } catch (e) {
            H = {
                apply: t.length
                    ? function (e, t) {
                          L.apply(e, O.call(t));
                      }
                    : function (e, t) {
                          var n = e.length,
                              r = 0;
                          while ((e[n++] = t[r++]));
                          e.length = n - 1;
                      },
            };
        }
        function se(t, e, n, r) {
            var i,
                o,
                a,
                s,
                u,
                l,
                c,
                f = e && e.ownerDocument,
                p = e ? e.nodeType : 9;
            if (((n = n || []), "string" != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))) return n;
            if (!r && (T(e), (e = e || C), E)) {
                if (11 !== p && (u = Z.exec(t)))
                    if ((i = u[1])) {
                        if (9 === p) {
                            if (!(a = e.getElementById(i))) return n;
                            if (a.id === i) return n.push(a), n;
                        } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i) return n.push(a), n;
                    } else {
                        if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
                        if ((i = u[3]) && d.getElementsByClassName && e.getElementsByClassName) return H.apply(n, e.getElementsByClassName(i)), n;
                    }
                if (d.qsa && !N[t + " "] && (!v || !v.test(t)) && (1 !== p || "object" !== e.nodeName.toLowerCase())) {
                    if (((c = t), (f = e), 1 === p && (U.test(t) || z.test(t)))) {
                        ((f = (ee.test(t) && ye(e.parentNode)) || e) === e && d.scope) || ((s = e.getAttribute("id")) ? (s = s.replace(re, ie)) : e.setAttribute("id", (s = S))), (o = (l = h(t)).length);
                        while (o--) l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]);
                        c = l.join(",");
                    }
                    try {
                        return H.apply(n, f.querySelectorAll(c)), n;
                    } catch (e) {
                        N(t, !0);
                    } finally {
                        s === S && e.removeAttribute("id");
                    }
                }
            }
            return g(t.replace($, "$1"), e, n, r);
        }
        function ue() {
            var r = [];
            return function e(t, n) {
                return r.push(t + " ") > b.cacheLength && delete e[r.shift()], (e[t + " "] = n);
            };
        }
        function le(e) {
            return (e[S] = !0), e;
        }
        function ce(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function fe(e, t) {
            var n = e.split("|"),
                r = n.length;
            while (r--) b.attrHandle[n[r]] = t;
        }
        function pe(e, t) {
            var n = t && e,
                r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (r) return r;
            if (n) while ((n = n.nextSibling)) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function de(t) {
            return function (e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t;
            };
        }
        function he(n) {
            return function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === n;
            };
        }
        function ge(t) {
            return function (e) {
                return "form" in e
                    ? e.parentNode && !1 === e.disabled
                        ? "label" in e
                            ? "label" in e.parentNode
                                ? e.parentNode.disabled === t
                                : e.disabled === t
                            : e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
                        : e.disabled === t
                    : "label" in e && e.disabled === t;
            };
        }
        function ve(a) {
            return le(function (o) {
                return (
                    (o = +o),
                    le(function (e, t) {
                        var n,
                            r = a([], e.length, o),
                            i = r.length;
                        while (i--) e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
                    })
                );
            });
        }
        function ye(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e;
        }
        for (e in ((d = se.support = {}),
        (i = se.isXML = function (e) {
            var t = e && e.namespaceURI,
                n = e && (e.ownerDocument || e).documentElement;
            return !Y.test(t || (n && n.nodeName) || "HTML");
        }),
        (T = se.setDocument = function (e) {
            var t,
                n,
                r = e ? e.ownerDocument || e : p;
            return (
                r != C &&
                    9 === r.nodeType &&
                    r.documentElement &&
                    ((a = (C = r).documentElement),
                    (E = !i(C)),
                    p != C && (n = C.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", oe, !1) : n.attachEvent && n.attachEvent("onunload", oe)),
                    (d.scope = ce(function (e) {
                        return a.appendChild(e).appendChild(C.createElement("div")), "undefined" != typeof e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                    })),
                    (d.attributes = ce(function (e) {
                        return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (d.getElementsByTagName = ce(function (e) {
                        return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length;
                    })),
                    (d.getElementsByClassName = K.test(C.getElementsByClassName)),
                    (d.getById = ce(function (e) {
                        return (a.appendChild(e).id = S), !C.getElementsByName || !C.getElementsByName(S).length;
                    })),
                    d.getById
                        ? ((b.filter.ID = function (e) {
                              var t = e.replace(te, ne);
                              return function (e) {
                                  return e.getAttribute("id") === t;
                              };
                          }),
                          (b.find.ID = function (e, t) {
                              if ("undefined" != typeof t.getElementById && E) {
                                  var n = t.getElementById(e);
                                  return n ? [n] : [];
                              }
                          }))
                        : ((b.filter.ID = function (e) {
                              var n = e.replace(te, ne);
                              return function (e) {
                                  var t = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                                  return t && t.value === n;
                              };
                          }),
                          (b.find.ID = function (e, t) {
                              if ("undefined" != typeof t.getElementById && E) {
                                  var n,
                                      r,
                                      i,
                                      o = t.getElementById(e);
                                  if (o) {
                                      if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                      (i = t.getElementsByName(e)), (r = 0);
                                      while ((o = i[r++])) if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                  }
                                  return [];
                              }
                          })),
                    (b.find.TAG = d.getElementsByTagName
                        ? function (e, t) {
                              return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : d.qsa ? t.querySelectorAll(e) : void 0;
                          }
                        : function (e, t) {
                              var n,
                                  r = [],
                                  i = 0,
                                  o = t.getElementsByTagName(e);
                              if ("*" === e) {
                                  while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                                  return r;
                              }
                              return o;
                          }),
                    (b.find.CLASS =
                        d.getElementsByClassName &&
                        function (e, t) {
                            if ("undefined" != typeof t.getElementsByClassName && E) return t.getElementsByClassName(e);
                        }),
                    (s = []),
                    (v = []),
                    (d.qsa = K.test(C.querySelectorAll)) &&
                        (ce(function (e) {
                            var t;
                            (a.appendChild(e).innerHTML = "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + M + "*(?:''|\"\")"),
                                e.querySelectorAll("[selected]").length || v.push("\\[" + M + "*(?:value|" + R + ")"),
                                e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="),
                                (t = C.createElement("input")).setAttribute("name", ""),
                                e.appendChild(t),
                                e.querySelectorAll("[name='']").length || v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"),
                                e.querySelectorAll(":checked").length || v.push(":checked"),
                                e.querySelectorAll("a#" + S + "+*").length || v.push(".#.+[+~]"),
                                e.querySelectorAll("\\\f"),
                                v.push("[\\r\\n\\f]");
                        }),
                        ce(function (e) {
                            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var t = C.createElement("input");
                            t.setAttribute("type", "hidden"),
                                e.appendChild(t).setAttribute("name", "D"),
                                e.querySelectorAll("[name=d]").length && v.push("name" + M + "*[*^$|!~]?="),
                                2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"),
                                (a.appendChild(e).disabled = !0),
                                2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"),
                                e.querySelectorAll("*,:x"),
                                v.push(",.*:");
                        })),
                    (d.matchesSelector = K.test((c = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.msMatchesSelector))) &&
                        ce(function (e) {
                            (d.disconnectedMatch = c.call(e, "*")), c.call(e, "[s!='']:x"), s.push("!=", F);
                        }),
                    (v = v.length && new RegExp(v.join("|"))),
                    (s = s.length && new RegExp(s.join("|"))),
                    (t = K.test(a.compareDocumentPosition)),
                    (y =
                        t || K.test(a.contains)
                            ? function (e, t) {
                                  var n = 9 === e.nodeType ? e.documentElement : e,
                                      r = t && t.parentNode;
                                  return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
                              }
                            : function (e, t) {
                                  if (t) while ((t = t.parentNode)) if (t === e) return !0;
                                  return !1;
                              }),
                    (j = t
                        ? function (e, t) {
                              if (e === t) return (l = !0), 0;
                              var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                              return (
                                  n ||
                                  (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!d.sortDetached && t.compareDocumentPosition(e) === n)
                                      ? e == C || (e.ownerDocument == p && y(p, e))
                                          ? -1
                                          : t == C || (t.ownerDocument == p && y(p, t))
                                          ? 1
                                          : u
                                          ? P(u, e) - P(u, t)
                                          : 0
                                      : 4 & n
                                      ? -1
                                      : 1)
                              );
                          }
                        : function (e, t) {
                              if (e === t) return (l = !0), 0;
                              var n,
                                  r = 0,
                                  i = e.parentNode,
                                  o = t.parentNode,
                                  a = [e],
                                  s = [t];
                              if (!i || !o) return e == C ? -1 : t == C ? 1 : i ? -1 : o ? 1 : u ? P(u, e) - P(u, t) : 0;
                              if (i === o) return pe(e, t);
                              n = e;
                              while ((n = n.parentNode)) a.unshift(n);
                              n = t;
                              while ((n = n.parentNode)) s.unshift(n);
                              while (a[r] === s[r]) r++;
                              return r ? pe(a[r], s[r]) : a[r] == p ? -1 : s[r] == p ? 1 : 0;
                          })),
                C
            );
        }),
        (se.matches = function (e, t) {
            return se(e, null, null, t);
        }),
        (se.matchesSelector = function (e, t) {
            if ((T(e), d.matchesSelector && E && !N[t + " "] && (!s || !s.test(t)) && (!v || !v.test(t))))
                try {
                    var n = c.call(e, t);
                    if (n || d.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                } catch (e) {
                    N(t, !0);
                }
            return 0 < se(t, C, null, [e]).length;
        }),
        (se.contains = function (e, t) {
            return (e.ownerDocument || e) != C && T(e), y(e, t);
        }),
        (se.attr = function (e, t) {
            (e.ownerDocument || e) != C && T(e);
            var n = b.attrHandle[t.toLowerCase()],
                r = n && D.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
            return void 0 !== r ? r : d.attributes || !E ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
        }),
        (se.escape = function (e) {
            return (e + "").replace(re, ie);
        }),
        (se.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (se.uniqueSort = function (e) {
            var t,
                n = [],
                r = 0,
                i = 0;
            if (((l = !d.detectDuplicates), (u = !d.sortStable && e.slice(0)), e.sort(j), l)) {
                while ((t = e[i++])) t === e[i] && (r = n.push(i));
                while (r--) e.splice(n[r], 1);
            }
            return (u = null), e;
        }),
        (o = se.getText = function (e) {
            var t,
                n = "",
                r = 0,
                i = e.nodeType;
            if (i) {
                if (1 === i || 9 === i || 11 === i) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
                } else if (3 === i || 4 === i) return e.nodeValue;
            } else while ((t = e[r++])) n += o(t);
            return n;
        }),
        ((b = se.selectors = {
            cacheLength: 50,
            createPseudo: le,
            match: G,
            attrHandle: {},
            find: {},
            relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
            preFilter: {
                ATTR: function (e) {
                    return (e[1] = e[1].replace(te, ne)), (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function (e) {
                    return (
                        (e[1] = e[1].toLowerCase()),
                        "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && se.error(e[0]),
                        e
                    );
                },
                PSEUDO: function (e) {
                    var t,
                        n = !e[6] && e[2];
                    return G.CHILD.test(e[0])
                        ? null
                        : (e[3] ? (e[2] = e[4] || e[5] || "") : n && X.test(n) && (t = h(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                },
            },
            filter: {
                TAG: function (e) {
                    var t = e.replace(te, ne).toLowerCase();
                    return "*" === e
                        ? function () {
                              return !0;
                          }
                        : function (e) {
                              return e.nodeName && e.nodeName.toLowerCase() === t;
                          };
                },
                CLASS: function (e) {
                    var t = m[e + " "];
                    return (
                        t ||
                        ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                            m(e, function (e) {
                                return t.test(("string" == typeof e.className && e.className) || ("undefined" != typeof e.getAttribute && e.getAttribute("class")) || "");
                            }))
                    );
                },
                ATTR: function (n, r, i) {
                    return function (e) {
                        var t = se.attr(e, n);
                        return null == t
                            ? "!=" === r
                            : !r ||
                                  ((t += ""),
                                  "=" === r
                                      ? t === i
                                      : "!=" === r
                                      ? t !== i
                                      : "^=" === r
                                      ? i && 0 === t.indexOf(i)
                                      : "*=" === r
                                      ? i && -1 < t.indexOf(i)
                                      : "$=" === r
                                      ? i && t.slice(-i.length) === i
                                      : "~=" === r
                                      ? -1 < (" " + t.replace(B, " ") + " ").indexOf(i)
                                      : "|=" === r && (t === i || t.slice(0, i.length + 1) === i + "-"));
                    };
                },
                CHILD: function (h, e, t, g, v) {
                    var y = "nth" !== h.slice(0, 3),
                        m = "last" !== h.slice(-4),
                        x = "of-type" === e;
                    return 1 === g && 0 === v
                        ? function (e) {
                              return !!e.parentNode;
                          }
                        : function (e, t, n) {
                              var r,
                                  i,
                                  o,
                                  a,
                                  s,
                                  u,
                                  l = y !== m ? "nextSibling" : "previousSibling",
                                  c = e.parentNode,
                                  f = x && e.nodeName.toLowerCase(),
                                  p = !n && !x,
                                  d = !1;
                              if (c) {
                                  if (y) {
                                      while (l) {
                                          a = e;
                                          while ((a = a[l])) if (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) return !1;
                                          u = l = "only" === h && !u && "nextSibling";
                                      }
                                      return !0;
                                  }
                                  if (((u = [m ? c.firstChild : c.lastChild]), m && p)) {
                                      (d = (s = (r = (i = (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]) && r[2]), (a = s && c.childNodes[s]);
                                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                                          if (1 === a.nodeType && ++d && a === e) {
                                              i[h] = [k, s, d];
                                              break;
                                          }
                                  } else if ((p && (d = s = (r = (i = (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]), !1 === d))
                                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                                          if ((x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) && ++d && (p && ((i = (o = a[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] = [k, d]), a === e)) break;
                                  return (d -= v) === g || (d % g == 0 && 0 <= d / g);
                              }
                          };
                },
                PSEUDO: function (e, o) {
                    var t,
                        a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                    return a[S]
                        ? a(o)
                        : 1 < a.length
                        ? ((t = [e, e, "", o]),
                          b.setFilters.hasOwnProperty(e.toLowerCase())
                              ? le(function (e, t) {
                                    var n,
                                        r = a(e, o),
                                        i = r.length;
                                    while (i--) e[(n = P(e, r[i]))] = !(t[n] = r[i]);
                                })
                              : function (e) {
                                    return a(e, 0, t);
                                })
                        : a;
                },
            },
            pseudos: {
                not: le(function (e) {
                    var r = [],
                        i = [],
                        s = f(e.replace($, "$1"));
                    return s[S]
                        ? le(function (e, t, n, r) {
                              var i,
                                  o = s(e, null, r, []),
                                  a = e.length;
                              while (a--) (i = o[a]) && (e[a] = !(t[a] = i));
                          })
                        : function (e, t, n) {
                              return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
                          };
                }),
                has: le(function (t) {
                    return function (e) {
                        return 0 < se(t, e).length;
                    };
                }),
                contains: le(function (t) {
                    return (
                        (t = t.replace(te, ne)),
                        function (e) {
                            return -1 < (e.textContent || o(e)).indexOf(t);
                        }
                    );
                }),
                lang: le(function (n) {
                    return (
                        V.test(n || "") || se.error("unsupported lang: " + n),
                        (n = n.replace(te, ne).toLowerCase()),
                        function (e) {
                            var t;
                            do {
                                if ((t = E ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))) return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-");
                            } while ((e = e.parentNode) && 1 === e.nodeType);
                            return !1;
                        }
                    );
                }),
                target: function (e) {
                    var t = n.location && n.location.hash;
                    return t && t.slice(1) === e.id;
                },
                root: function (e) {
                    return e === a;
                },
                focus: function (e) {
                    return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: ge(!1),
                disabled: ge(!0),
                checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                },
                parent: function (e) {
                    return !b.pseudos.empty(e);
                },
                header: function (e) {
                    return J.test(e.nodeName);
                },
                input: function (e) {
                    return Q.test(e.nodeName);
                },
                button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: ve(function () {
                    return [0];
                }),
                last: ve(function (e, t) {
                    return [t - 1];
                }),
                eq: ve(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                }),
                even: ve(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                }),
                odd: ve(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                }),
                lt: ve(function (e, t, n) {
                    for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) e.push(r);
                    return e;
                }),
                gt: ve(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                    return e;
                }),
            },
        }).pseudos.nth = b.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            b.pseudos[e] = de(e);
        for (e in { submit: !0, reset: !0 }) b.pseudos[e] = he(e);
        function me() {}
        function xe(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
            return r;
        }
        function be(s, e, t) {
            var u = e.dir,
                l = e.next,
                c = l || u,
                f = t && "parentNode" === c,
                p = r++;
            return e.first
                ? function (e, t, n) {
                      while ((e = e[u])) if (1 === e.nodeType || f) return s(e, t, n);
                      return !1;
                  }
                : function (e, t, n) {
                      var r,
                          i,
                          o,
                          a = [k, p];
                      if (n) {
                          while ((e = e[u])) if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
                      } else
                          while ((e = e[u]))
                              if (1 === e.nodeType || f)
                                  if (((i = (o = e[S] || (e[S] = {}))[e.uniqueID] || (o[e.uniqueID] = {})), l && l === e.nodeName.toLowerCase())) e = e[u] || e;
                                  else {
                                      if ((r = i[c]) && r[0] === k && r[1] === p) return (a[2] = r[2]);
                                      if (((i[c] = a)[2] = s(e, t, n))) return !0;
                                  }
                      return !1;
                  };
        }
        function we(i) {
            return 1 < i.length
                ? function (e, t, n) {
                      var r = i.length;
                      while (r--) if (!i[r](e, t, n)) return !1;
                      return !0;
                  }
                : i[0];
        }
        function Te(e, t, n, r, i) {
            for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
            return a;
        }
        function Ce(d, h, g, v, y, e) {
            return (
                v && !v[S] && (v = Ce(v)),
                y && !y[S] && (y = Ce(y, e)),
                le(function (e, t, n, r) {
                    var i,
                        o,
                        a,
                        s = [],
                        u = [],
                        l = t.length,
                        c =
                            e ||
                            (function (e, t, n) {
                                for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                                return n;
                            })(h || "*", n.nodeType ? [n] : n, []),
                        f = !d || (!e && h) ? c : Te(c, s, d, n, r),
                        p = g ? (y || (e ? d : l || v) ? [] : t) : f;
                    if ((g && g(f, p, n, r), v)) {
                        (i = Te(p, u)), v(i, [], n, r), (o = i.length);
                        while (o--) (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
                    }
                    if (e) {
                        if (y || d) {
                            if (y) {
                                (i = []), (o = p.length);
                                while (o--) (a = p[o]) && i.push((f[o] = a));
                                y(null, (p = []), i, r);
                            }
                            o = p.length;
                            while (o--) (a = p[o]) && -1 < (i = y ? P(e, a) : s[o]) && (e[i] = !(t[i] = a));
                        }
                    } else (p = Te(p === t ? p.splice(l, p.length) : p)), y ? y(null, t, p, r) : H.apply(t, p);
                })
            );
        }
        function Ee(e) {
            for (
                var i,
                    t,
                    n,
                    r = e.length,
                    o = b.relative[e[0].type],
                    a = o || b.relative[" "],
                    s = o ? 1 : 0,
                    u = be(
                        function (e) {
                            return e === i;
                        },
                        a,
                        !0
                    ),
                    l = be(
                        function (e) {
                            return -1 < P(i, e);
                        },
                        a,
                        !0
                    ),
                    c = [
                        function (e, t, n) {
                            var r = (!o && (n || t !== w)) || ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
                            return (i = null), r;
                        },
                    ];
                s < r;
                s++
            )
                if ((t = b.relative[e[s].type])) c = [be(we(c), t)];
                else {
                    if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
                        for (n = ++s; n < r; n++) if (b.relative[e[n].type]) break;
                        return Ce(1 < s && we(c), 1 < s && xe(e.slice(0, s - 1).concat({ value: " " === e[s - 2].type ? "*" : "" })).replace($, "$1"), t, s < n && Ee(e.slice(s, n)), n < r && Ee((e = e.slice(n))), n < r && xe(e));
                    }
                    c.push(t);
                }
            return we(c);
        }
        return (
            (me.prototype = b.filters = b.pseudos),
            (b.setFilters = new me()),
            (h = se.tokenize = function (e, t) {
                var n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = x[e + " "];
                if (l) return t ? 0 : l.slice(0);
                (a = e), (s = []), (u = b.preFilter);
                while (a) {
                    for (o in ((n && !(r = _.exec(a))) || (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
                    (n = !1),
                    (r = z.exec(a)) && ((n = r.shift()), i.push({ value: n, type: r[0].replace($, " ") }), (a = a.slice(n.length))),
                    b.filter))
                        !(r = G[o].exec(a)) || (u[o] && !(r = u[o](r))) || ((n = r.shift()), i.push({ value: n, type: o, matches: r }), (a = a.slice(n.length)));
                    if (!n) break;
                }
                return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
            }),
            (f = se.compile = function (e, t) {
                var n,
                    v,
                    y,
                    m,
                    x,
                    r,
                    i = [],
                    o = [],
                    a = A[e + " "];
                if (!a) {
                    t || (t = h(e)), (n = t.length);
                    while (n--) (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
                    (a = A(
                        e,
                        ((v = o),
                        (m = 0 < (y = i).length),
                        (x = 0 < v.length),
                        (r = function (e, t, n, r, i) {
                            var o,
                                a,
                                s,
                                u = 0,
                                l = "0",
                                c = e && [],
                                f = [],
                                p = w,
                                d = e || (x && b.find.TAG("*", i)),
                                h = (k += null == p ? 1 : Math.random() || 0.1),
                                g = d.length;
                            for (i && (w = t == C || t || i); l !== g && null != (o = d[l]); l++) {
                                if (x && o) {
                                    (a = 0), t || o.ownerDocument == C || (T(o), (n = !E));
                                    while ((s = v[a++]))
                                        if (s(o, t || C, n)) {
                                            r.push(o);
                                            break;
                                        }
                                    i && (k = h);
                                }
                                m && ((o = !s && o) && u--, e && c.push(o));
                            }
                            if (((u += l), m && l !== u)) {
                                a = 0;
                                while ((s = y[a++])) s(c, f, t, n);
                                if (e) {
                                    if (0 < u) while (l--) c[l] || f[l] || (f[l] = q.call(r));
                                    f = Te(f);
                                }
                                H.apply(r, f), i && !e && 0 < f.length && 1 < u + y.length && se.uniqueSort(r);
                            }
                            return i && ((k = h), (w = p)), c;
                        }),
                        m ? le(r) : r)
                    )).selector = e;
                }
                return a;
            }),
            (g = se.select = function (e, t, n, r) {
                var i,
                    o,
                    a,
                    s,
                    u,
                    l = "function" == typeof e && e,
                    c = !r && h((e = l.selector || e));
                if (((n = n || []), 1 === c.length)) {
                    if (2 < (o = c[0] = c[0].slice(0)).length && "ID" === (a = o[0]).type && 9 === t.nodeType && E && b.relative[o[1].type]) {
                        if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0])) return n;
                        l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
                    }
                    i = G.needsContext.test(e) ? 0 : o.length;
                    while (i--) {
                        if (((a = o[i]), b.relative[(s = a.type)])) break;
                        if ((u = b.find[s]) && (r = u(a.matches[0].replace(te, ne), (ee.test(o[0].type) && ye(t.parentNode)) || t))) {
                            if ((o.splice(i, 1), !(e = r.length && xe(o)))) return H.apply(n, r), n;
                            break;
                        }
                    }
                }
                return (l || f(e, c))(r, t, !E, n, !t || (ee.test(e) && ye(t.parentNode)) || t), n;
            }),
            (d.sortStable = S.split("").sort(j).join("") === S),
            (d.detectDuplicates = !!l),
            T(),
            (d.sortDetached = ce(function (e) {
                return 1 & e.compareDocumentPosition(C.createElement("fieldset"));
            })),
            ce(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
                fe("type|href|height|width", function (e, t, n) {
                    if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
            (d.attributes &&
                ce(function (e) {
                    return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                })) ||
                fe("value", function (e, t, n) {
                    if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                }),
            ce(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
                fe(R, function (e, t, n) {
                    var r;
                    if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                }),
            se
        );
    })(C);
    (S.find = d), (S.expr = d.selectors), (S.expr[":"] = S.expr.pseudos), (S.uniqueSort = S.unique = d.uniqueSort), (S.text = d.getText), (S.isXMLDoc = d.isXML), (S.contains = d.contains), (S.escapeSelector = d.escape);
    var h = function (e, t, n) {
            var r = [],
                i = void 0 !== n;
            while ((e = e[t]) && 9 !== e.nodeType)
                if (1 === e.nodeType) {
                    if (i && S(e).is(n)) break;
                    r.push(e);
                }
            return r;
        },
        T = function (e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        },
        k = S.expr.match.needsContext;
    function A(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function j(e, n, r) {
        return m(n)
            ? S.grep(e, function (e, t) {
                  return !!n.call(e, t, e) !== r;
              })
            : n.nodeType
            ? S.grep(e, function (e) {
                  return (e === n) !== r;
              })
            : "string" != typeof n
            ? S.grep(e, function (e) {
                  return -1 < i.call(n, e) !== r;
              })
            : S.filter(n, e, r);
    }
    (S.filter = function (e, t, n) {
        var r = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === r.nodeType
                ? S.find.matchesSelector(r, e)
                    ? [r]
                    : []
                : S.find.matches(
                      e,
                      S.grep(t, function (e) {
                          return 1 === e.nodeType;
                      })
                  )
        );
    }),
        S.fn.extend({
            find: function (e) {
                var t,
                    n,
                    r = this.length,
                    i = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        S(e).filter(function () {
                            for (t = 0; t < r; t++) if (S.contains(i[t], this)) return !0;
                        })
                    );
                for (n = this.pushStack([]), t = 0; t < r; t++) S.find(e, i[t], n);
                return 1 < r ? S.uniqueSort(n) : n;
            },
            filter: function (e) {
                return this.pushStack(j(this, e || [], !1));
            },
            not: function (e) {
                return this.pushStack(j(this, e || [], !0));
            },
            is: function (e) {
                return !!j(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1).length;
            },
        });
    var D,
        q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((S.fn.init = function (e, t, n) {
        var r, i;
        if (!e) return this;
        if (((n = n || D), "string" == typeof e)) {
            if (!(r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : q.exec(e)) || (!r[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (r[1]) {
                if (((t = t instanceof S ? t[0] : t), S.merge(this, S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)), N.test(r[1]) && S.isPlainObject(t))) for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
            }
            return (i = E.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
        }
        return e.nodeType ? ((this[0] = e), (this.length = 1), this) : m(e) ? (void 0 !== n.ready ? n.ready(e) : e(S)) : S.makeArray(e, this);
    }).prototype = S.fn),
        (D = S(E));
    var L = /^(?:parents|prev(?:Until|All))/,
        H = { children: !0, contents: !0, next: !0, prev: !0 };
    function O(e, t) {
        while ((e = e[t]) && 1 !== e.nodeType);
        return e;
    }
    S.fn.extend({
        has: function (e) {
            var t = S(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
            });
        },
        closest: function (e, t) {
            var n,
                r = 0,
                i = this.length,
                o = [],
                a = "string" != typeof e && S(e);
            if (!k.test(e))
                for (; r < i; r++)
                    for (n = this[r]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && S.find.matchesSelector(n, e))) {
                            o.push(n);
                            break;
                        }
            return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
        },
        index: function (e) {
            return e ? ("string" == typeof e ? i.call(S(e), this[0]) : i.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function (e, t) {
            return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
        },
        addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        S.each(
            {
                parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                    return h(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                    return h(e, "parentNode", n);
                },
                next: function (e) {
                    return O(e, "nextSibling");
                },
                prev: function (e) {
                    return O(e, "previousSibling");
                },
                nextAll: function (e) {
                    return h(e, "nextSibling");
                },
                prevAll: function (e) {
                    return h(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                    return h(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                    return h(e, "previousSibling", n);
                },
                siblings: function (e) {
                    return T((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                    return T(e.firstChild);
                },
                contents: function (e) {
                    return null != e.contentDocument && r(e.contentDocument) ? e.contentDocument : (A(e, "template") && (e = e.content || e), S.merge([], e.childNodes));
                },
            },
            function (r, i) {
                S.fn[r] = function (e, t) {
                    var n = S.map(this, i, e);
                    return "Until" !== r.slice(-5) && (t = e), t && "string" == typeof t && (n = S.filter(t, n)), 1 < this.length && (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()), this.pushStack(n);
                };
            }
        );
    var P = /[^\x20\t\r\n\f]+/g;
    function R(e) {
        return e;
    }
    function M(e) {
        throw e;
    }
    function I(e, t, n, r) {
        var i;
        try {
            e && m((i = e.promise)) ? i.call(e).done(t).fail(n) : e && m((i = e.then)) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
        } catch (e) {
            n.apply(void 0, [e]);
        }
    }
    (S.Callbacks = function (r) {
        var e, n;
        r =
            "string" == typeof r
                ? ((e = r),
                  (n = {}),
                  S.each(e.match(P) || [], function (e, t) {
                      n[t] = !0;
                  }),
                  n)
                : S.extend({}, r);
        var i,
            t,
            o,
            a,
            s = [],
            u = [],
            l = -1,
            c = function () {
                for (a = a || r.once, o = i = !0; u.length; l = -1) {
                    t = u.shift();
                    while (++l < s.length) !1 === s[l].apply(t[0], t[1]) && r.stopOnFalse && ((l = s.length), (t = !1));
                }
                r.memory || (t = !1), (i = !1), a && (s = t ? [] : "");
            },
            f = {
                add: function () {
                    return (
                        s &&
                            (t && !i && ((l = s.length - 1), u.push(t)),
                            (function n(e) {
                                S.each(e, function (e, t) {
                                    m(t) ? (r.unique && f.has(t)) || s.push(t) : t && t.length && "string" !== w(t) && n(t);
                                });
                            })(arguments),
                            t && !i && c()),
                        this
                    );
                },
                remove: function () {
                    return (
                        S.each(arguments, function (e, t) {
                            var n;
                            while (-1 < (n = S.inArray(t, s, n))) s.splice(n, 1), n <= l && l--;
                        }),
                        this
                    );
                },
                has: function (e) {
                    return e ? -1 < S.inArray(e, s) : 0 < s.length;
                },
                empty: function () {
                    return s && (s = []), this;
                },
                disable: function () {
                    return (a = u = []), (s = t = ""), this;
                },
                disabled: function () {
                    return !s;
                },
                lock: function () {
                    return (a = u = []), t || i || (s = t = ""), this;
                },
                locked: function () {
                    return !!a;
                },
                fireWith: function (e, t) {
                    return a || ((t = [e, (t = t || []).slice ? t.slice() : t]), u.push(t), i || c()), this;
                },
                fire: function () {
                    return f.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!o;
                },
            };
        return f;
    }),
        S.extend({
            Deferred: function (e) {
                var o = [
                        ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
                        ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"],
                    ],
                    i = "pending",
                    a = {
                        state: function () {
                            return i;
                        },
                        always: function () {
                            return s.done(arguments).fail(arguments), this;
                        },
                        catch: function (e) {
                            return a.then(null, e);
                        },
                        pipe: function () {
                            var i = arguments;
                            return S.Deferred(function (r) {
                                S.each(o, function (e, t) {
                                    var n = m(i[t[4]]) && i[t[4]];
                                    s[t[1]](function () {
                                        var e = n && n.apply(this, arguments);
                                        e && m(e.promise) ? e.promise().progress(r.notify).done(r.resolve).fail(r.reject) : r[t[0] + "With"](this, n ? [e] : arguments);
                                    });
                                }),
                                    (i = null);
                            }).promise();
                        },
                        then: function (t, n, r) {
                            var u = 0;
                            function l(i, o, a, s) {
                                return function () {
                                    var n = this,
                                        r = arguments,
                                        e = function () {
                                            var e, t;
                                            if (!(i < u)) {
                                                if ((e = a.apply(n, r)) === o.promise()) throw new TypeError("Thenable self-resolution");
                                                (t = e && ("object" == typeof e || "function" == typeof e) && e.then),
                                                    m(t)
                                                        ? s
                                                            ? t.call(e, l(u, o, R, s), l(u, o, M, s))
                                                            : (u++, t.call(e, l(u, o, R, s), l(u, o, M, s), l(u, o, R, o.notifyWith)))
                                                        : (a !== R && ((n = void 0), (r = [e])), (s || o.resolveWith)(n, r));
                                            }
                                        },
                                        t = s
                                            ? e
                                            : function () {
                                                  try {
                                                      e();
                                                  } catch (e) {
                                                      S.Deferred.exceptionHook && S.Deferred.exceptionHook(e, t.stackTrace), u <= i + 1 && (a !== M && ((n = void 0), (r = [e])), o.rejectWith(n, r));
                                                  }
                                              };
                                    i ? t() : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()), C.setTimeout(t));
                                };
                            }
                            return S.Deferred(function (e) {
                                o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)), o[1][3].add(l(0, e, m(t) ? t : R)), o[2][3].add(l(0, e, m(n) ? n : M));
                            }).promise();
                        },
                        promise: function (e) {
                            return null != e ? S.extend(e, a) : a;
                        },
                    },
                    s = {};
                return (
                    S.each(o, function (e, t) {
                        var n = t[2],
                            r = t[5];
                        (a[t[1]] = n.add),
                            r &&
                                n.add(
                                    function () {
                                        i = r;
                                    },
                                    o[3 - e][2].disable,
                                    o[3 - e][3].disable,
                                    o[0][2].lock,
                                    o[0][3].lock
                                ),
                            n.add(t[3].fire),
                            (s[t[0]] = function () {
                                return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
                            }),
                            (s[t[0] + "With"] = n.fireWith);
                    }),
                    a.promise(s),
                    e && e.call(s, s),
                    s
                );
            },
            when: function (e) {
                var n = arguments.length,
                    t = n,
                    r = Array(t),
                    i = s.call(arguments),
                    o = S.Deferred(),
                    a = function (t) {
                        return function (e) {
                            (r[t] = this), (i[t] = 1 < arguments.length ? s.call(arguments) : e), --n || o.resolveWith(r, i);
                        };
                    };
                if (n <= 1 && (I(e, o.done(a(t)).resolve, o.reject, !n), "pending" === o.state() || m(i[t] && i[t].then))) return o.then();
                while (t--) I(i[t], a(t), o.reject);
                return o.promise();
            },
        });
    var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (S.Deferred.exceptionHook = function (e, t) {
        C.console && C.console.warn && e && W.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
    }),
        (S.readyException = function (e) {
            C.setTimeout(function () {
                throw e;
            });
        });
    var F = S.Deferred();
    function B() {
        E.removeEventListener("DOMContentLoaded", B), C.removeEventListener("load", B), S.ready();
    }
    (S.fn.ready = function (e) {
        return (
            F.then(e)["catch"](function (e) {
                S.readyException(e);
            }),
            this
        );
    }),
        S.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e) {
                (!0 === e ? --S.readyWait : S.isReady) || ((S.isReady = !0) !== e && 0 < --S.readyWait) || F.resolveWith(E, [S]);
            },
        }),
        (S.ready.then = F.then),
        "complete" === E.readyState || ("loading" !== E.readyState && !E.documentElement.doScroll) ? C.setTimeout(S.ready) : (E.addEventListener("DOMContentLoaded", B), C.addEventListener("load", B));
    var $ = function (e, t, n, r, i, o, a) {
            var s = 0,
                u = e.length,
                l = null == n;
            if ("object" === w(n)) for (s in ((i = !0), n)) $(e, t, s, n[s], !0, o, a);
            else if (
                void 0 !== r &&
                ((i = !0),
                m(r) || (a = !0),
                l &&
                    (a
                        ? (t.call(e, r), (t = null))
                        : ((l = t),
                          (t = function (e, t, n) {
                              return l.call(S(e), n);
                          }))),
                t)
            )
                for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
            return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
        },
        _ = /^-ms-/,
        z = /-([a-z])/g;
    function U(e, t) {
        return t.toUpperCase();
    }
    function X(e) {
        return e.replace(_, "ms-").replace(z, U);
    }
    var V = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
    function G() {
        this.expando = S.expando + G.uid++;
    }
    (G.uid = 1),
        (G.prototype = {
            cache: function (e) {
                var t = e[this.expando];
                return t || ((t = {}), V(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
            },
            set: function (e, t, n) {
                var r,
                    i = this.cache(e);
                if ("string" == typeof t) i[X(t)] = n;
                else for (r in t) i[X(r)] = t[r];
                return i;
            },
            get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
            },
            access: function (e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
                var n,
                    r = e[this.expando];
                if (void 0 !== r) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [t] : t.match(P) || []).length;
                        while (n--) delete r[t[n]];
                    }
                    (void 0 === t || S.isEmptyObject(r)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !S.isEmptyObject(t);
            },
        });
    var Y = new G(),
        Q = new G(),
        J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        K = /[A-Z]/g;
    function Z(e, t, n) {
        var r, i;
        if (void 0 === n && 1 === e.nodeType)
            if (((r = "data-" + t.replace(K, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
                try {
                    n = "true" === (i = n) || ("false" !== i && ("null" === i ? null : i === +i + "" ? +i : J.test(i) ? JSON.parse(i) : i));
                } catch (e) {}
                Q.set(e, t, n);
            } else n = void 0;
        return n;
    }
    S.extend({
        hasData: function (e) {
            return Q.hasData(e) || Y.hasData(e);
        },
        data: function (e, t, n) {
            return Q.access(e, t, n);
        },
        removeData: function (e, t) {
            Q.remove(e, t);
        },
        _data: function (e, t, n) {
            return Y.access(e, t, n);
        },
        _removeData: function (e, t) {
            Y.remove(e, t);
        },
    }),
        S.fn.extend({
            data: function (n, e) {
                var t,
                    r,
                    i,
                    o = this[0],
                    a = o && o.attributes;
                if (void 0 === n) {
                    if (this.length && ((i = Q.get(o)), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) {
                        t = a.length;
                        while (t--) a[t] && 0 === (r = a[t].name).indexOf("data-") && ((r = X(r.slice(5))), Z(o, r, i[r]));
                        Y.set(o, "hasDataAttrs", !0);
                    }
                    return i;
                }
                return "object" == typeof n
                    ? this.each(function () {
                          Q.set(this, n);
                      })
                    : $(
                          this,
                          function (e) {
                              var t;
                              if (o && void 0 === e) return void 0 !== (t = Q.get(o, n)) ? t : void 0 !== (t = Z(o, n)) ? t : void 0;
                              this.each(function () {
                                  Q.set(this, n, e);
                              });
                          },
                          null,
                          e,
                          1 < arguments.length,
                          null,
                          !0
                      );
            },
            removeData: function (e) {
                return this.each(function () {
                    Q.remove(this, e);
                });
            },
        }),
        S.extend({
            queue: function (e, t, n) {
                var r;
                if (e) return (t = (t || "fx") + "queue"), (r = Y.get(e, t)), n && (!r || Array.isArray(n) ? (r = Y.access(e, t, S.makeArray(n))) : r.push(n)), r || [];
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = S.queue(e, t),
                    r = n.length,
                    i = n.shift(),
                    o = S._queueHooks(e, t);
                "inprogress" === i && ((i = n.shift()), r--),
                    i &&
                        ("fx" === t && n.unshift("inprogress"),
                        delete o.stop,
                        i.call(
                            e,
                            function () {
                                S.dequeue(e, t);
                            },
                            o
                        )),
                    !r && o && o.empty.fire();
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                    Y.get(e, n) ||
                    Y.access(e, n, {
                        empty: S.Callbacks("once memory").add(function () {
                            Y.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        S.fn.extend({
            queue: function (t, n) {
                var e = 2;
                return (
                    "string" != typeof t && ((n = t), (t = "fx"), e--),
                    arguments.length < e
                        ? S.queue(this[0], t)
                        : void 0 === n
                        ? this
                        : this.each(function () {
                              var e = S.queue(this, t, n);
                              S._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t);
                          })
                );
            },
            dequeue: function (e) {
                return this.each(function () {
                    S.dequeue(this, e);
                });
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
                var n,
                    r = 1,
                    i = S.Deferred(),
                    o = this,
                    a = this.length,
                    s = function () {
                        --r || i.resolveWith(o, [o]);
                    };
                "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
                while (a--) (n = Y.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                return s(), i.promise(t);
            },
        });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        re = E.documentElement,
        ie = function (e) {
            return S.contains(e.ownerDocument, e);
        },
        oe = { composed: !0 };
    re.getRootNode &&
        (ie = function (e) {
            return S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument;
        });
    var ae = function (e, t) {
        return "none" === (e = t || e).style.display || ("" === e.style.display && ie(e) && "none" === S.css(e, "display"));
    };
    function se(e, t, n, r) {
        var i,
            o,
            a = 20,
            s = r
                ? function () {
                      return r.cur();
                  }
                : function () {
                      return S.css(e, t, "");
                  },
            u = s(),
            l = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
            c = e.nodeType && (S.cssNumber[t] || ("px" !== l && +u)) && te.exec(S.css(e, t));
        if (c && c[3] !== l) {
            (u /= 2), (l = l || c[3]), (c = +u || 1);
            while (a--) S.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o);
            (c *= 2), S.style(e, t, c + l), (n = n || []);
        }
        return n && ((c = +c || +u || 0), (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), r && ((r.unit = l), (r.start = c), (r.end = i))), i;
    }
    var ue = {};
    function le(e, t) {
        for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)
            (r = e[c]).style &&
                ((n = r.style.display),
                t
                    ? ("none" === n && ((l[c] = Y.get(r, "display") || null), l[c] || (r.style.display = "")),
                      "" === r.style.display &&
                          ae(r) &&
                          (l[c] =
                              ((u = a = o = void 0),
                              (a = (i = r).ownerDocument),
                              (s = i.nodeName),
                              (u = ue[s]) || ((o = a.body.appendChild(a.createElement(s))), (u = S.css(o, "display")), o.parentNode.removeChild(o), "none" === u && (u = "block"), (ue[s] = u)))))
                    : "none" !== n && ((l[c] = "none"), Y.set(r, "display", n)));
        for (c = 0; c < f; c++) null != l[c] && (e[c].style.display = l[c]);
        return e;
    }
    S.fn.extend({
        show: function () {
            return le(this, !0);
        },
        hide: function () {
            return le(this);
        },
        toggle: function (e) {
            return "boolean" == typeof e
                ? e
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      ae(this) ? S(this).show() : S(this).hide();
                  });
        },
    });
    var ce,
        fe,
        pe = /^(?:checkbox|radio)$/i,
        de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i;
    (ce = E.createDocumentFragment().appendChild(E.createElement("div"))),
        (fe = E.createElement("input")).setAttribute("type", "radio"),
        fe.setAttribute("checked", "checked"),
        fe.setAttribute("name", "t"),
        ce.appendChild(fe),
        (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (ce.innerHTML = "<textarea>x</textarea>"),
        (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
        (ce.innerHTML = "<option></option>"),
        (y.option = !!ce.lastChild);
    var ge = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
    function ve(e, t) {
        var n;
        return (n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && A(e, t)) ? S.merge([e], n) : n;
    }
    function ye(e, t) {
        for (var n = 0, r = e.length; n < r; n++) Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
    }
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead), (ge.th = ge.td), y.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]);
    var me = /<|&#?\w+;/;
    function xe(e, t, n, r, i) {
        for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)
            if ((o = e[d]) || 0 === o)
                if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o);
                else if (me.test(o)) {
                    (a = a || f.appendChild(t.createElement("div"))), (s = (de.exec(o) || ["", ""])[1].toLowerCase()), (u = ge[s] || ge._default), (a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2]), (c = u[0]);
                    while (c--) a = a.lastChild;
                    S.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
                } else p.push(t.createTextNode(o));
        (f.textContent = ""), (d = 0);
        while ((o = p[d++]))
            if (r && -1 < S.inArray(o, r)) i && i.push(o);
            else if (((l = ie(o)), (a = ve(f.appendChild(o), "script")), l && ye(a), n)) {
                c = 0;
                while ((o = a[c++])) he.test(o.type || "") && n.push(o);
            }
        return f;
    }
    var be = /^([^.]*)(?:\.(.+)|)/;
    function we() {
        return !0;
    }
    function Te() {
        return !1;
    }
    function Ce(e, t) {
        return (
            (e ===
                (function () {
                    try {
                        return E.activeElement;
                    } catch (e) {}
                })()) ==
            ("focus" === t)
        );
    }
    function Ee(e, t, n, r, i, o) {
        var a, s;
        if ("object" == typeof t) {
            for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) Ee(e, s, n, r, t[s], o);
            return e;
        }
        if ((null == r && null == i ? ((i = n), (r = n = void 0)) : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))), !1 === i)) i = Te;
        else if (!i) return e;
        return (
            1 === o &&
                ((a = i),
                ((i = function (e) {
                    return S().off(e), a.apply(this, arguments);
                }).guid = a.guid || (a.guid = S.guid++))),
            e.each(function () {
                S.event.add(this, t, i, r, n);
            })
        );
    }
    function Se(e, i, o) {
        o
            ? (Y.set(e, i, !1),
              S.event.add(e, i, {
                  namespace: !1,
                  handler: function (e) {
                      var t,
                          n,
                          r = Y.get(this, i);
                      if (1 & e.isTrigger && this[i]) {
                          if (r.length) (S.event.special[i] || {}).delegateType && e.stopPropagation();
                          else if (((r = s.call(arguments)), Y.set(this, i, r), (t = o(this, i)), this[i](), r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : (n = {}), r !== n))
                              return e.stopImmediatePropagation(), e.preventDefault(), n && n.value;
                      } else r.length && (Y.set(this, i, { value: S.event.trigger(S.extend(r[0], S.Event.prototype), r.slice(1), this) }), e.stopImmediatePropagation());
                  },
              }))
            : void 0 === Y.get(e, i) && S.event.add(e, i, we);
    }
    (S.event = {
        global: {},
        add: function (t, e, n, r, i) {
            var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.get(t);
            if (V(t)) {
                n.handler && ((n = (o = n).handler), (i = o.selector)),
                    i && S.find.matchesSelector(re, i),
                    n.guid || (n.guid = S.guid++),
                    (u = v.events) || (u = v.events = Object.create(null)),
                    (a = v.handle) ||
                        (a = v.handle = function (e) {
                            return "undefined" != typeof S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0;
                        }),
                    (l = (e = (e || "").match(P) || [""]).length);
                while (l--)
                    (d = g = (s = be.exec(e[l]) || [])[1]),
                        (h = (s[2] || "").split(".").sort()),
                        d &&
                            ((f = S.event.special[d] || {}),
                            (d = (i ? f.delegateType : f.bindType) || d),
                            (f = S.event.special[d] || {}),
                            (c = S.extend({ type: d, origType: g, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && S.expr.match.needsContext.test(i), namespace: h.join(".") }, o)),
                            (p = u[d]) || (((p = u[d] = []).delegateCount = 0), (f.setup && !1 !== f.setup.call(t, r, h, a)) || (t.addEventListener && t.addEventListener(d, a))),
                            f.add && (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
                            i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                            (S.event.global[d] = !0));
            }
        },
        remove: function (e, t, n, r, i) {
            var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.hasData(e) && Y.get(e);
            if (v && (u = v.events)) {
                l = (t = (t || "").match(P) || [""]).length;
                while (l--)
                    if (((d = g = (s = be.exec(t[l]) || [])[1]), (h = (s[2] || "").split(".").sort()), d)) {
                        (f = S.event.special[d] || {}), (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []), (s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")), (a = o = p.length);
                        while (o--)
                            (c = p[o]),
                                (!i && g !== c.origType) ||
                                    (n && n.guid !== c.guid) ||
                                    (s && !s.test(c.namespace)) ||
                                    (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                                    (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                        a && !p.length && ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) || S.removeEvent(e, d, v.handle), delete u[d]);
                    } else for (d in u) S.event.remove(e, d + t[l], n, r, !0);
                S.isEmptyObject(u) && Y.remove(e, "handle events");
            }
        },
        dispatch: function (e) {
            var t,
                n,
                r,
                i,
                o,
                a,
                s = new Array(arguments.length),
                u = S.event.fix(e),
                l = (Y.get(this, "events") || Object.create(null))[u.type] || [],
                c = S.event.special[u.type] || {};
            for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
            if (((u.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, u))) {
                (a = S.event.handlers.call(this, u, l)), (t = 0);
                while ((i = a[t++]) && !u.isPropagationStopped()) {
                    (u.currentTarget = i.elem), (n = 0);
                    while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped())
                        (u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace)) ||
                            ((u.handleObj = o), (u.data = o.data), void 0 !== (r = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (u.result = r) && (u.preventDefault(), u.stopPropagation()));
                }
                return c.postDispatch && c.postDispatch.call(this, u), u.result;
            }
        },
        handlers: function (e, t) {
            var n,
                r,
                i,
                o,
                a,
                s = [],
                u = t.delegateCount,
                l = e.target;
            if (u && l.nodeType && !("click" === e.type && 1 <= e.button))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                        for (o = [], a = {}, n = 0; n < u; n++) void 0 === a[(i = (r = t[n]).selector + " ")] && (a[i] = r.needsContext ? -1 < S(i, this).index(l) : S.find(i, this, null, [l]).length), a[i] && o.push(r);
                        o.length && s.push({ elem: l, handlers: o });
                    }
            return (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s;
        },
        addProp: function (t, e) {
            Object.defineProperty(S.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: m(e)
                    ? function () {
                          if (this.originalEvent) return e(this.originalEvent);
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[t];
                      },
                set: function (e) {
                    Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                },
            });
        },
        fix: function (e) {
            return e[S.expando] ? e : new S.Event(e);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && A(t, "input") && Se(t, "click", we), !1;
                },
                trigger: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && A(t, "input") && Se(t, "click"), !0;
                },
                _default: function (e) {
                    var t = e.target;
                    return (pe.test(t.type) && t.click && A(t, "input") && Y.get(t, "click")) || A(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (S.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (S.Event = function (e, t) {
            if (!(this instanceof S.Event)) return new S.Event(e, t);
            e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? we : Te),
                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && S.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[S.expando] = !0);
        }),
        (S.Event.prototype = {
            constructor: S.Event,
            isDefaultPrevented: Te,
            isPropagationStopped: Te,
            isImmediatePropagationStopped: Te,
            isSimulated: !1,
            preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = we), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = we), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = we), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
            },
        }),
        S.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
            },
            S.event.addProp
        ),
        S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            S.event.special[e] = {
                setup: function () {
                    return Se(this, e, Ce), !1;
                },
                trigger: function () {
                    return Se(this, e), !0;
                },
                _default: function () {
                    return !0;
                },
                delegateType: t,
            };
        }),
        S.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, i) {
            S.event.special[e] = {
                delegateType: i,
                bindType: i,
                handle: function (e) {
                    var t,
                        n = e.relatedTarget,
                        r = e.handleObj;
                    return (n && (n === this || S.contains(this, n))) || ((e.type = r.origType), (t = r.handler.apply(this, arguments)), (e.type = i)), t;
                },
            };
        }),
        S.fn.extend({
            on: function (e, t, n, r) {
                return Ee(this, e, t, n, r);
            },
            one: function (e, t, n, r) {
                return Ee(this, e, t, n, r, 1);
            },
            off: function (e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj) return (r = e.handleObj), S(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                if ("object" == typeof e) {
                    for (i in e) this.off(i, t, e[i]);
                    return this;
                }
                return (
                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                    !1 === n && (n = Te),
                    this.each(function () {
                        S.event.remove(this, e, n, t);
                    })
                );
            },
        });
    var ke = /<script|<style|<link/i,
        Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Ne = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function je(e, t) {
        return (A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0]) || e;
    }
    function De(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function qe(e) {
        return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
    }
    function Le(e, t) {
        var n, r, i, o, a, s;
        if (1 === t.nodeType) {
            if (Y.hasData(e) && (s = Y.get(e).events)) for (i in (Y.remove(t, "handle events"), s)) for (n = 0, r = s[i].length; n < r; n++) S.event.add(t, i, s[i][n]);
            Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
        }
    }
    function He(n, r, i, o) {
        r = g(r);
        var e,
            t,
            a,
            s,
            u,
            l,
            c = 0,
            f = n.length,
            p = f - 1,
            d = r[0],
            h = m(d);
        if (h || (1 < f && "string" == typeof d && !y.checkClone && Ae.test(d)))
            return n.each(function (e) {
                var t = n.eq(e);
                h && (r[0] = d.call(this, e, t.html())), He(t, r, i, o);
            });
        if (f && ((t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild), 1 === e.childNodes.length && (e = t), t || o)) {
            for (s = (a = S.map(ve(e, "script"), De)).length; c < f; c++) (u = e), c !== p && ((u = S.clone(u, !0, !0)), s && S.merge(a, ve(u, "script"))), i.call(n[c], u, c);
            if (s)
                for (l = a[a.length - 1].ownerDocument, S.map(a, qe), c = 0; c < s; c++)
                    (u = a[c]),
                        he.test(u.type || "") &&
                            !Y.access(u, "globalEval") &&
                            S.contains(l, u) &&
                            (u.src && "module" !== (u.type || "").toLowerCase() ? S._evalUrl && !u.noModule && S._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }, l) : b(u.textContent.replace(Ne, ""), u, l));
        }
        return n;
    }
    function Oe(e, t, n) {
        for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++) n || 1 !== r.nodeType || S.cleanData(ve(r)), r.parentNode && (n && ie(r) && ye(ve(r, "script")), r.parentNode.removeChild(r));
        return e;
    }
    S.extend({
        htmlPrefilter: function (e) {
            return e;
        },
        clone: function (e, t, n) {
            var r,
                i,
                o,
                a,
                s,
                u,
                l,
                c = e.cloneNode(!0),
                f = ie(e);
            if (!(y.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || S.isXMLDoc(e)))
                for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++)
                    (s = o[r]), (u = a[r]), void 0, "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type) ? (u.checked = s.checked) : ("input" !== l && "textarea" !== l) || (u.defaultValue = s.defaultValue);
            if (t)
                if (n) for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++) Le(o[r], a[r]);
                else Le(e, c);
            return 0 < (a = ve(c, "script")).length && ye(a, !f && ve(e, "script")), c;
        },
        cleanData: function (e) {
            for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (V(n)) {
                    if ((t = n[Y.expando])) {
                        if (t.events) for (r in t.events) i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
                        n[Y.expando] = void 0;
                    }
                    n[Q.expando] && (n[Q.expando] = void 0);
                }
        },
    }),
        S.fn.extend({
            detach: function (e) {
                return Oe(this, e, !0);
            },
            remove: function (e) {
                return Oe(this, e);
            },
            text: function (e) {
                return $(
                    this,
                    function (e) {
                        return void 0 === e
                            ? S.text(this)
                            : this.empty().each(function () {
                                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                              });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function () {
                return He(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || je(this, e).appendChild(e);
                });
            },
            prepend: function () {
                return He(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = je(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function () {
                return He(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function () {
                return He(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (S.cleanData(ve(e, !1)), (e.textContent = ""));
                return this;
            },
            clone: function (e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return S.clone(this, e, t);
                    })
                );
            },
            html: function (e) {
                return $(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            r = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !ke.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = S.htmlPrefilter(e);
                            try {
                                for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (S.cleanData(ve(t, !1)), (t.innerHTML = e));
                                t = 0;
                            } catch (e) {}
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function () {
                var n = [];
                return He(
                    this,
                    arguments,
                    function (e) {
                        var t = this.parentNode;
                        S.inArray(this, n) < 0 && (S.cleanData(ve(this)), t && t.replaceChild(e, this));
                    },
                    n
                );
            },
        }),
        S.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, a) {
            S.fn[e] = function (e) {
                for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++) (t = o === i ? this : this.clone(!0)), S(r[o])[a](t), u.apply(n, t.get());
                return this.pushStack(n);
            };
        });
    var Pe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        Re = function (e) {
            var t = e.ownerDocument.defaultView;
            return (t && t.opener) || (t = C), t.getComputedStyle(e);
        },
        Me = function (e, t, n) {
            var r,
                i,
                o = {};
            for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
            for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
            return r;
        },
        Ie = new RegExp(ne.join("|"), "i");
    function We(e, t, n) {
        var r,
            i,
            o,
            a,
            s = e.style;
        return (
            (n = n || Re(e)) &&
                ("" !== (a = n.getPropertyValue(t) || n[t]) || ie(e) || (a = S.style(e, t)),
                !y.pixelBoxStyles() && Pe.test(a) && Ie.test(t) && ((r = s.width), (i = s.minWidth), (o = s.maxWidth), (s.minWidth = s.maxWidth = s.width = a), (a = n.width), (s.width = r), (s.minWidth = i), (s.maxWidth = o))),
            void 0 !== a ? a + "" : a
        );
    }
    function Fe(e, t) {
        return {
            get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
            },
        };
    }
    !(function () {
        function e() {
            if (l) {
                (u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                    (l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                    re.appendChild(u).appendChild(l);
                var e = C.getComputedStyle(l);
                (n = "1%" !== e.top),
                    (s = 12 === t(e.marginLeft)),
                    (l.style.right = "60%"),
                    (o = 36 === t(e.right)),
                    (r = 36 === t(e.width)),
                    (l.style.position = "absolute"),
                    (i = 12 === t(l.offsetWidth / 3)),
                    re.removeChild(u),
                    (l = null);
            }
        }
        function t(e) {
            return Math.round(parseFloat(e));
        }
        var n,
            r,
            i,
            o,
            a,
            s,
            u = E.createElement("div"),
            l = E.createElement("div");
        l.style &&
            ((l.style.backgroundClip = "content-box"),
            (l.cloneNode(!0).style.backgroundClip = ""),
            (y.clearCloneStyle = "content-box" === l.style.backgroundClip),
            S.extend(y, {
                boxSizingReliable: function () {
                    return e(), r;
                },
                pixelBoxStyles: function () {
                    return e(), o;
                },
                pixelPosition: function () {
                    return e(), n;
                },
                reliableMarginLeft: function () {
                    return e(), s;
                },
                scrollboxSize: function () {
                    return e(), i;
                },
                reliableTrDimensions: function () {
                    var e, t, n, r;
                    return (
                        null == a &&
                            ((e = E.createElement("table")),
                            (t = E.createElement("tr")),
                            (n = E.createElement("div")),
                            (e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate"),
                            (t.style.cssText = "border:1px solid"),
                            (t.style.height = "1px"),
                            (n.style.height = "9px"),
                            (n.style.display = "block"),
                            re.appendChild(e).appendChild(t).appendChild(n),
                            (r = C.getComputedStyle(t)),
                            (a = parseInt(r.height, 10) + parseInt(r.borderTopWidth, 10) + parseInt(r.borderBottomWidth, 10) === t.offsetHeight),
                            re.removeChild(e)),
                        a
                    );
                },
            }));
    })();
    var Be = ["Webkit", "Moz", "ms"],
        $e = E.createElement("div").style,
        _e = {};
    function ze(e) {
        var t = S.cssProps[e] || _e[e];
        return (
            t ||
            (e in $e
                ? e
                : (_e[e] =
                      (function (e) {
                          var t = e[0].toUpperCase() + e.slice(1),
                              n = Be.length;
                          while (n--) if ((e = Be[n] + t) in $e) return e;
                      })(e) || e))
        );
    }
    var Ue = /^(none|table(?!-c[ea]).+)/,
        Xe = /^--/,
        Ve = { position: "absolute", visibility: "hidden", display: "block" },
        Ge = { letterSpacing: "0", fontWeight: "400" };
    function Ye(e, t, n) {
        var r = te.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
    }
    function Qe(e, t, n, r, i, o) {
        var a = "width" === t ? 1 : 0,
            s = 0,
            u = 0;
        if (n === (r ? "border" : "content")) return 0;
        for (; a < 4; a += 2)
            "margin" === n && (u += S.css(e, n + ne[a], !0, i)),
                r
                    ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)), "margin" !== n && (u -= S.css(e, "border" + ne[a] + "Width", !0, i)))
                    : ((u += S.css(e, "padding" + ne[a], !0, i)), "padding" !== n ? (u += S.css(e, "border" + ne[a] + "Width", !0, i)) : (s += S.css(e, "border" + ne[a] + "Width", !0, i)));
        return !r && 0 <= o && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)) || 0), u;
    }
    function Je(e, t, n) {
        var r = Re(e),
            i = (!y.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, r),
            o = i,
            a = We(e, t, r),
            s = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Pe.test(a)) {
            if (!n) return a;
            a = "auto";
        }
        return (
            ((!y.boxSizingReliable() && i) || (!y.reliableTrDimensions() && A(e, "tr")) || "auto" === a || (!parseFloat(a) && "inline" === S.css(e, "display", !1, r))) &&
                e.getClientRects().length &&
                ((i = "border-box" === S.css(e, "boxSizing", !1, r)), (o = s in e) && (a = e[s])),
            (a = parseFloat(a) || 0) + Qe(e, t, n || (i ? "border" : "content"), o, r, a) + "px"
        );
    }
    function Ke(e, t, n, r, i) {
        return new Ke.prototype.init(e, t, n, r, i);
    }
    S.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = We(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                    o,
                    a,
                    s = X(t),
                    u = Xe.test(t),
                    l = e.style;
                if ((u || (t = ze(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n)) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                "string" === (o = typeof n) && (i = te.exec(n)) && i[1] && ((n = se(e, t, i)), (o = "number")),
                    null != n &&
                        n == n &&
                        ("number" !== o || u || (n += (i && i[3]) || (S.cssNumber[s] ? "" : "px")),
                        y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                        (a && "set" in a && void 0 === (n = a.set(e, n, r))) || (u ? l.setProperty(t, n) : (l[t] = n)));
            }
        },
        css: function (e, t, n, r) {
            var i,
                o,
                a,
                s = X(t);
            return (
                Xe.test(t) || (t = ze(s)),
                (a = S.cssHooks[t] || S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)),
                void 0 === i && (i = We(e, t, r)),
                "normal" === i && t in Ge && (i = Ge[t]),
                "" === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
            );
        },
    }),
        S.each(["height", "width"], function (e, u) {
            S.cssHooks[u] = {
                get: function (e, t, n) {
                    if (t)
                        return !Ue.test(S.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                            ? Je(e, u, n)
                            : Me(e, Ve, function () {
                                  return Je(e, u, n);
                              });
                },
                set: function (e, t, n) {
                    var r,
                        i = Re(e),
                        o = !y.scrollboxSize() && "absolute" === i.position,
                        a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i),
                        s = n ? Qe(e, u, n, a, i) : 0;
                    return (
                        a && o && (s -= Math.ceil(e["offset" + u[0].toUpperCase() + u.slice(1)] - parseFloat(i[u]) - Qe(e, u, "border", !1, i) - 0.5)),
                        s && (r = te.exec(t)) && "px" !== (r[3] || "px") && ((e.style[u] = t), (t = S.css(e, u))),
                        Ye(0, t, s)
                    );
                },
            };
        }),
        (S.cssHooks.marginLeft = Fe(y.reliableMarginLeft, function (e, t) {
            if (t)
                return (
                    (parseFloat(We(e, "marginLeft")) ||
                        e.getBoundingClientRect().left -
                            Me(e, { marginLeft: 0 }, function () {
                                return e.getBoundingClientRect().left;
                            })) + "px"
                );
        })),
        S.each({ margin: "", padding: "", border: "Width" }, function (i, o) {
            (S.cssHooks[i + o] = {
                expand: function (e) {
                    for (var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
                    return n;
                },
            }),
                "margin" !== i && (S.cssHooks[i + o].set = Ye);
        }),
        S.fn.extend({
            css: function (e, t) {
                return $(
                    this,
                    function (e, t, n) {
                        var r,
                            i,
                            o = {},
                            a = 0;
                        if (Array.isArray(t)) {
                            for (r = Re(e), i = t.length; a < i; a++) o[t[a]] = S.css(e, t[a], !1, r);
                            return o;
                        }
                        return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                    },
                    e,
                    t,
                    1 < arguments.length
                );
            },
        }),
        (((S.Tween = Ke).prototype = {
            constructor: Ke,
            init: function (e, t, n, r, i, o) {
                (this.elem = e), (this.prop = n), (this.easing = i || S.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = r), (this.unit = o || (S.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
                var e = Ke.propHooks[this.prop];
                return e && e.get ? e.get(this) : Ke.propHooks._default.get(this);
            },
            run: function (e) {
                var t,
                    n = Ke.propHooks[this.prop];
                return (
                    this.options.duration ? (this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : Ke.propHooks._default.set(this),
                    this
                );
            },
        }).init.prototype = Ke.prototype),
        ((Ke.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                },
                set: function (e) {
                    S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!S.cssHooks[e.prop] && null == e.elem.style[ze(e.prop)]) ? (e.elem[e.prop] = e.now) : S.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }).scrollTop = Ke.propHooks.scrollLeft = {
            set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
        }),
        (S.easing = {
            linear: function (e) {
                return e;
            },
            swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (S.fx = Ke.prototype.init),
        (S.fx.step = {});
    var Ze,
        et,
        tt,
        nt,
        rt = /^(?:toggle|show|hide)$/,
        it = /queueHooks$/;
    function ot() {
        et && (!1 === E.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(ot) : C.setTimeout(ot, S.fx.interval), S.fx.tick());
    }
    function at() {
        return (
            C.setTimeout(function () {
                Ze = void 0;
            }),
            (Ze = Date.now())
        );
    }
    function st(e, t) {
        var n,
            r = 0,
            i = { height: e };
        for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = ne[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i;
    }
    function ut(e, t, n) {
        for (var r, i = (lt.tweeners[t] || []).concat(lt.tweeners["*"]), o = 0, a = i.length; o < a; o++) if ((r = i[o].call(n, t, e))) return r;
    }
    function lt(o, e, t) {
        var n,
            a,
            r = 0,
            i = lt.prefilters.length,
            s = S.Deferred().always(function () {
                delete u.elem;
            }),
            u = function () {
                if (a) return !1;
                for (var e = Ze || at(), t = Math.max(0, l.startTime + l.duration - e), n = 1 - (t / l.duration || 0), r = 0, i = l.tweens.length; r < i; r++) l.tweens[r].run(n);
                return s.notifyWith(o, [l, n, t]), n < 1 && i ? t : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1);
            },
            l = s.promise({
                elem: o,
                props: S.extend({}, e),
                opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: Ze || at(),
                duration: t.duration,
                tweens: [],
                createTween: function (e, t) {
                    var n = S.Tween(o, l.opts, e, t, l.opts.specialEasing[e] || l.opts.easing);
                    return l.tweens.push(n), n;
                },
                stop: function (e) {
                    var t = 0,
                        n = e ? l.tweens.length : 0;
                    if (a) return this;
                    for (a = !0; t < n; t++) l.tweens[t].run(1);
                    return e ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e])) : s.rejectWith(o, [l, e]), this;
                },
            }),
            c = l.props;
        for (
            !(function (e, t) {
                var n, r, i, o, a;
                for (n in e)
                    if (((i = t[(r = X(n))]), (o = e[n]), Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])), n !== r && ((e[r] = o), delete e[n]), (a = S.cssHooks[r]) && ("expand" in a)))
                        for (n in ((o = a.expand(o)), delete e[r], o)) (n in e) || ((e[n] = o[n]), (t[n] = i));
                    else t[r] = i;
            })(c, l.opts.specialEasing);
            r < i;
            r++
        )
            if ((n = lt.prefilters[r].call(l, o, c, l.opts))) return m(n.stop) && (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n;
        return (
            S.map(c, ut, l),
            m(l.opts.start) && l.opts.start.call(o, l),
            l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
            S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })),
            l
        );
    }
    (S.Animation = S.extend(lt, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return se(n.elem, e, te.exec(t), n), n;
                },
            ],
        },
        tweener: function (e, t) {
            m(e) ? ((t = e), (e = ["*"])) : (e = e.match(P));
            for (var n, r = 0, i = e.length; r < i; r++) (n = e[r]), (lt.tweeners[n] = lt.tweeners[n] || []), lt.tweeners[n].unshift(t);
        },
        prefilters: [
            function (e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l,
                    c,
                    f = "width" in t || "height" in t,
                    p = this,
                    d = {},
                    h = e.style,
                    g = e.nodeType && ae(e),
                    v = Y.get(e, "fxshow");
                for (r in (n.queue ||
                    (null == (a = S._queueHooks(e, "fx")).unqueued &&
                        ((a.unqueued = 0),
                        (s = a.empty.fire),
                        (a.empty.fire = function () {
                            a.unqueued || s();
                        })),
                    a.unqueued++,
                    p.always(function () {
                        p.always(function () {
                            a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
                        });
                    })),
                t))
                    if (((i = t[r]), rt.test(i))) {
                        if ((delete t[r], (o = o || "toggle" === i), i === (g ? "hide" : "show"))) {
                            if ("show" !== i || !v || void 0 === v[r]) continue;
                            g = !0;
                        }
                        d[r] = (v && v[r]) || S.style(e, r);
                    }
                if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
                    for (r in (f &&
                        1 === e.nodeType &&
                        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                        null == (l = v && v.display) && (l = Y.get(e, "display")),
                        "none" === (c = S.css(e, "display")) && (l ? (c = l) : (le([e], !0), (l = e.style.display || l), (c = S.css(e, "display")), le([e]))),
                        ("inline" === c || ("inline-block" === c && null != l)) &&
                            "none" === S.css(e, "float") &&
                            (u ||
                                (p.done(function () {
                                    h.display = l;
                                }),
                                null == l && ((c = h.display), (l = "none" === c ? "" : c))),
                            (h.display = "inline-block"))),
                    n.overflow &&
                        ((h.overflow = "hidden"),
                        p.always(function () {
                            (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                        })),
                    (u = !1),
                    d))
                        u ||
                            (v ? "hidden" in v && (g = v.hidden) : (v = Y.access(e, "fxshow", { display: l })),
                            o && (v.hidden = !g),
                            g && le([e], !0),
                            p.done(function () {
                                for (r in (g || le([e]), Y.remove(e, "fxshow"), d)) S.style(e, r, d[r]);
                            })),
                            (u = ut(g ? v[r] : 0, r, p)),
                            r in v || ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
            },
        ],
        prefilter: function (e, t) {
            t ? lt.prefilters.unshift(e) : lt.prefilters.push(e);
        },
    })),
        (S.speed = function (e, t, n) {
            var r = e && "object" == typeof e ? S.extend({}, e) : { complete: n || (!n && t) || (m(e) && e), duration: e, easing: (n && t) || (t && !m(t) && t) };
            return (
                S.fx.off ? (r.duration = 0) : "number" != typeof r.duration && (r.duration in S.fx.speeds ? (r.duration = S.fx.speeds[r.duration]) : (r.duration = S.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                (r.old = r.complete),
                (r.complete = function () {
                    m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
                }),
                r
            );
        }),
        S.fn.extend({
            fadeTo: function (e, t, n, r) {
                return this.filter(ae).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
            },
            animate: function (t, e, n, r) {
                var i = S.isEmptyObject(t),
                    o = S.speed(e, n, r),
                    a = function () {
                        var e = lt(this, S.extend({}, t), o);
                        (i || Y.get(this, "finish")) && e.stop(!0);
                    };
                return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
            },
            stop: function (i, e, o) {
                var a = function (e) {
                    var t = e.stop;
                    delete e.stop, t(o);
                };
                return (
                    "string" != typeof i && ((o = e), (e = i), (i = void 0)),
                    e && this.queue(i || "fx", []),
                    this.each(function () {
                        var e = !0,
                            t = null != i && i + "queueHooks",
                            n = S.timers,
                            r = Y.get(this);
                        if (t) r[t] && r[t].stop && a(r[t]);
                        else for (t in r) r[t] && r[t].stop && it.test(t) && a(r[t]);
                        for (t = n.length; t--; ) n[t].elem !== this || (null != i && n[t].queue !== i) || (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
                        (!e && o) || S.dequeue(this, i);
                    })
                );
            },
            finish: function (a) {
                return (
                    !1 !== a && (a = a || "fx"),
                    this.each(function () {
                        var e,
                            t = Y.get(this),
                            n = t[a + "queue"],
                            r = t[a + "queueHooks"],
                            i = S.timers,
                            o = n ? n.length : 0;
                        for (t.finish = !0, S.queue(this, a, []), r && r.stop && r.stop.call(this, !0), e = i.length; e--; ) i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0), i.splice(e, 1));
                        for (e = 0; e < o; e++) n[e] && n[e].finish && n[e].finish.call(this);
                        delete t.finish;
                    })
                );
            },
        }),
        S.each(["toggle", "show", "hide"], function (e, r) {
            var i = S.fn[r];
            S.fn[r] = function (e, t, n) {
                return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(st(r, !0), e, t, n);
            };
        }),
        S.each({ slideDown: st("show"), slideUp: st("hide"), slideToggle: st("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, r) {
            S.fn[e] = function (e, t, n) {
                return this.animate(r, e, t, n);
            };
        }),
        (S.timers = []),
        (S.fx.tick = function () {
            var e,
                t = 0,
                n = S.timers;
            for (Ze = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || S.fx.stop(), (Ze = void 0);
        }),
        (S.fx.timer = function (e) {
            S.timers.push(e), S.fx.start();
        }),
        (S.fx.interval = 13),
        (S.fx.start = function () {
            et || ((et = !0), ot());
        }),
        (S.fx.stop = function () {
            et = null;
        }),
        (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (S.fn.delay = function (r, e) {
            return (
                (r = (S.fx && S.fx.speeds[r]) || r),
                (e = e || "fx"),
                this.queue(e, function (e, t) {
                    var n = C.setTimeout(e, r);
                    t.stop = function () {
                        C.clearTimeout(n);
                    };
                })
            );
        }),
        (tt = E.createElement("input")),
        (nt = E.createElement("select").appendChild(E.createElement("option"))),
        (tt.type = "checkbox"),
        (y.checkOn = "" !== tt.value),
        (y.optSelected = nt.selected),
        ((tt = E.createElement("input")).value = "t"),
        (tt.type = "radio"),
        (y.radioValue = "t" === tt.value);
    var ct,
        ft = S.expr.attrHandle;
    S.fn.extend({
        attr: function (e, t) {
            return $(this, S.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function (e) {
            return this.each(function () {
                S.removeAttr(this, e);
            });
        },
    }),
        S.extend({
            attr: function (e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return "undefined" == typeof e.getAttribute
                        ? S.prop(e, t, n)
                        : ((1 === o && S.isXMLDoc(e)) || (i = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? ct : void 0)),
                          void 0 !== n
                              ? null === n
                                  ? void S.removeAttr(e, t)
                                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                  ? r
                                  : (e.setAttribute(t, n + ""), n)
                              : i && "get" in i && null !== (r = i.get(e, t))
                              ? r
                              : null == (r = S.find.attr(e, t))
                              ? void 0
                              : r);
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!y.radioValue && "radio" === t && A(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function (e, t) {
                var n,
                    r = 0,
                    i = t && t.match(P);
                if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
            },
        }),
        (ct = {
            set: function (e, t, n) {
                return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var a = ft[t] || S.find.attr;
            ft[t] = function (e, t, n) {
                var r,
                    i,
                    o = t.toLowerCase();
                return n || ((i = ft[o]), (ft[o] = r), (r = null != a(e, t, n) ? o : null), (ft[o] = i)), r;
            };
        });
    var pt = /^(?:input|select|textarea|button)$/i,
        dt = /^(?:a|area)$/i;
    function ht(e) {
        return (e.match(P) || []).join(" ");
    }
    function gt(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function vt(e) {
        return Array.isArray(e) ? e : ("string" == typeof e && e.match(P)) || [];
    }
    S.fn.extend({
        prop: function (e, t) {
            return $(this, S.prop, e, t, 1 < arguments.length);
        },
        removeProp: function (e) {
            return this.each(function () {
                delete this[S.propFix[e] || e];
            });
        },
    }),
        S.extend({
            prop: function (e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return (
                        (1 === o && S.isXMLDoc(e)) || ((t = S.propFix[t] || t), (i = S.propHooks[t])),
                        void 0 !== n ? (i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e[t] = n)) : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = S.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : pt.test(e.nodeName) || (dt.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        y.optSelected ||
            (S.propHooks.selected = {
                get: function (e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            S.propFix[this.toLowerCase()] = this;
        }),
        S.fn.extend({
            addClass: function (t) {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = 0;
                if (m(t))
                    return this.each(function (e) {
                        S(this).addClass(t.call(this, e, gt(this)));
                    });
                if ((e = vt(t)).length)
                    while ((n = this[u++]))
                        if (((i = gt(n)), (r = 1 === n.nodeType && " " + ht(i) + " "))) {
                            a = 0;
                            while ((o = e[a++])) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                            i !== (s = ht(r)) && n.setAttribute("class", s);
                        }
                return this;
            },
            removeClass: function (t) {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = 0;
                if (m(t))
                    return this.each(function (e) {
                        S(this).removeClass(t.call(this, e, gt(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((e = vt(t)).length)
                    while ((n = this[u++]))
                        if (((i = gt(n)), (r = 1 === n.nodeType && " " + ht(i) + " "))) {
                            a = 0;
                            while ((o = e[a++])) while (-1 < r.indexOf(" " + o + " ")) r = r.replace(" " + o + " ", " ");
                            i !== (s = ht(r)) && n.setAttribute("class", s);
                        }
                return this;
            },
            toggleClass: function (i, t) {
                var o = typeof i,
                    a = "string" === o || Array.isArray(i);
                return "boolean" == typeof t && a
                    ? t
                        ? this.addClass(i)
                        : this.removeClass(i)
                    : m(i)
                    ? this.each(function (e) {
                          S(this).toggleClass(i.call(this, e, gt(this), t), t);
                      })
                    : this.each(function () {
                          var e, t, n, r;
                          if (a) {
                              (t = 0), (n = S(this)), (r = vt(i));
                              while ((e = r[t++])) n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                          } else (void 0 !== i && "boolean" !== o) || ((e = gt(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === i ? "" : Y.get(this, "__className__") || ""));
                      });
            },
            hasClass: function (e) {
                var t,
                    n,
                    r = 0;
                t = " " + e + " ";
                while ((n = this[r++])) if (1 === n.nodeType && -1 < (" " + ht(gt(n)) + " ").indexOf(t)) return !0;
                return !1;
            },
        });
    var yt = /\r/g;
    S.fn.extend({
        val: function (n) {
            var r,
                e,
                i,
                t = this[0];
            return arguments.length
                ? ((i = m(n)),
                  this.each(function (e) {
                      var t;
                      1 === this.nodeType &&
                          (null == (t = i ? n.call(this, e, S(this).val()) : n)
                              ? (t = "")
                              : "number" == typeof t
                              ? (t += "")
                              : Array.isArray(t) &&
                                (t = S.map(t, function (e) {
                                    return null == e ? "" : e + "";
                                })),
                          ((r = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in r && void 0 !== r.set(this, t, "value")) || (this.value = t));
                  }))
                : t
                ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) && "get" in r && void 0 !== (e = r.get(t, "value"))
                    ? e
                    : "string" == typeof (e = t.value)
                    ? e.replace(yt, "")
                    : null == e
                    ? ""
                    : e
                : void 0;
        },
    }),
        S.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = S.find.attr(e, "value");
                        return null != t ? t : ht(S.text(e));
                    },
                },
                select: {
                    get: function (e) {
                        var t,
                            n,
                            r,
                            i = e.options,
                            o = e.selectedIndex,
                            a = "select-one" === e.type,
                            s = a ? null : [],
                            u = a ? o + 1 : i.length;
                        for (r = o < 0 ? u : a ? o : 0; r < u; r++)
                            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))) {
                                if (((t = S(n).val()), a)) return t;
                                s.push(t);
                            }
                        return s;
                    },
                    set: function (e, t) {
                        var n,
                            r,
                            i = e.options,
                            o = S.makeArray(t),
                            a = i.length;
                        while (a--) ((r = i[a]).selected = -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
                        return n || (e.selectedIndex = -1), o;
                    },
                },
            },
        }),
        S.each(["radio", "checkbox"], function () {
            (S.valHooks[this] = {
                set: function (e, t) {
                    if (Array.isArray(t)) return (e.checked = -1 < S.inArray(S(e).val(), t));
                },
            }),
                y.checkOn ||
                    (S.valHooks[this].get = function (e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
        }),
        (y.focusin = "onfocusin" in C);
    var mt = /^(?:focusinfocus|focusoutblur)$/,
        xt = function (e) {
            e.stopPropagation();
        };
    S.extend(S.event, {
        trigger: function (e, t, n, r) {
            var i,
                o,
                a,
                s,
                u,
                l,
                c,
                f,
                p = [n || E],
                d = v.call(e, "type") ? e.type : e,
                h = v.call(e, "namespace") ? e.namespace.split(".") : [];
            if (
                ((o = f = a = n = n || E),
                3 !== n.nodeType &&
                    8 !== n.nodeType &&
                    !mt.test(d + S.event.triggered) &&
                    (-1 < d.indexOf(".") && ((d = (h = d.split(".")).shift()), h.sort()),
                    (u = d.indexOf(":") < 0 && "on" + d),
                    ((e = e[S.expando] ? e : new S.Event(d, "object" == typeof e && e)).isTrigger = r ? 2 : 3),
                    (e.namespace = h.join(".")),
                    (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (e.result = void 0),
                    e.target || (e.target = n),
                    (t = null == t ? [e] : S.makeArray(t, [e])),
                    (c = S.event.special[d] || {}),
                    r || !c.trigger || !1 !== c.trigger.apply(n, t)))
            ) {
                if (!r && !c.noBubble && !x(n)) {
                    for (s = c.delegateType || d, mt.test(s + d) || (o = o.parentNode); o; o = o.parentNode) p.push(o), (a = o);
                    a === (n.ownerDocument || E) && p.push(a.defaultView || a.parentWindow || C);
                }
                i = 0;
                while ((o = p[i++]) && !e.isPropagationStopped())
                    (f = o),
                        (e.type = 1 < i ? s : c.bindType || d),
                        (l = (Y.get(o, "events") || Object.create(null))[e.type] && Y.get(o, "handle")) && l.apply(o, t),
                        (l = u && o[u]) && l.apply && V(o) && ((e.result = l.apply(o, t)), !1 === e.result && e.preventDefault());
                return (
                    (e.type = d),
                    r ||
                        e.isDefaultPrevented() ||
                        (c._default && !1 !== c._default.apply(p.pop(), t)) ||
                        !V(n) ||
                        (u &&
                            m(n[d]) &&
                            !x(n) &&
                            ((a = n[u]) && (n[u] = null),
                            (S.event.triggered = d),
                            e.isPropagationStopped() && f.addEventListener(d, xt),
                            n[d](),
                            e.isPropagationStopped() && f.removeEventListener(d, xt),
                            (S.event.triggered = void 0),
                            a && (n[u] = a))),
                    e.result
                );
            }
        },
        simulate: function (e, t, n) {
            var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
            S.event.trigger(r, null, t);
        },
    }),
        S.fn.extend({
            trigger: function (e, t) {
                return this.each(function () {
                    S.event.trigger(e, t, this);
                });
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return S.event.trigger(e, t, n, !0);
            },
        }),
        y.focusin ||
            S.each({ focus: "focusin", blur: "focusout" }, function (n, r) {
                var i = function (e) {
                    S.event.simulate(r, e.target, S.event.fix(e));
                };
                S.event.special[r] = {
                    setup: function () {
                        var e = this.ownerDocument || this.document || this,
                            t = Y.access(e, r);
                        t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
                    },
                    teardown: function () {
                        var e = this.ownerDocument || this.document || this,
                            t = Y.access(e, r) - 1;
                        t ? Y.access(e, r, t) : (e.removeEventListener(n, i, !0), Y.remove(e, r));
                    },
                };
            });
    var bt = C.location,
        wt = { guid: Date.now() },
        Tt = /\?/;
    S.parseXML = function (e) {
        var t, n;
        if (!e || "string" != typeof e) return null;
        try {
            t = new C.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {}
        return (
            (n = t && t.getElementsByTagName("parsererror")[0]),
            (t && !n) ||
                S.error(
                    "Invalid XML: " +
                        (n
                            ? S.map(n.childNodes, function (e) {
                                  return e.textContent;
                              }).join("\n")
                            : e)
                ),
            t
        );
    };
    var Ct = /\[\]$/,
        Et = /\r?\n/g,
        St = /^(?:submit|button|image|reset|file)$/i,
        kt = /^(?:input|select|textarea|keygen)/i;
    function At(n, e, r, i) {
        var t;
        if (Array.isArray(e))
            S.each(e, function (e, t) {
                r || Ct.test(n) ? i(n, t) : At(n + "[" + ("object" == typeof t && null != t ? e : "") + "]", t, r, i);
            });
        else if (r || "object" !== w(e)) i(n, e);
        else for (t in e) At(n + "[" + t + "]", e[t], r, i);
    }
    (S.param = function (e, t) {
        var n,
            r = [],
            i = function (e, t) {
                var n = m(t) ? t() : t;
                r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
            };
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
            S.each(e, function () {
                i(this.name, this.value);
            });
        else for (n in e) At(n, e[n], t, i);
        return r.join("&");
    }),
        S.fn.extend({
            serialize: function () {
                return S.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = S.prop(this, "elements");
                    return e ? S.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return this.name && !S(this).is(":disabled") && kt.test(this.nodeName) && !St.test(e) && (this.checked || !pe.test(e));
                    })
                    .map(function (e, t) {
                        var n = S(this).val();
                        return null == n
                            ? null
                            : Array.isArray(n)
                            ? S.map(n, function (e) {
                                  return { name: t.name, value: e.replace(Et, "\r\n") };
                              })
                            : { name: t.name, value: n.replace(Et, "\r\n") };
                    })
                    .get();
            },
        });
    var Nt = /%20/g,
        jt = /#.*$/,
        Dt = /([?&])_=[^&]*/,
        qt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Lt = /^(?:GET|HEAD)$/,
        Ht = /^\/\//,
        Ot = {},
        Pt = {},
        Rt = "*/".concat("*"),
        Mt = E.createElement("a");
    function It(o) {
        return function (e, t) {
            "string" != typeof e && ((t = e), (e = "*"));
            var n,
                r = 0,
                i = e.toLowerCase().match(P) || [];
            if (m(t)) while ((n = i[r++])) "+" === n[0] ? ((n = n.slice(1) || "*"), (o[n] = o[n] || []).unshift(t)) : (o[n] = o[n] || []).push(t);
        };
    }
    function Wt(t, i, o, a) {
        var s = {},
            u = t === Pt;
        function l(e) {
            var r;
            return (
                (s[e] = !0),
                S.each(t[e] || [], function (e, t) {
                    var n = t(i, o, a);
                    return "string" != typeof n || u || s[n] ? (u ? !(r = n) : void 0) : (i.dataTypes.unshift(n), l(n), !1);
                }),
                r
            );
        }
        return l(i.dataTypes[0]) || (!s["*"] && l("*"));
    }
    function Ft(e, t) {
        var n,
            r,
            i = S.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        return r && S.extend(!0, e, r), e;
    }
    (Mt.href = bt.href),
        S.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: bt.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(bt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: { "*": Rt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
                return t ? Ft(Ft(e, S.ajaxSettings), t) : Ft(S.ajaxSettings, e);
            },
            ajaxPrefilter: It(Ot),
            ajaxTransport: It(Pt),
            ajax: function (e, t) {
                "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                var c,
                    f,
                    p,
                    n,
                    d,
                    r,
                    h,
                    g,
                    i,
                    o,
                    v = S.ajaxSetup({}, t),
                    y = v.context || v,
                    m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event,
                    x = S.Deferred(),
                    b = S.Callbacks("once memory"),
                    w = v.statusCode || {},
                    a = {},
                    s = {},
                    u = "canceled",
                    T = {
                        readyState: 0,
                        getResponseHeader: function (e) {
                            var t;
                            if (h) {
                                if (!n) {
                                    n = {};
                                    while ((t = qt.exec(p))) n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                }
                                t = n[e.toLowerCase() + " "];
                            }
                            return null == t ? null : t.join(", ");
                        },
                        getAllResponseHeaders: function () {
                            return h ? p : null;
                        },
                        setRequestHeader: function (e, t) {
                            return null == h && ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e), (a[e] = t)), this;
                        },
                        overrideMimeType: function (e) {
                            return null == h && (v.mimeType = e), this;
                        },
                        statusCode: function (e) {
                            var t;
                            if (e)
                                if (h) T.always(e[T.status]);
                                else for (t in e) w[t] = [w[t], e[t]];
                            return this;
                        },
                        abort: function (e) {
                            var t = e || u;
                            return c && c.abort(t), l(0, t), this;
                        },
                    };
                if (
                    (x.promise(T),
                    (v.url = ((e || v.url || bt.href) + "").replace(Ht, bt.protocol + "//")),
                    (v.type = t.method || t.type || v.method || v.type),
                    (v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""]),
                    null == v.crossDomain)
                ) {
                    r = E.createElement("a");
                    try {
                        (r.href = v.url), (r.href = r.href), (v.crossDomain = Mt.protocol + "//" + Mt.host != r.protocol + "//" + r.host);
                    } catch (e) {
                        v.crossDomain = !0;
                    }
                }
                if ((v.data && v.processData && "string" != typeof v.data && (v.data = S.param(v.data, v.traditional)), Wt(Ot, v, t, T), h)) return T;
                for (i in ((g = S.event && v.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
                (v.type = v.type.toUpperCase()),
                (v.hasContent = !Lt.test(v.type)),
                (f = v.url.replace(jt, "")),
                v.hasContent
                    ? v.data && v.processData && 0 === (v.contentType || "").indexOf("application/x-www-form-urlencoded") && (v.data = v.data.replace(Nt, "+"))
                    : ((o = v.url.slice(f.length)),
                      v.data && (v.processData || "string" == typeof v.data) && ((f += (Tt.test(f) ? "&" : "?") + v.data), delete v.data),
                      !1 === v.cache && ((f = f.replace(Dt, "$1")), (o = (Tt.test(f) ? "&" : "?") + "_=" + wt.guid++ + o)),
                      (v.url = f + o)),
                v.ifModified && (S.lastModified[f] && T.setRequestHeader("If-Modified-Since", S.lastModified[f]), S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])),
                ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) && T.setRequestHeader("Content-Type", v.contentType),
                T.setRequestHeader("Accept", v.dataTypes[0] && v.accepts[v.dataTypes[0]] ? v.accepts[v.dataTypes[0]] + ("*" !== v.dataTypes[0] ? ", " + Rt + "; q=0.01" : "") : v.accepts["*"]),
                v.headers))
                    T.setRequestHeader(i, v.headers[i]);
                if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h)) return T.abort();
                if (((u = "abort"), b.add(v.complete), T.done(v.success), T.fail(v.error), (c = Wt(Pt, v, t, T)))) {
                    if (((T.readyState = 1), g && m.trigger("ajaxSend", [T, v]), h)) return T;
                    v.async &&
                        0 < v.timeout &&
                        (d = C.setTimeout(function () {
                            T.abort("timeout");
                        }, v.timeout));
                    try {
                        (h = !1), c.send(a, l);
                    } catch (e) {
                        if (h) throw e;
                        l(-1, e);
                    }
                } else l(-1, "No Transport");
                function l(e, t, n, r) {
                    var i,
                        o,
                        a,
                        s,
                        u,
                        l = t;
                    h ||
                        ((h = !0),
                        d && C.clearTimeout(d),
                        (c = void 0),
                        (p = r || ""),
                        (T.readyState = 0 < e ? 4 : 0),
                        (i = (200 <= e && e < 300) || 304 === e),
                        n &&
                            (s = (function (e, t, n) {
                                var r,
                                    i,
                                    o,
                                    a,
                                    s = e.contents,
                                    u = e.dataTypes;
                                while ("*" === u[0]) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (r)
                                    for (i in s)
                                        if (s[i] && s[i].test(r)) {
                                            u.unshift(i);
                                            break;
                                        }
                                if (u[0] in n) o = u[0];
                                else {
                                    for (i in n) {
                                        if (!u[0] || e.converters[i + " " + u[0]]) {
                                            o = i;
                                            break;
                                        }
                                        a || (a = i);
                                    }
                                    o = o || a;
                                }
                                if (o) return o !== u[0] && u.unshift(o), n[o];
                            })(v, T, n)),
                        !i && -1 < S.inArray("script", v.dataTypes) && S.inArray("json", v.dataTypes) < 0 && (v.converters["text script"] = function () {}),
                        (s = (function (e, t, n, r) {
                            var i,
                                o,
                                a,
                                s,
                                u,
                                l = {},
                                c = e.dataTypes.slice();
                            if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
                            o = c.shift();
                            while (o)
                                if ((e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (u = o), (o = c.shift())))
                                    if ("*" === o) o = u;
                                    else if ("*" !== u && u !== o) {
                                        if (!(a = l[u + " " + o] || l["* " + o]))
                                            for (i in l)
                                                if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                                                    !0 === a ? (a = l[i]) : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                                                    break;
                                                }
                                        if (!0 !== a)
                                            if (a && e["throws"]) t = a(t);
                                            else
                                                try {
                                                    t = a(t);
                                                } catch (e) {
                                                    return { state: "parsererror", error: a ? e : "No conversion from " + u + " to " + o };
                                                }
                                    }
                            return { state: "success", data: t };
                        })(v, s, T, i)),
                        i
                            ? (v.ifModified && ((u = T.getResponseHeader("Last-Modified")) && (S.lastModified[f] = u), (u = T.getResponseHeader("etag")) && (S.etag[f] = u)),
                              204 === e || "HEAD" === v.type ? (l = "nocontent") : 304 === e ? (l = "notmodified") : ((l = s.state), (o = s.data), (i = !(a = s.error))))
                            : ((a = l), (!e && l) || ((l = "error"), e < 0 && (e = 0))),
                        (T.status = e),
                        (T.statusText = (t || l) + ""),
                        i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
                        T.statusCode(w),
                        (w = void 0),
                        g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, v, i ? o : a]),
                        b.fireWith(y, [T, l]),
                        g && (m.trigger("ajaxComplete", [T, v]), --S.active || S.event.trigger("ajaxStop")));
                }
                return T;
            },
            getJSON: function (e, t, n) {
                return S.get(e, t, n, "json");
            },
            getScript: function (e, t) {
                return S.get(e, void 0, t, "script");
            },
        }),
        S.each(["get", "post"], function (e, i) {
            S[i] = function (e, t, n, r) {
                return m(t) && ((r = r || n), (n = t), (t = void 0)), S.ajax(S.extend({ url: e, type: i, dataType: r, data: t, success: n }, S.isPlainObject(e) && e));
            };
        }),
        S.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
        }),
        (S._evalUrl = function (e, t, n) {
            return S.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                    S.globalEval(e, t, n);
                },
            });
        }),
        S.fn.extend({
            wrapAll: function (e) {
                var t;
                return (
                    this[0] &&
                        (m(e) && (e = e.call(this[0])),
                        (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                var e = this;
                                while (e.firstElementChild) e = e.firstElementChild;
                                return e;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function (n) {
                return m(n)
                    ? this.each(function (e) {
                          S(this).wrapInner(n.call(this, e));
                      })
                    : this.each(function () {
                          var e = S(this),
                              t = e.contents();
                          t.length ? t.wrapAll(n) : e.append(n);
                      });
            },
            wrap: function (t) {
                var n = m(t);
                return this.each(function (e) {
                    S(this).wrapAll(n ? t.call(this, e) : t);
                });
            },
            unwrap: function (e) {
                return (
                    this.parent(e)
                        .not("body")
                        .each(function () {
                            S(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (S.expr.pseudos.hidden = function (e) {
            return !S.expr.pseudos.visible(e);
        }),
        (S.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        }),
        (S.ajaxSettings.xhr = function () {
            try {
                return new C.XMLHttpRequest();
            } catch (e) {}
        });
    var Bt = { 0: 200, 1223: 204 },
        $t = S.ajaxSettings.xhr();
    (y.cors = !!$t && "withCredentials" in $t),
        (y.ajax = $t = !!$t),
        S.ajaxTransport(function (i) {
            var o, a;
            if (y.cors || ($t && !i.crossDomain))
                return {
                    send: function (e, t) {
                        var n,
                            r = i.xhr();
                        if ((r.open(i.type, i.url, i.async, i.username, i.password), i.xhrFields)) for (n in i.xhrFields) r[n] = i.xhrFields[n];
                        for (n in (i.mimeType && r.overrideMimeType && r.overrideMimeType(i.mimeType), i.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e)) r.setRequestHeader(n, e[n]);
                        (o = function (e) {
                            return function () {
                                o &&
                                    ((o = a = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null),
                                    "abort" === e
                                        ? r.abort()
                                        : "error" === e
                                        ? "number" != typeof r.status
                                            ? t(0, "error")
                                            : t(r.status, r.statusText)
                                        : t(Bt[r.status] || r.status, r.statusText, "text" !== (r.responseType || "text") || "string" != typeof r.responseText ? { binary: r.response } : { text: r.responseText }, r.getAllResponseHeaders()));
                            };
                        }),
                            (r.onload = o()),
                            (a = r.onerror = r.ontimeout = o("error")),
                            void 0 !== r.onabort
                                ? (r.onabort = a)
                                : (r.onreadystatechange = function () {
                                      4 === r.readyState &&
                                          C.setTimeout(function () {
                                              o && a();
                                          });
                                  }),
                            (o = o("abort"));
                        try {
                            r.send((i.hasContent && i.data) || null);
                        } catch (e) {
                            if (o) throw e;
                        }
                    },
                    abort: function () {
                        o && o();
                    },
                };
        }),
        S.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
        }),
        S.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (e) {
                    return S.globalEval(e), e;
                },
            },
        }),
        S.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        S.ajaxTransport("script", function (n) {
            var r, i;
            if (n.crossDomain || n.scriptAttrs)
                return {
                    send: function (e, t) {
                        (r = S("<script>")
                            .attr(n.scriptAttrs || {})
                            .prop({ charset: n.scriptCharset, src: n.url })
                            .on(
                                "load error",
                                (i = function (e) {
                                    r.remove(), (i = null), e && t("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            E.head.appendChild(r[0]);
                    },
                    abort: function () {
                        i && i();
                    },
                };
        });
    var _t,
        zt = [],
        Ut = /(=)\?(?=&|$)|\?\?/;
    S.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = zt.pop() || S.expando + "_" + wt.guid++;
            return (this[e] = !0), e;
        },
    }),
        S.ajaxPrefilter("json jsonp", function (e, t, n) {
            var r,
                i,
                o,
                a = !1 !== e.jsonp && (Ut.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ut.test(e.data) && "data");
            if (a || "jsonp" === e.dataTypes[0])
                return (
                    (r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                    a ? (e[a] = e[a].replace(Ut, "$1" + r)) : !1 !== e.jsonp && (e.url += (Tt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
                    (e.converters["script json"] = function () {
                        return o || S.error(r + " was not called"), o[0];
                    }),
                    (e.dataTypes[0] = "json"),
                    (i = C[r]),
                    (C[r] = function () {
                        o = arguments;
                    }),
                    n.always(function () {
                        void 0 === i ? S(C).removeProp(r) : (C[r] = i), e[r] && ((e.jsonpCallback = t.jsonpCallback), zt.push(r)), o && m(i) && i(o[0]), (o = i = void 0);
                    }),
                    "script"
                );
        }),
        (y.createHTMLDocument = (((_t = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === _t.childNodes.length)),
        (S.parseHTML = function (e, t, n) {
            return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t || (y.createHTMLDocument ? (((r = (t = E.implementation.createHTMLDocument("")).createElement("base")).href = E.location.href), t.head.appendChild(r)) : (t = E)),
                  (o = !n && []),
                  (i = N.exec(e)) ? [t.createElement(i[1])] : ((i = xe([e], t, o)), o && o.length && S(o).remove(), S.merge([], i.childNodes)));
            var r, i, o;
        }),
        (S.fn.load = function (e, t, n) {
            var r,
                i,
                o,
                a = this,
                s = e.indexOf(" ");
            return (
                -1 < s && ((r = ht(e.slice(s))), (e = e.slice(0, s))),
                m(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
                0 < a.length &&
                    S.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (o = arguments), a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
                        })
                        .always(
                            n &&
                                function (e, t) {
                                    a.each(function () {
                                        n.apply(this, o || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
        (S.expr.pseudos.animated = function (t) {
            return S.grep(S.timers, function (e) {
                return t === e.elem;
            }).length;
        }),
        (S.offset = {
            setOffset: function (e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = S.css(e, "position"),
                    c = S(e),
                    f = {};
                "static" === l && (e.style.position = "relative"),
                    (s = c.offset()),
                    (o = S.css(e, "top")),
                    (u = S.css(e, "left")),
                    ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto") ? ((a = (r = c.position()).top), (i = r.left)) : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
                    m(t) && (t = t.call(e, n, S.extend({}, s))),
                    null != t.top && (f.top = t.top - s.top + a),
                    null != t.left && (f.left = t.left - s.left + i),
                    "using" in t ? t.using.call(e, f) : c.css(f);
            },
        }),
        S.fn.extend({
            offset: function (t) {
                if (arguments.length)
                    return void 0 === t
                        ? this
                        : this.each(function (e) {
                              S.offset.setOffset(this, t, e);
                          });
                var e,
                    n,
                    r = this[0];
                return r ? (r.getClientRects().length ? ((e = r.getBoundingClientRect()), (n = r.ownerDocument.defaultView), { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
            },
            position: function () {
                if (this[0]) {
                    var e,
                        t,
                        n,
                        r = this[0],
                        i = { top: 0, left: 0 };
                    if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();
                    else {
                        (t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement);
                        while (e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position")) e = e.parentNode;
                        e && e !== r && 1 === e.nodeType && (((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0)), (i.left += S.css(e, "borderLeftWidth", !0)));
                    }
                    return { top: t.top - i.top - S.css(r, "marginTop", !0), left: t.left - i.left - S.css(r, "marginLeft", !0) };
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    var e = this.offsetParent;
                    while (e && "static" === S.css(e, "position")) e = e.offsetParent;
                    return e || re;
                });
            },
        }),
        S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, i) {
            var o = "pageYOffset" === i;
            S.fn[t] = function (e) {
                return $(
                    this,
                    function (e, t, n) {
                        var r;
                        if ((x(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === n)) return r ? r[i] : e[t];
                        r ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset) : (e[t] = n);
                    },
                    t,
                    e,
                    arguments.length
                );
            };
        }),
        S.each(["top", "left"], function (e, n) {
            S.cssHooks[n] = Fe(y.pixelPosition, function (e, t) {
                if (t) return (t = We(e, n)), Pe.test(t) ? S(e).position()[n] + "px" : t;
            });
        }),
        S.each({ Height: "height", Width: "width" }, function (a, s) {
            S.each({ padding: "inner" + a, content: s, "": "outer" + a }, function (r, o) {
                S.fn[o] = function (e, t) {
                    var n = arguments.length && (r || "boolean" != typeof e),
                        i = r || (!0 === e || !0 === t ? "margin" : "border");
                    return $(
                        this,
                        function (e, t, n) {
                            var r;
                            return x(e)
                                ? 0 === o.indexOf("outer")
                                    ? e["inner" + a]
                                    : e.document.documentElement["client" + a]
                                : 9 === e.nodeType
                                ? ((r = e.documentElement), Math.max(e.body["scroll" + a], r["scroll" + a], e.body["offset" + a], r["offset" + a], r["client" + a]))
                                : void 0 === n
                                ? S.css(e, t, i)
                                : S.style(e, t, n, i);
                        },
                        s,
                        n ? e : void 0,
                        n
                    );
                };
            });
        }),
        S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            S.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        S.fn.extend({
            bind: function (e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
                return this.off(e, null, t);
            },
            delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, n) {
            S.fn[n] = function (e, t) {
                return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n);
            };
        });
    var Xt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (S.proxy = function (e, t) {
        var n, r, i;
        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
            return (
                (r = s.call(arguments, 2)),
                ((i = function () {
                    return e.apply(t || this, r.concat(s.call(arguments)));
                }).guid = e.guid = e.guid || S.guid++),
                i
            );
    }),
        (S.holdReady = function (e) {
            e ? S.readyWait++ : S.ready(!0);
        }),
        (S.isArray = Array.isArray),
        (S.parseJSON = JSON.parse),
        (S.nodeName = A),
        (S.isFunction = m),
        (S.isWindow = x),
        (S.camelCase = X),
        (S.type = w),
        (S.now = Date.now),
        (S.isNumeric = function (e) {
            var t = S.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
        }),
        (S.trim = function (e) {
            return null == e ? "" : (e + "").replace(Xt, "");
        }),
        "function" == typeof define &&
            define.amd &&
            define("jquery", [], function () {
                return S;
            });
    var Vt = C.jQuery,
        Gt = C.$;
    return (
        (S.noConflict = function (e) {
            return C.$ === S && (C.$ = Gt), e && C.jQuery === S && (C.jQuery = Vt), S;
        }),
        "undefined" == typeof e && (C.jQuery = C.$ = S),
        S
    );
});
!(function (e, t) {
    var r = t(e, e.document);
    (e.lazySizes = r), "object" == typeof module && module.exports && (module.exports = r);
})(window, function (e, t) {
    "use strict";
    if (t.getElementsByClassName) {
        var r,
            i,
            a = t.documentElement,
            n = e.Date,
            s = e.HTMLPictureElement,
            o = "addEventListener",
            l = "getAttribute",
            u = e[o],
            c = e.setTimeout,
            d = e.requestAnimationFrame || c,
            f = e.requestIdleCallback,
            g = /^picture$/i,
            p = ["load", "error", "lazyincluded", "_lazyloaded"],
            y = {},
            z = Array.prototype.forEach,
            m = function (e, t) {
                return y[t] || (y[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), y[t].test(e[l]("class") || "") && y[t];
            },
            v = function (e, t) {
                m(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
            },
            b = function (e, t) {
                var r;
                (r = m(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(r, " "));
            },
            A = function (e, t, r) {
                var i = r ? o : "removeEventListener";
                r && A(e, t),
                    p.forEach(function (r) {
                        e[i](r, t);
                    });
            },
            h = function (e, i, a, n, s) {
                var o = t.createEvent("CustomEvent");
                return a || (a = {}), (a.instance = r), o.initCustomEvent(i, !n, !s, a), e.dispatchEvent(o), o;
            },
            E = function (t, r) {
                var a;
                !s && (a = e.picturefill || i.pf) ? a({ reevaluate: !0, elements: [t] }) : r && r.src && (t.src = r.src);
            },
            C = function (e, t) {
                return (getComputedStyle(e, null) || {})[t];
            },
            w = function (e, t, r) {
                for (r = r || e.offsetWidth; r < i.minSize && t && !e._lazysizesWidth; ) (r = t.offsetWidth), (t = t.parentNode);
                return r;
            },
            _ = (function () {
                var e,
                    r,
                    i = [],
                    a = [],
                    n = i,
                    s = function () {
                        var t = n;
                        for (n = i.length ? a : i, e = !0, r = !1; t.length; ) t.shift()();
                        e = !1;
                    },
                    o = function (i, a) {
                        e && !a ? i.apply(this, arguments) : (n.push(i), r || ((r = !0), (t.hidden ? c : d)(s)));
                    };
                return (o._lsFlush = s), o;
            })(),
            S = function (e, t) {
                return t
                    ? function () {
                          _(e);
                      }
                    : function () {
                          var t = this,
                              r = arguments;
                          _(function () {
                              e.apply(t, r);
                          });
                      };
            },
            x = function (e) {
                var t,
                    r = 0,
                    a = 125,
                    s = i.ricTimeout,
                    o = function () {
                        (t = !1), (r = n.now()), e();
                    },
                    l =
                        f && i.ricTimeout
                            ? function () {
                                  f(o, { timeout: s }), s !== i.ricTimeout && (s = i.ricTimeout);
                              }
                            : S(function () {
                                  c(o);
                              }, !0);
                return function (e) {
                    var i;
                    (e = e === !0) && (s = 33), t || ((t = !0), (i = a - (n.now() - r)), i < 0 && (i = 0), e || (i < 9 && f) ? l() : c(l, i));
                };
            },
            N = function (e) {
                var t,
                    r,
                    i = 99,
                    a = function () {
                        (t = null), e();
                    },
                    s = function () {
                        var e = n.now() - r;
                        e < i ? c(s, i - e) : (f || a)(a);
                    };
                return function () {
                    (r = n.now()), t || (t = c(s, i));
                };
            };
        !(function () {
            var t,
                r = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: 0.8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 300,
                };
            i = e.lazySizesConfig || e.lazysizesConfig || {};
            for (t in r) t in i || (i[t] = r[t]);
            (e.lazySizesConfig = i),
                c(function () {
                    i.init && M();
                });
        })();
        var P = (function () {
                var s,
                    d,
                    f,
                    p,
                    y,
                    w,
                    P,
                    M,
                    T,
                    O,
                    R,
                    F,
                    j,
                    $,
                    k = /^img$/i,
                    W = /^iframe$/i,
                    B = "onscroll" in e && !/glebot/.test(navigator.userAgent),
                    I = 0,
                    q = 0,
                    U = 0,
                    H = -1,
                    X = function (e) {
                        U--, e && e.target && A(e.target, X), (!e || U < 0 || !e.target) && (U = 0);
                    },
                    D = function (e, r) {
                        var i,
                            n = e,
                            s = "hidden" == C(t.body, "visibility") || "hidden" != C(e, "visibility");
                        for (M -= r, R += r, T -= r, O += r; s && (n = n.offsetParent) && n != t.body && n != a; )
                            (s = (C(n, "opacity") || 1) > 0), s && "visible" != C(n, "overflow") && ((i = n.getBoundingClientRect()), (s = O > i.left && T < i.right && R > i.top - 1 && M < i.bottom + 1));
                        return s;
                    },
                    J = function () {
                        var e,
                            n,
                            o,
                            u,
                            c,
                            f,
                            g,
                            y,
                            z,
                            m = r.elements;
                        if ((p = i.loadMode) && U < 8 && (e = m.length)) {
                            (n = 0),
                                H++,
                                null == j && ("expand" in i || (i.expand = a.clientHeight > 500 && a.clientWidth > 500 ? 500 : 370), (F = i.expand), (j = F * i.expFactor)),
                                q < j && U < 1 && H > 2 && p > 2 && !t.hidden ? ((q = j), (H = 0)) : (q = p > 1 && H > 1 && U < 6 ? F : I);
                            for (; n < e; n++)
                                if (m[n] && !m[n]._lazyRace)
                                    if (B)
                                        if (
                                            (((y = m[n][l]("data-expand")) && (f = 1 * y)) || (f = q),
                                            z !== f && ((w = innerWidth + f * $), (P = innerHeight + f), (g = f * -1), (z = f)),
                                            (o = m[n].getBoundingClientRect()),
                                            (R = o.bottom) >= g &&
                                                (M = o.top) <= P &&
                                                (O = o.right) >= g * $ &&
                                                (T = o.left) <= w &&
                                                (R || O || T || M) &&
                                                (i.loadHidden || "hidden" != C(m[n], "visibility")) &&
                                                ((d && U < 3 && !y && (p < 3 || H < 4)) || D(m[n], f)))
                                        ) {
                                            if ((te(m[n]), (c = !0), U > 9)) break;
                                        } else !c && d && !u && U < 4 && H < 4 && p > 2 && (s[0] || i.preloadAfterLoad) && (s[0] || (!y && (R || O || T || M || "auto" != m[n][l](i.sizesAttr)))) && (u = s[0] || m[n]);
                                    else te(m[n]);
                            u && !c && te(u);
                        }
                    },
                    V = x(J),
                    G = function (e) {
                        v(e.target, i.loadedClass), b(e.target, i.loadingClass), A(e.target, Q), h(e.target, "lazyloaded");
                    },
                    K = S(G),
                    Q = function (e) {
                        K({ target: e.target });
                    },
                    Y = function (e, t) {
                        try {
                            e.contentWindow.location.replace(t);
                        } catch (r) {
                            e.src = t;
                        }
                    },
                    Z = function (e) {
                        var t,
                            r = e[l](i.srcsetAttr);
                        (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), r && e.setAttribute("srcset", r);
                    },
                    ee = S(function (e, t, r, a, n) {
                        var s, o, u, d, p, y;
                        (p = h(e, "lazybeforeunveil", t)).defaultPrevented ||
                            (a && (r ? v(e, i.autosizesClass) : e.setAttribute("sizes", a)),
                            (o = e[l](i.srcsetAttr)),
                            (s = e[l](i.srcAttr)),
                            n && ((u = e.parentNode), (d = u && g.test(u.nodeName || ""))),
                            (y = t.firesLoad || ("src" in e && (o || s || d))),
                            (p = { target: e }),
                            y && (A(e, X, !0), clearTimeout(f), (f = c(X, 2500)), v(e, i.loadingClass), A(e, Q, !0)),
                            d && z.call(u.getElementsByTagName("source"), Z),
                            o ? e.setAttribute("srcset", o) : s && !d && (W.test(e.nodeName) ? Y(e, s) : (e.src = s)),
                            n && (o || d) && E(e, { src: s })),
                            e._lazyRace && delete e._lazyRace,
                            b(e, i.lazyClass),
                            _(function () {
                                (!y || (e.complete && e.naturalWidth > 1)) && (y ? X(p) : U--, G(p));
                            }, !0);
                    }),
                    te = function (e) {
                        var t,
                            r = k.test(e.nodeName),
                            a = r && (e[l](i.sizesAttr) || e[l]("sizes")),
                            n = "auto" == a;
                        ((!n && d) || !r || (!e[l]("src") && !e.srcset) || e.complete || m(e, i.errorClass) || !m(e, i.lazyClass)) &&
                            ((t = h(e, "lazyunveilread").detail), n && L.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), U++, ee(e, t, n, a, r));
                    },
                    re = function () {
                        if (!d) {
                            if (n.now() - y < 999) return void c(re, 999);
                            var e = N(function () {
                                (i.loadMode = 3), V();
                            });
                            (d = !0),
                                (i.loadMode = 3),
                                V(),
                                u(
                                    "scroll",
                                    function () {
                                        3 == i.loadMode && (i.loadMode = 2), e();
                                    },
                                    !0
                                );
                        }
                    };
                return {
                    _: function () {
                        (y = n.now()),
                            (r.elements = t.getElementsByClassName(i.lazyClass)),
                            (s = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass)),
                            ($ = i.hFac),
                            u("scroll", V, !0),
                            u("resize", V, !0),
                            e.MutationObserver ? new MutationObserver(V).observe(a, { childList: !0, subtree: !0, attributes: !0 }) : (a[o]("DOMNodeInserted", V, !0), a[o]("DOMAttrModified", V, !0), setInterval(V, 999)),
                            u("hashchange", V, !0),
                            ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (e) {
                                t[o](e, V, !0);
                            }),
                            /d$|^c/.test(t.readyState) ? re() : (u("load", re), t[o]("DOMContentLoaded", V), c(re, 2e4)),
                            r.elements.length ? (J(), _._lsFlush()) : V();
                    },
                    checkElems: V,
                    unveil: te,
                };
            })(),
            L = (function () {
                var e,
                    r = S(function (e, t, r, i) {
                        var a, n, s;
                        if (((e._lazysizesWidth = i), (i += "px"), e.setAttribute("sizes", i), g.test(t.nodeName || ""))) for (a = t.getElementsByTagName("source"), n = 0, s = a.length; n < s; n++) a[n].setAttribute("sizes", i);
                        r.detail.dataAttr || E(e, r.detail);
                    }),
                    a = function (e, t, i) {
                        var a,
                            n = e.parentNode;
                        n && ((i = w(e, n, i)), (a = h(e, "lazybeforesizes", { width: i, dataAttr: !!t })), a.defaultPrevented || ((i = a.detail.width), i && i !== e._lazysizesWidth && r(e, n, a, i)));
                    },
                    n = function () {
                        var t,
                            r = e.length;
                        if (r) for (t = 0; t < r; t++) a(e[t]);
                    },
                    s = N(n);
                return {
                    _: function () {
                        (e = t.getElementsByClassName(i.autosizesClass)), u("resize", s);
                    },
                    checkElems: s,
                    updateElem: a,
                };
            })(),
            M = function () {
                M.i || ((M.i = !0), L._(), P._());
            };
        return (r = { cfg: i, autoSizer: L, loader: P, init: M, uP: E, aC: v, rC: b, hC: m, fire: h, gW: w, rAF: _ });
    }
}),
    (function (e, t) {
        var r = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", r, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0);
    })(window, function (e, t, r) {
        "use strict";
        var i,
            a = (r && r.cfg) || e.lazySizesConfig,
            n = t.createElement("img"),
            s = "sizes" in n && "srcset" in n,
            o = /\s+\d+h/g,
            l = (function () {
                var e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                    r = Array.prototype.forEach;
                return function (i) {
                    var a = t.createElement("img"),
                        n = function (t) {
                            var r,
                                i = t.getAttribute(lazySizesConfig.srcsetAttr);
                            i && (i.match(e) && ((r = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1), r && t.setAttribute("data-aspectratio", r)), t.setAttribute(lazySizesConfig.srcsetAttr, i.replace(o, "")));
                        },
                        s = function (e) {
                            var t = e.target.parentNode;
                            t && "PICTURE" == t.nodeName && r.call(t.getElementsByTagName("source"), n), n(e.target);
                        },
                        l = function () {
                            a.currentSrc && t.removeEventListener("lazybeforeunveil", s);
                        };
                    i[1] && (t.addEventListener("lazybeforeunveil", s), (a.onload = l), (a.onerror = l), (a.srcset = "data:,a 1w 1h"), a.complete && l());
                };
            })();
        if (
            (a || ((a = {}), (e.lazySizesConfig = a)),
            a.supportsType ||
                (a.supportsType = function (e) {
                    return !e;
                }),
            !e.picturefill && !a.pf)
        ) {
            if (e.HTMLPictureElement && s) return t.msElementsFromPoint && l(navigator.userAgent.match(/Edge\/(\d+)/)), void (a.pf = function () {});
            (a.pf = function (t) {
                var r, a;
                if (!e.picturefill) for (r = 0, a = t.elements.length; r < a; r++) i(t.elements[r]);
            }),
                (i = (function () {
                    var n = function (e, t) {
                            return e.w - t.w;
                        },
                        l = /^\s*\d+\.*\d*px\s*$/,
                        u = function (e) {
                            var t,
                                r,
                                i = e.length,
                                a = e[i - 1],
                                n = 0;
                            for (n; n < i; n++)
                                if (((a = e[n]), (a.d = a.w / e.w), a.d >= e.d)) {
                                    !a.cached && (t = e[n - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((r = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * r), t.d + (a.d - e.d) * r > e.d && (a = t));
                                    break;
                                }
                            return a;
                        },
                        c = (function () {
                            var e,
                                t = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                                r = /\s/,
                                i = function (t, r, i, a) {
                                    e.push({ c: r, u: i, w: 1 * a });
                                };
                            return function (a) {
                                return (e = []), (a = a.trim()), a.replace(o, "").replace(t, i), e.length || !a || r.test(a) || e.push({ c: a, u: a, w: 99 }), e;
                            };
                        })(),
                        d = function () {
                            d.init ||
                                ((d.init = !0),
                                addEventListener(
                                    "resize",
                                    (function () {
                                        var e,
                                            r = t.getElementsByClassName("lazymatchmedia"),
                                            a = function () {
                                                var e, t;
                                                for (e = 0, t = r.length; e < t; e++) i(r[e]);
                                            };
                                        return function () {
                                            clearTimeout(e), (e = setTimeout(a, 66));
                                        };
                                    })()
                                ));
                        },
                        f = function (t, i) {
                            var n,
                                s = t.getAttribute("srcset") || t.getAttribute(a.srcsetAttr);
                            !s && i && (s = t._lazypolyfill ? t._lazypolyfill._set : t.getAttribute(a.srcAttr) || t.getAttribute("src")),
                                (t._lazypolyfill && t._lazypolyfill._set == s) ||
                                    ((n = c(s || "")),
                                    i && t.parentNode && ((n.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase()), n.isPicture && e.matchMedia && (r.aC(t, "lazymatchmedia"), d())),
                                    (n._set = s),
                                    Object.defineProperty(t, "_lazypolyfill", { value: n, writable: !0 }));
                        },
                        g = function (t) {
                            var i = e.devicePixelRatio || 1,
                                a = r.getX && r.getX(t);
                            return Math.min(a || i, 2.5, i);
                        },
                        p = function (t) {
                            return e.matchMedia
                                ? (p = function (e) {
                                      return !e || (matchMedia(e) || {}).matches;
                                  })(t)
                                : !t;
                        },
                        y = function (e) {
                            var t, i, s, o, c, d, y;
                            if (((o = e), f(o, !0), (c = o._lazypolyfill), c.isPicture))
                                for (i = 0, t = e.parentNode.getElementsByTagName("source"), s = t.length; i < s; i++)
                                    if (a.supportsType(t[i].getAttribute("type"), e) && p(t[i].getAttribute("media"))) {
                                        (o = t[i]), f(o), (c = o._lazypolyfill);
                                        break;
                                    }
                            return (
                                c.length > 1
                                    ? ((y = o.getAttribute("sizes") || ""), (y = (l.test(y) && parseInt(y, 10)) || r.gW(e, e.parentNode)), (c.d = g(e)), !c.src || !c.w || c.w < y ? ((c.w = y), (d = u(c.sort(n))), (c.src = d)) : (d = c.src))
                                    : (d = c[0]),
                                d
                            );
                        },
                        z = function (e) {
                            if (!s || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                                var t = y(e);
                                t && t.u && e._lazypolyfill.cur != t.u && ((e._lazypolyfill.cur = t.u), (t.cached = !0), e.setAttribute(a.srcAttr, t.u), e.setAttribute("src", t.u));
                            }
                        };
                    return (z.parse = c), z;
                })()),
                a.loadedClass &&
                    a.loadingClass &&
                    !(function () {
                        var e = [];
                        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (t) {
                            e.push(t + a.loadedClass), e.push(t + a.loadingClass);
                        }),
                            a.pf({ elements: t.querySelectorAll(e.join(", ")) });
                    })();
        }
    }),
    (function (e, t) {
        var r = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", r, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0);
    })(window, function (e, t, r) {
        "use strict";
        if (e.addEventListener) {
            var i,
                a = /^picture$/i,
                n = t.documentElement,
                s = (function () {
                    var e,
                        t = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,
                        r = function (t, r, i, a, n, s, o, l) {
                            e.push({ c: r, u: i, w: 1 * ("w" == l ? o : a) });
                        };
                    return function (i) {
                        return (e = []), i.replace(t, r), e;
                    };
                })(),
                o = (function () {
                    var e = function (e, t) {
                            return e.w - t.w;
                        },
                        t = function (t, i) {
                            var a = { srcset: t.getAttribute(r.cfg.srcsetAttr) || "" },
                                n = s(a.srcset);
                            return (
                                Object.defineProperty(t, i, { value: a, writable: !0 }),
                                (a.cands = n),
                                (a.index = 0),
                                (a.dirty = !1),
                                n[0] && n[0].w ? (n.sort(e), (a.cSrcset = [n[a.index].c])) : ((a.cSrcset = a.srcset ? [a.srcset] : []), (a.cands = [])),
                                a
                            );
                        };
                    return function (e, r) {
                        var i, n, s, o;
                        if (!e[r] && ((o = e.parentNode || {}), (e[r] = t(e, r)), (e[r].isImg = !0), a.test(o.nodeName || "")))
                            for (e[r].picture = !0, i = o.getElementsByTagName("source"), n = 0, s = i.length; n < s; n++) t(i[n], r).isImg = !1;
                        return e[r];
                    };
                })(),
                l = {
                    _lazyOptimumx: (function () {
                        var e = function (e, t, r) {
                            var i, a, n;
                            return !e || !e.d || ((n = r > 0.7 ? 0.6 : 0.4), !(e.d >= r) && ((a = Math.pow(e.d - n, 1.6) || 0.1), a < 0.1 ? (a = 0.1) : a > 3 && (a = 3), (i = e.d + (t - r) * a), i < r));
                        };
                        return function (t, r, i) {
                            var a, n;
                            for (a = 0; a < t.cands.length; a++)
                                if (((n = t.cands[a]), (n.d = (n.w || 1) / r), !(t.index >= a))) {
                                    if (!(n.d <= i || e(t.cands[a - 1], n.d, i))) break;
                                    t.cSrcset.push(n.c), (t.index = a);
                                }
                        };
                    })(),
                },
                u = (function () {
                    var e = function (e, t, r, i, a) {
                        var n,
                            s = e[a];
                        s && ((n = s.index), l[a](s, t, r), (s.dirty && n == s.index) || (s.cSrcset.join(", "), e.setAttribute(i, s.cSrcset.join(", ")), (s.dirty = !0)));
                    };
                    return function (t, r, i, a, n) {
                        var s,
                            o,
                            l,
                            u,
                            c = t[n];
                        if (((c.width = r), c.picture && (o = t.parentNode))) for (s = o.getElementsByTagName("source"), u = 0, l = s.length; u < l; u++) e(s[u], r, i, a, n);
                        e(t, r, i, a, n);
                    };
                })(),
                c = function (e) {
                    var t = e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
                    return !t && i.constrainPixelDensity && (t = "auto"), t && (t = "auto" == t ? i.getOptimumX(e) : parseFloat(t, 10)), t;
                },
                d = function () {
                    r && !r.getOptimumX && ((r.getX = c), (r.pWS = s), n.removeEventListener("lazybeforeunveil", d));
                };
            n.addEventListener("lazybeforeunveil", d),
                setTimeout(d),
                (i = (r && r.cfg) || e.lazySizesConfig),
                i || ((i = {}), (e.lazySizesConfig = i)),
                "function" != typeof i.getOptimumX &&
                    (i.getOptimumX = function () {
                        var t = e.devicePixelRatio || 1;
                        return t > 2.6 ? (t *= 0.6) : t > 1.9 ? (t *= 0.8) : (t -= 0.01), Math.min(Math.round(100 * t) / 100, 2);
                    }),
                e.devicePixelRatio &&
                    addEventListener("lazybeforesizes", function (e) {
                        if (e.detail.instance == r) {
                            var t,
                                a,
                                n,
                                s,
                                l = e.target,
                                d = e.detail,
                                f = d.dataAttr;
                            e.defaultPrevented ||
                                !(t = c(l)) ||
                                t >= devicePixelRatio ||
                                (!f || !l._lazyOptimumx || d.reloaded || (i.unloadedClass && r.hC(l, i.unloadedClass)) || (l._lazyOptimumx = null),
                                (a = o(l, "_lazyOptimumx")),
                                (n = d.width),
                                n &&
                                    (a.width || 0) < n &&
                                    ((s = f ? r.cfg.srcsetAttr : "srcset"),
                                    r.rAF(function () {
                                        u(l, n, t, s, "_lazyOptimumx");
                                    })));
                        }
                    });
        }
    }),
    (function (e, t) {
        var r = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", r, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0);
    })(window, function (e, t, r) {
        "use strict";
        if (e.addEventListener) {
            var i = /\s+/g,
                a = /\s*\|\s+|\s+\|\s*/g,
                n = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                s = /\(|\)|'/,
                o = { contain: 1, cover: 1 },
                l = function (e) {
                    var t = r.gW(e, e.parentNode);
                    return (!e._lazysizesWidth || t > e._lazysizesWidth) && (e._lazysizesWidth = t), e._lazysizesWidth;
                },
                u = function (e) {
                    var t;
                    return (t = (getComputedStyle(e) || { getPropertyValue: function () {} }).getPropertyValue("background-size")), !o[t] && o[e.style.backgroundSize] && (t = e.style.backgroundSize), t;
                },
                c = function (e, r, s) {
                    var o = t.createElement("picture"),
                        l = r.getAttribute(lazySizesConfig.sizesAttr),
                        u = r.getAttribute("data-ratio"),
                        c = r.getAttribute("data-optimumx");
                    r._lazybgset && r._lazybgset.parentNode == r && r.removeChild(r._lazybgset),
                        Object.defineProperty(s, "_lazybgset", { value: r, writable: !0 }),
                        Object.defineProperty(r, "_lazybgset", { value: o, writable: !0 }),
                        (e = e.replace(i, " ").split(a)),
                        (o.style.display = "none"),
                        (s.className = lazySizesConfig.lazyClass),
                        1 != e.length || l || (l = "auto"),
                        e.forEach(function (e) {
                            var r = t.createElement("source");
                            l && "auto" != l && r.setAttribute("sizes", l),
                                e.match(n) && (r.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && r.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                                o.appendChild(r);
                        }),
                        l && (s.setAttribute(lazySizesConfig.sizesAttr, l), r.removeAttribute(lazySizesConfig.sizesAttr), r.removeAttribute("sizes")),
                        c && s.setAttribute("data-optimumx", c),
                        u && s.setAttribute("data-ratio", u),
                        o.appendChild(s),
                        r.appendChild(o);
                },
                d = function (e) {
                    if (e.target._lazybgset) {
                        var t = e.target,
                            i = t._lazybgset,
                            a = t.currentSrc || t.src;
                        a && (i.style.backgroundImage = "url(" + (s.test(a) ? JSON.stringify(a) : a) + ")"), t._lazybgsetLoading && (r.fire(i, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading);
                    }
                };
            addEventListener("lazybeforeunveil", function (e) {
                var i, a, n;
                !e.defaultPrevented &&
                    (i = e.target.getAttribute("data-bgset")) &&
                    ((n = e.target),
                    (a = t.createElement("img")),
                    (a.alt = ""),
                    (a._lazybgsetLoading = !0),
                    (e.detail.firesLoad = !0),
                    c(i, n, a),
                    setTimeout(function () {
                        r.loader.unveil(a),
                            r.rAF(function () {
                                r.fire(a, "_lazyloaded", {}, !0, !0), a.complete && d({ target: a });
                            });
                    }));
            }),
                t.addEventListener("load", d, !0),
                e.addEventListener(
                    "lazybeforesizes",
                    function (e) {
                        if (e.detail.instance == r && e.target._lazybgset && e.detail.dataAttr) {
                            var t = e.target._lazybgset,
                                i = u(t);
                            o[i] &&
                                ((e.target._lazysizesParentFit = i),
                                r.rAF(function () {
                                    e.target.setAttribute("data-parent-fit", i), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                                }));
                        }
                    },
                    !0
                ),
                t.documentElement.addEventListener("lazybeforesizes", function (e) {
                    !e.defaultPrevented && e.target._lazybgset && e.detail.instance == r && (e.detail.width = l(e.target._lazybgset));
                });
        }
    }),
    (function (e, t) {
        var r = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", r, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0);
    })(window, function (e, t, r) {
        "use strict";
        function i(t, r) {
            var i,
                a,
                n,
                s,
                o = e.getComputedStyle(t);
            (a = t.parentNode),
                (s = { isPicture: !(!a || !f.test(a.nodeName || "")) }),
                (n = function (e, r) {
                    var i = t.getAttribute("data-" + e);
                    if (!i) {
                        var a = o.getPropertyValue("--ls-" + e);
                        a && (i = a.trim());
                    }
                    if (i) {
                        if ("true" == i) i = !0;
                        else if ("false" == i) i = !1;
                        else if (d.test(i)) i = parseFloat(i);
                        else if ("function" == typeof u[e]) i = u[e](t, i);
                        else if (z.test(i))
                            try {
                                i = JSON.parse(i);
                            } catch (n) {}
                        s[e] = i;
                    } else e in u && "function" != typeof u[e] ? (s[e] = u[e]) : r && "function" == typeof u[e] && (s[e] = u[e](t, i));
                });
            for (i in u) n(i);
            return (
                r.replace(y, function (e, t) {
                    t in s || n(t, !0);
                }),
                s
            );
        }
        function a(e, t) {
            var r = [],
                i = function (e, r) {
                    return c[typeof t[r]] ? t[r] : e;
                };
            return (
                (r.srcset = []),
                t.absUrl && (v.setAttribute("href", e), (e = v.href)),
                (e = ((t.prefix || "") + e + (t.postfix || "")).replace(y, i)),
                t.widths.forEach(function (i) {
                    var a = t.widthmap[i] || i,
                        n = { u: e.replace(g, a).replace(p, t.ratio ? Math.round(i * t.ratio) : ""), w: i };
                    r.push(n), r.srcset.push((n.c = n.u + " " + i + "w"));
                }),
                r
            );
        }
        function n(e, r, i) {
            var n = 0,
                s = 0,
                o = i;
            if (e) {
                if ("container" === r.ratio) {
                    for (n = o.scrollWidth, s = o.scrollHeight; !((n && s) || o === t); ) (o = o.parentNode), (n = o.scrollWidth), (s = o.scrollHeight);
                    n && s && (r.ratio = s / n);
                }
                (e = a(e, r)),
                    (e.isPicture = r.isPicture),
                    A && "IMG" == i.nodeName.toUpperCase() ? i.removeAttribute(l.srcsetAttr) : i.setAttribute(l.srcsetAttr, e.srcset.join(", ")),
                    Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
            }
        }
        function s(e, t) {
            var a = i(e, t);
            return u.modifyOptions.call(e, { target: e, details: a, detail: a }), r.fire(e, "lazyriasmodifyoptions", a), a;
        }
        function o(e) {
            return e.getAttribute(e.getAttribute("data-srcattr") || u.srcAttr) || e.getAttribute(l.srcsetAttr) || e.getAttribute(l.srcAttr) || e.getAttribute("data-pfsrcset") || "";
        }
        var l,
            u,
            c = { string: 1, number: 1 },
            d = /^\-*\+*\d+\.*\d*$/,
            f = /^picture$/i,
            g = /\s*\{\s*width\s*\}\s*/i,
            p = /\s*\{\s*height\s*\}\s*/i,
            y = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
            z = /^\[.*\]|\{.*\}$/,
            m = /^(?:auto|\d+(px)?)$/,
            v = t.createElement("a"),
            b = t.createElement("img"),
            A = "srcset" in b && !("sizes" in b),
            h = !!e.HTMLPictureElement && !A;
        !(function () {
            var t,
                i = function () {},
                a = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: i, widthmap: {}, ratio: !1 };
            (l = (r && r.cfg) || e.lazySizesConfig),
                l || ((l = {}), (e.lazySizesConfig = l)),
                l.supportsType ||
                    (l.supportsType = function (e) {
                        return !e;
                    }),
                l.rias || (l.rias = {}),
                (u = l.rias),
                "widths" in u ||
                    ((u.widths = []),
                    (function (e) {
                        for (var t, r = 0; !t || t < 3e3; ) (r += 5), r > 30 && (r += 1), (t = 36 * r), e.push(t);
                    })(u.widths));
            for (t in a) t in u || (u[t] = a[t]);
        })(),
            addEventListener(
                "lazybeforesizes",
                function (e) {
                    if (e.detail.instance == r) {
                        var t, i, a, c, d, f, p, y, z, v, b, A, C;
                        if (((t = e.target), e.detail.dataAttr && !e.defaultPrevented && !u.disabled && (z = t.getAttribute(l.sizesAttr) || t.getAttribute("sizes")) && m.test(z))) {
                            if (((i = o(t)), (a = s(t, i)), (b = g.test(a.prefix) || g.test(a.postfix)), a.isPicture && (c = t.parentNode)))
                                for (d = c.getElementsByTagName("source"), f = 0, p = d.length; f < p; f++) (b || g.test((y = o(d[f])))) && (n(y, a, d[f]), (A = !0));
                            b || g.test(i) ? (n(i, a, t), (A = !0)) : A && ((C = []), (C.srcset = []), (C.isPicture = !0), Object.defineProperty(t, "_lazyrias", { value: C, writable: !0 })),
                                A && (h ? t.removeAttribute(l.srcAttr) : "auto" != z && ((v = { width: parseInt(z, 10) }), E({ target: t, detail: v })));
                        }
                    }
                },
                !0
            );
        var E = (function () {
            var i = function (e, t) {
                    return e.w - t.w;
                },
                a = function (e) {
                    var t,
                        r,
                        i = e.length,
                        a = e[i - 1],
                        n = 0;
                    for (n; n < i; n++)
                        if (((a = e[n]), (a.d = a.w / e.w), a.d >= e.d)) {
                            !a.cached && (t = e[n - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((r = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * r), t.d + (a.d - e.d) * r > e.d && (a = t));
                            break;
                        }
                    return a;
                },
                n = function (e, t) {
                    var i;
                    return (
                        !e._lazyrias &&
                            r.pWS &&
                            (i = r.pWS(e.getAttribute(l.srcsetAttr || ""))).length &&
                            (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }), t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
                        e._lazyrias
                    );
                },
                s = function (t) {
                    var i = e.devicePixelRatio || 1,
                        a = r.getX && r.getX(t);
                    return Math.min(a || i, 2.4, i);
                },
                o = function (t, r) {
                    var o, l, u, c, d, f;
                    if (((d = t._lazyrias), d.isPicture && e.matchMedia))
                        for (l = 0, o = t.parentNode.getElementsByTagName("source"), u = o.length; l < u; l++)
                            if (n(o[l]) && !o[l].getAttribute("type") && (!(c = o[l].getAttribute("media")) || (matchMedia(c) || {}).matches)) {
                                d = o[l]._lazyrias;
                                break;
                            }
                    return (!d.w || d.w < r) && ((d.w = r), (d.d = s(t)), (f = a(d.sort(i)))), f;
                },
                u = function (i) {
                    if (i.detail.instance == r) {
                        var a,
                            s = i.target;
                        return !A && (e.respimage || e.picturefill || lazySizesConfig.pf)
                            ? void t.removeEventListener("lazybeforesizes", u)
                            : void (
                                  ("_lazyrias" in s || (i.detail.dataAttr && n(s, !0))) &&
                                  ((a = o(s, i.detail.width)),
                                  a &&
                                      a.u &&
                                      s._lazyrias.cur != a.u &&
                                      ((s._lazyrias.cur = a.u),
                                      (a.cached = !0),
                                      r.rAF(function () {
                                          s.setAttribute(l.srcAttr, a.u), s.setAttribute("src", a.u);
                                      })))
                              );
                    }
                };
            return h ? (u = function () {}) : addEventListener("lazybeforesizes", u), u;
        })();
    }),
    (function (e, t) {
        var r = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", r, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0);
    })(window, function (e, t, r) {
        "use strict";
        function i(e, r) {
            if (!s[e]) {
                var i = t.createElement(r ? "link" : "script"),
                    a = t.getElementsByTagName("script")[0];
                r ? ((i.rel = "stylesheet"), (i.href = e)) : (i.src = e), (s[e] = !0), (s[i.src || i.href] = !0), a.parentNode.insertBefore(i, a);
            }
        }
        var a,
            n,
            s = {};
        t.addEventListener &&
            ((n = /\(|\)|\s|'/),
            (a = function (e, r) {
                var i = t.createElement("img");
                (i.onload = function () {
                    (i.onload = null), (i.onerror = null), (i = null), r();
                }),
                    (i.onerror = i.onload),
                    (i.src = e),
                    i && i.complete && i.onload && i.onload();
            }),
            addEventListener(
                "lazybeforeunveil",
                function (e) {
                    if (e.detail.instance == r) {
                        var t, s, o, l;
                        e.defaultPrevented ||
                            ("none" == e.target.preload && (e.target.preload = "auto"),
                            (t = e.target.getAttribute("data-link")),
                            t && i(t, !0),
                            (t = e.target.getAttribute("data-script")),
                            t && i(t),
                            (t = e.target.getAttribute("data-require")),
                            t && (r.cfg.requireJs ? r.cfg.requireJs([t]) : i(t)),
                            (o = e.target.getAttribute("data-bg")),
                            o &&
                                ((e.detail.firesLoad = !0),
                                (s = function () {
                                    (e.target.style.backgroundImage = "url(" + (n.test(o) ? JSON.stringify(o) : o) + ")"), (e.detail.firesLoad = !1), r.fire(e.target, "_lazyloaded", {}, !0, !0);
                                }),
                                a(o, s)),
                            (l = e.target.getAttribute("data-poster")),
                            l &&
                                ((e.detail.firesLoad = !0),
                                (s = function () {
                                    (e.target.poster = l), (e.detail.firesLoad = !1), r.fire(e.target, "_lazyloaded", {}, !0, !0);
                                }),
                                a(l, s)));
                    }
                },
                !1
            ));
    }),
    (function (e, t) {
        var r = function (i) {
            t(e.lazySizes, i), e.removeEventListener("lazyunveilread", r, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0);
    })(window, function (e, t, r, i) {
        "use strict";
        function a(e) {
            var t = getComputedStyle(e, null) || {},
                r = t.fontFamily || "",
                i = r.match(u) || "",
                a = (i && r.match(c)) || "";
            return a && (a = a[1]), { fit: (i && i[1]) || "", position: g[a] || a || "center" };
        }
        function n(e, t) {
            var i,
                a,
                n = r.cfg,
                s = e.cloneNode(!1),
                o = s.style,
                l = function () {
                    var t = e.currentSrc || e.src;
                    t && a !== t && ((a = t), (o.backgroundImage = "url(" + (f.test(t) ? JSON.stringify(t) : t) + ")"), i || ((i = !0), r.rC(s, n.loadingClass), r.aC(s, n.loadedClass)));
                },
                u = function () {
                    r.rAF(l);
                };
            (e._lazysizesParentFit = t.fit),
                e.addEventListener("lazyloaded", u, !0),
                e.addEventListener("load", u, !0),
                s.addEventListener("load", function () {
                    var e = s.currentSrc || s.src;
                    e && e != d && ((s.src = d), (s.srcset = ""));
                }),
                r.rAF(function () {
                    var i = e,
                        a = e.parentNode;
                    "PICTURE" == a.nodeName.toUpperCase() && ((i = a), (a = a.parentNode)),
                        r.rC(s, n.loadedClass),
                        r.rC(s, n.lazyClass),
                        r.aC(s, n.loadingClass),
                        r.aC(s, n.objectFitClass || "lazysizes-display-clone"),
                        s.getAttribute(n.srcsetAttr) && s.setAttribute(n.srcsetAttr, ""),
                        s.getAttribute(n.srcAttr) && s.setAttribute(n.srcAttr, ""),
                        (s.src = d),
                        (s.srcset = ""),
                        (o.backgroundRepeat = "no-repeat"),
                        (o.backgroundPosition = t.position),
                        (o.backgroundSize = t.fit),
                        (i.style.display = "none"),
                        e.setAttribute("data-parent-fit", t.fit),
                        e.setAttribute("data-parent-container", "prev"),
                        a.insertBefore(s, i),
                        e._lazysizesParentFit && delete e._lazysizesParentFit,
                        e.complete && l();
                });
        }
        var s = t.createElement("a").style,
            o = "objectFit" in s,
            l = o && "objectPosition" in s,
            u = /object-fit["']*\s*:\s*["']*(contain|cover)/,
            c = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
            d = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
            f = /\(|\)|'/,
            g = { center: "center", "50% 50%": "center" };
        if (!o || !l) {
            var p = function (e) {
                if (e.detail.instance == r) {
                    var t = e.target,
                        i = a(t);
                    !i.fit || (o && "center" == i.position) || n(t, i);
                }
            };
            e.addEventListener("lazyunveilread", p, !0), i && i.detail && p(i);
        }
    });
!(function (e) {
    "function" == typeof define && define.amd ? define("index", e) : e();
})(function () {
    "use strict";
    function e(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function t(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    function i(e, i, n) {
        return i && t(e.prototype, i), n && t(e, n), e;
    }
    function n(e) {
        return (n = Object.setPrototypeOf
            ? Object.getPrototypeOf
            : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
              })(e);
    }
    function o(e, t) {
        return (o =
            Object.setPrototypeOf ||
            function (e, t) {
                return (e.__proto__ = t), e;
            })(e, t);
    }
    function a() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
            return !1;
        }
    }
    function s(e, t, i) {
        return (s = a()
            ? Reflect.construct
            : function (e, t, i) {
                  var n = [null];
                  n.push.apply(n, t);
                  var a = new (Function.bind.apply(e, n))();
                  return i && o(a, i.prototype), a;
              }).apply(null, arguments);
    }
    function r(e) {
        var t = "function" == typeof Map ? new Map() : void 0;
        return (r = function (e) {
            if (null === e || ((i = e), -1 === Function.toString.call(i).indexOf("[native code]"))) return e;
            var i;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, a);
            }
            function a() {
                return s(e, arguments, n(this).constructor);
            }
            return (a.prototype = Object.create(e.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } })), o(a, e);
        })(e);
    }
    function l(e, t) {
        return !t || ("object" != typeof t && "function" != typeof t)
            ? (function (e) {
                  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return e;
              })(e)
            : t;
    }
    var c = (function () {
            function t() {
                var i = this;
                e(this, t),
                    (this.currentBreakpoint = t.getCurrentBreakpoint()),
                    window.addEventListener("resize", function () {
                        var e = t.getCurrentBreakpoint();
                        i.currentBreakpoint !== e && (document.dispatchEvent(new CustomEvent("breakpoint:changed", { detail: { previousBreakpoint: i.currentBreakpoint, currentBreakpoint: e } })), (i.currentBreakpoint = e));
                    });
            }
            return (
                i(t, null, [
                    {
                        key: "matchesBreakpoint",
                        value: function (e) {
                            switch (e) {
                                case "phone":
                                    return window.matchMedia("screen and (max-width: 640px)").matches;
                                case "tablet":
                                    return window.matchMedia("screen and (min-width: 641px) and (max-width: 1007px)").matches;
                                case "tablet-and-up":
                                    return window.matchMedia("screen and (min-width: 641px)").matches;
                                case "pocket":
                                    return window.matchMedia("screen and (max-width: 1007px)").matches;
                                case "lap":
                                    return window.matchMedia("screen and (min-width: 1008px) and (max-width: 1279px)").matches;
                                case "lap-and-up":
                                    return window.matchMedia("screen and (min-width: 1008px)").matches;
                                case "desk":
                                    return window.matchMedia("screen and (min-width: 1280px)").matches;
                                case "widescreen":
                                    return window.matchMedia("screen and (min-width: 1600px)").matches;
                                case "supports-hover":
                                    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
                            }
                        },
                    },
                    {
                        key: "getCurrentBreakpoint",
                        value: function () {
                            return window.matchMedia("screen and (max-width: 640px)").matches
                                ? "phone"
                                : window.matchMedia("screen and (min-width: 641px) and (max-width: 1007px)").matches
                                ? "tablet"
                                : window.matchMedia("screen and (min-width: 1008px) and (max-width: 1279px)").matches
                                ? "lap"
                                : window.matchMedia("screen and (min-width: 1280px)").matches
                                ? "desk"
                                : void 0;
                        },
                    },
                ]),
                t
            );
        })(),
        d = (function () {
            function t(i) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                e(this, t), (this.element = i), (this.initialConfig = Object.assign(JSON.parse(i.getAttribute("data-flickity-config")), o)), (this.options = n), this._attachListeners(), this._build();
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.flickityInstance.destroy(), void 0 !== this.initialConfig.breakpoints && document.removeEventListener("breakpoint:changed", this._onBreakpointChangedListener);
                        },
                    },
                    {
                        key: "getFlickityInstance",
                        value: function () {
                            return this.flickityInstance;
                        },
                    },
                    {
                        key: "selectCell",
                        value: function (e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                                i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                            t && this.flickityInstance.pausePlayer(), this.flickityInstance.select(e, !1, !i);
                        },
                    },
                    {
                        key: "next",
                        value: function () {
                            this.flickityInstance.next();
                        },
                    },
                    {
                        key: "previous",
                        value: function () {
                            this.flickityInstance.previous();
                        },
                    },
                    {
                        key: "pausePlayer",
                        value: function () {
                            this.flickityInstance.pausePlayer();
                        },
                    },
                    {
                        key: "unpausePlayer",
                        value: function () {
                            this.flickityInstance.unpausePlayer();
                        },
                    },
                    {
                        key: "resize",
                        value: function () {
                            this.flickityInstance.resize();
                        },
                    },
                    {
                        key: "getSelectedIndex",
                        value: function () {
                            return this.flickityInstance.selectedIndex;
                        },
                    },
                    {
                        key: "getSelectedCell",
                        value: function () {
                            return this.flickityInstance.selectedCell.element;
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            void 0 !== this.initialConfig.breakpoints && ((this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this)), document.addEventListener("breakpoint:changed", this._onBreakpointChangedListener));
                        },
                    },
                    {
                        key: "_build",
                        value: function () {
                            var e = this,
                                t = this._processConfig();
                            (this.flickityInstance = new Flickity(this.element, t)),
                                this._validateDraggable(),
                                (this.selectedIndex = this.flickityInstance.selectedIndex),
                                this.flickityInstance.on("resize", this._validateDraggable.bind(this)),
                                this.options.onSelect &&
                                    this.flickityInstance.on("select", function () {
                                        e.selectedIndex !== e.flickityInstance.selectedIndex &&
                                            (e.options.onSelect(e.flickityInstance.selectedIndex, e.flickityInstance.selectedCell.element), (e.selectedIndex = e.flickityInstance.selectedIndex));
                                    }),
                                this.options.onSettle &&
                                    this.flickityInstance.on("settle", function (t) {
                                        e.options.onSettle(t, e.flickityInstance.selectedCell.element);
                                    }),
                                this.options.onClick &&
                                    this.flickityInstance.on("staticClick", function (t, i, n, o) {
                                        e.options.onClick(n, o);
                                    });
                        },
                    },
                    {
                        key: "_validateDraggable",
                        value: function () {
                            (this.flickityInstance.isActive || !1) &&
                                this.flickityInstance.options.draggable &&
                                (void 0 === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length
                                    ? this.flickityInstance.unbindDrag()
                                    : this.flickityInstance.bindDrag());
                        },
                    },
                    {
                        key: "_processConfig",
                        value: function () {
                            var e = Object.assign({}, this.initialConfig);
                            return (
                                delete e.breakpoints,
                                void 0 === this.initialConfig.breakpoints
                                    ? e
                                    : (this.initialConfig.breakpoints.forEach(function (t) {
                                          c.matchesBreakpoint(t.matches) && (e = Object.assign(e, t.settings));
                                      }),
                                      e)
                            );
                        },
                    },
                    {
                        key: "_onBreakpointChanged",
                        value: function () {
                            this.flickityInstance.destroy(), this._build();
                        },
                    },
                ]),
                t
            );
        })(),
        u = (function () {
            function t() {
                e(this, t);
            }
            return (
                i(t, null, [
                    {
                        key: "slideUp",
                        value: function (e) {
                            (e.style.height = "".concat(e.scrollHeight, "px")), e.offsetHeight, (e.style.height = 0);
                        },
                    },
                    {
                        key: "slideDown",
                        value: function (e) {
                            if ("auto" !== e.style.height) {
                                e.style.height = "".concat(e.firstElementChild.scrollHeight, "px");
                                e.addEventListener("transitionend", function t(i) {
                                    "height" === i.propertyName && ((e.style.height = "auto"), e.removeEventListener("transitionend", t));
                                });
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        h = (function () {
            function t() {
                e(this, t);
            }
            return (
                i(t, null, [
                    {
                        key: "getSiblings",
                        value: function (e, t) {
                            for (var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = [], o = e; (o = o.previousElementSibling); ) (t && !o.matches(t)) || n.push(o);
                            for (i && n.push(e), o = e; (o = o.nextElementSibling); ) (t && !o.matches(t)) || n.push(o);
                            return n;
                        },
                    },
                    {
                        key: "nodeListToArray",
                        value: function (e, t) {
                            for (var i = [], n = 0; n !== e.length; ++n) (t && !e[n].matches(t)) || i.push(e[n]);
                            return i;
                        },
                    },
                    {
                        key: "outerWidthWithMargin",
                        value: function (e) {
                            var t = e.offsetWidth,
                                i = getComputedStyle(e);
                            return (t += parseInt(i.marginLeft) + parseInt(i.marginRight));
                        },
                    },
                    {
                        key: "outerHeightWithMargin",
                        value: function (e) {
                            var t = e.offsetHeight,
                                i = getComputedStyle(e);
                            return (t += parseInt(i.marginTop) + parseInt(i.marginBottom));
                        },
                    },
                ]),
                t
            );
        })(),
        p = (function () {
            function t() {
                e(this, t), (this.domDelegate = new domDelegate.Delegate(document.body)), this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.domDelegate.on("click", '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
                        },
                    },
                    {
                        key: "_toggleCollapsible",
                        value: function (e, t) {
                            var i = this,
                                n = t.closest(".Collapsible");
                            (n.classList.contains("Collapsible--autoExpand") && c.matchesBreakpoint("tablet-and-up")) ||
                                ("true" === t.getAttribute("aria-expanded") ? this._close(n, t) : this._open(n, t),
                                h.getSiblings(n).forEach(function (e) {
                                    return i._close(e);
                                }),
                                e.preventDefault());
                        },
                    },
                    {
                        key: "_open",
                        value: function (e) {
                            var t = e.querySelector(".Collapsible__Button"),
                                i = e.querySelector(".Collapsible__Inner");
                            i &&
                                "true" !== t.getAttribute("aria-expanded") &&
                                (t.setAttribute("aria-expanded", "true"),
                                (i.style.overflow = "visible"),
                                u.slideDown(i),
                                setTimeout(function () {
                                    e.style.overflow = "visible";
                                }, 350));
                        },
                    },
                    {
                        key: "_close",
                        value: function (e) {
                            var t = e.querySelector(".Collapsible__Button"),
                                i = e.querySelector(".Collapsible__Inner");
                            i && "false" !== t.getAttribute("aria-expanded") && (t.setAttribute("aria-expanded", "false"), (i.style.overflow = "hidden"), (e.style.overflow = "hidden"), u.slideUp(i));
                        },
                    },
                ]),
                t
            );
        })(),
        m = (function () {
            function t() {
                e(this, t);
            }
            return (
                i(t, null, [
                    {
                        key: "trapFocus",
                        value: function (e, t) {
                            this.listeners = this.listeners || {};
                            var i = e.querySelector("[autofocus]") || e;
                            e.setAttribute("tabindex", "-1"),
                                i.focus(),
                                (this.listeners[t] = function (t) {
                                    e === t.target || e.contains(t.target) || e.focus();
                                }),
                                document.addEventListener("focusin", this.listeners[t]);
                        },
                    },
                    {
                        key: "removeTrapFocus",
                        value: function (e, t) {
                            e && e.removeAttribute("tabindex"), this.listeners && this.listeners[t] && document.removeEventListener("focusin", this.listeners[t]);
                        },
                    },
                    {
                        key: "clearTrapFocus",
                        value: function () {
                            for (var e in this.listeners) this.listeners.hasOwnProperty(e) && document.removeEventListener("focusin", this.listeners[e]);
                            this.listeners = {};
                        },
                    },
                ]),
                t
            );
        })(),
        v = (function () {
            function t(i) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.delegateBody = new domDelegate.Delegate(document.body)),
                    (this.onOpen = n.onOpen || function () {}),
                    (this.onClose = n.onClose || function () {}),
                    (this.isOpen = !1),
                    (this.direction = this.element.classList.contains("Drawer--fromLeft") ? "fromLeft" : "fromRight"),
                    (this.pageOverlayElement = document.querySelector(".PageOverlay")),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateBody.off("click", '[data-action="open-drawer"][data-drawer-id="'.concat(this.element.id, '"]')),
                                this.delegateBody.off("click", '[data-action="close-drawer"][data-drawer-id="'.concat(this.element.id, '"]')),
                                window.removeEventListener("resize", this._calculateMaxHeightListener);
                        },
                    },
                    {
                        key: "toggle",
                        value: function () {
                            this.isOpen ? this.close() : this.open();
                        },
                    },
                    {
                        key: "open",
                        value: function (e) {
                            if (!this.isOpen)
                                return (
                                    this.element.dispatchEvent(new CustomEvent("search:close", { bubbles: !0 })),
                                    e && e.preventDefault(),
                                    this.element.setAttribute("aria-hidden", "false"),
                                    this._calculateMaxHeight(),
                                    document.documentElement.classList.add("no-scroll"),
                                    m.trapFocus(this.element, "drawer"),
                                    (document.querySelector("#shopify-section-header").style.zIndex = ""),
                                    this.pageOverlayElement.classList.add("is-visible"),
                                    this.pageOverlayElement.addEventListener("click", this._closeListener),
                                    (this.isOpen = !0),
                                    this.onOpen(),
                                    !1
                                );
                        },
                    },
                    {
                        key: "close",
                        value: function (e) {
                            this.isOpen &&
                                (e && e.preventDefault(),
                                this.element.setAttribute("aria-hidden", "true"),
                                document.documentElement.classList.remove("no-scroll"),
                                m.removeTrapFocus(this.element, "drawer"),
                                this.pageOverlayElement.classList.remove("is-visible"),
                                this.pageOverlayElement.removeEventListener("click", this._closeListener),
                                (this.isOpen = !1),
                                this.onClose());
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._openListener = this.open.bind(this)),
                                (this._closeListener = this.close.bind(this)),
                                (this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this)),
                                this.delegateBody.on("click", '[data-action="open-drawer"][data-drawer-id="'.concat(this.element.id, '"]'), this._openListener),
                                this.delegateBody.on("click", '[data-action="close-drawer"][data-drawer-id="'.concat(this.element.id, '"]'), this._closeListener),
                                this.element.addEventListener("keyup", this._handleKeyboard.bind(this)),
                                window.addEventListener("resize", this._calculateMaxHeightListener);
                        },
                    },
                    {
                        key: "_calculateMaxHeight",
                        value: function () {
                            this.element.style.maxHeight = window.innerHeight + "px";
                        },
                    },
                    {
                        key: "_handleKeyboard",
                        value: function (e) {
                            this.isOpen && 27 === e.keyCode && this.close();
                        },
                    },
                ]),
                t
            );
        })(),
        f = (function () {
            function t() {
                e(this, t),
                    (this.element = document.querySelector(".LoadingBar")),
                    document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this)),
                    document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this)),
                    this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this));
            }
            return (
                i(t, [
                    {
                        key: "_onLoadingStart",
                        value: function () {
                            this.element.classList.add("is-visible"), (this.element.style.width = "40%");
                        },
                    },
                    {
                        key: "_onLoadingEnd",
                        value: function () {
                            (this.element.style.width = "100%"), this.element.classList.add("is-finished");
                        },
                    },
                    {
                        key: "_onTransitionEnd",
                        value: function (e) {
                            "width" === e.propertyName && this.element.classList.contains("is-finished") && (this.element.classList.remove("is-visible"), this.element.classList.remove("is-finished"), (this.element.style.width = "0"));
                        },
                    },
                ]),
                t
            );
        })(),
        y = (function () {
            function t() {
                e(this, t),
                    (this.domDelegate = new domDelegate.Delegate(document.body)),
                    (this.activeModal = null),
                    (this.wasLocked = !1),
                    (this.pageOverlayElement = document.querySelector(".PageOverlay")),
                    this._attachListeners(),
                    this._checkOpenByHash();
            }
            return (
                i(t, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._closeListener = this._closeModal.bind(this)),
                                (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                                this.domDelegate.on("click", '[data-action="open-modal"]', this._openModalEvent.bind(this)),
                                this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this));
                        },
                    },
                    {
                        key: "_openModalEvent",
                        value: function (e, t) {
                            this._openModal(document.getElementById(t.getAttribute("aria-controls"))), e.preventDefault(), e.stopPropagation();
                        },
                    },
                    {
                        key: "_openModal",
                        value: function (e) {
                            var t = this;
                            !this.activeModal &&
                                e &&
                                ((this.activeModal = e),
                                this.domDelegate.on("keyup", this._handleKeyboardListener),
                                document.documentElement.classList.contains("no-scroll") && (this.wasLocked = !0),
                                fastdom.mutate(function () {
                                    m.clearTrapFocus(),
                                        (t._onTransitionEndedListener = t._onTransitionEnded.bind(t)),
                                        t.activeModal.addEventListener("transitionend", t._onTransitionEndedListener),
                                        t.activeModal.setAttribute("aria-hidden", "false"),
                                        document.documentElement.classList.add("no-scroll"),
                                        t.activeModal.classList.contains("Modal--fullScreen") || (t.pageOverlayElement.classList.add("is-visible"), t.pageOverlayElement.addEventListener("click", t._closeListener));
                                }));
                        },
                    },
                    {
                        key: "_closeModal",
                        value: function () {
                            var e = this;
                            this.activeModal &&
                                (this.activeModal.removeEventListener("keyup", this._handleKeyboardListener),
                                this.domDelegate.off("keyup"),
                                fastdom.mutate(function () {
                                    e.activeModal.classList.contains("Modal--videoContent") && ((e._resetVideoListener = e._resetVideo.bind(e)), e.activeModal.addEventListener("transitionend", e._resetVideoListener)),
                                        m.removeTrapFocus(e.activeModal, "modal"),
                                        e.activeModal.classList.contains("Modal--fullScreen") || (e.pageOverlayElement.classList.remove("is-visible"), e.pageOverlayElement.removeEventListener("click", e._closeListener)),
                                        e.activeModal.setAttribute("aria-hidden", "true"),
                                        (e.activeModal = null),
                                        e.wasLocked || document.documentElement.classList.remove("no-scroll");
                                }));
                        },
                    },
                    {
                        key: "_onTransitionEnded",
                        value: function (e) {
                            "visibility" === e.propertyName && (m.trapFocus(this.activeModal, "modal"), this.activeModal.removeEventListener("transitionend", this._onTransitionEndedListener));
                        },
                    },
                    {
                        key: "_resetVideo",
                        value: function (e) {
                            if ("visibility" === e.propertyName) {
                                var t = e.target.querySelector("iframe");
                                (t.parentNode.innerHTML = '<iframe class="Image--lazyLoad" data-src='.concat(t.getAttribute("data-src"), ' frameborder="0" allowfullscreen>')),
                                    e.target.removeEventListener("transitionend", this._resetVideoListener);
                            }
                        },
                    },
                    {
                        key: "_checkOpenByHash",
                        value: function () {
                            var e = window.location.hash,
                                t = document.getElementById(e.replace("#", ""));
                            t && t.classList.contains("Modal") && this._openModal(t);
                        },
                    },
                    {
                        key: "_handleKeyboard",
                        value: function (e) {
                            null !== this.activeModal && 27 === e.keyCode && this._closeModal();
                        },
                    },
                ]),
                t
            );
        })(),
        g = (function () {
            function t(i, n) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.activator = n.activator || document.querySelector('[aria-controls="'.concat(i.getAttribute("id"), '"]'))),
                    (this.preferredPosition = n.preferredPosition || "bottom"),
                    (this.preferredAlignment = n.preferredAlignment || void 0),
                    (this.threshold = n.threshold || 20),
                    (this.isOpen = !1),
                    (this.onValueChanged = n.onValueChanged || function () {}),
                    (this.onOpen = n.onOpen || function () {}),
                    (this.onClose = n.onClose || function () {}),
                    (this.showOverlay = void 0 === n.showOverlay || n.showOverlay),
                    (this.pageOverlayElement = document.querySelector(".PageOverlay")),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.element.removeEventListener("keyup", this._handleKeyboardListener), this.delegateElement.off("click"), this.activator.removeEventListener("click", this._toggleListener);
                        },
                    },
                    {
                        key: "toggle",
                        value: function () {
                            this.isOpen ? this.close() : this.open();
                        },
                    },
                    {
                        key: "open",
                        value: function () {
                            var e = this;
                            this.isOpen ||
                                this.activator.getAttribute("aria-controls") !== this.element.id ||
                                (this.element.setAttribute("aria-hidden", "false"),
                                this.activator.setAttribute("aria-expanded", "true"),
                                disableBodyScroll(!0, "[data-scrollable]"),
                                document.documentElement.classList.add("no-scroll"),
                                c.matchesBreakpoint("lap-and-up")
                                    ? (document.body.addEventListener("click", this._clickOutsideListener),
                                      this._position(),
                                      this.element.setAttribute("tabindex", "-1"),
                                      this.element.addEventListener(
                                          "transitionend",
                                          function () {
                                              e.element.focus();
                                          },
                                          { once: !0 }
                                      ))
                                    : (this.element.removeAttribute("style"), this.showOverlay && (this.pageOverlayElement.classList.add("is-visible"), this.pageOverlayElement.addEventListener("click", this._closeListener))),
                                this.onOpen(this),
                                (this.isOpen = !0));
                        },
                    },
                    {
                        key: "close",
                        value: function () {
                            this.isOpen &&
                                (this.element.setAttribute("aria-hidden", "true"),
                                this.activator.setAttribute("aria-expanded", "false"),
                                disableBodyScroll(!1, "[data-scrollable]"),
                                document.documentElement.classList.remove("no-scroll"),
                                c.matchesBreakpoint("lap-and-up")
                                    ? document.body.removeEventListener("click", this._clickOutsideListener)
                                    : this.showOverlay && (this.pageOverlayElement.classList.remove("is-visible"), this.pageOverlayElement.removeEventListener("click", this._closeListener)),
                                this.element.removeAttribute("tabindex"),
                                this.activator.focus(),
                                this.onClose(this),
                                (this.isOpen = !1));
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                                (this._clickOutsideListener = this._clickOutside.bind(this)),
                                (this._closeListener = this.close.bind(this)),
                                (this._toggleListener = this.toggle.bind(this)),
                                this.element.addEventListener("keyup", this._handleKeyboardListener),
                                this.activator.addEventListener("click", this._toggleListener),
                                this.delegateElement.on("click", '[data-action="close-popover"]', this.close.bind(this)),
                                this.delegateElement.on("click", '[data-action="select-value"]', this._valueChanged.bind(this)),
                                this.element.hasAttribute("id") && this.delegateElement.on("focusout", "#".concat(this.element.getAttribute("id")), this._onFocusOut.bind(this));
                        },
                    },
                    {
                        key: "_valueChanged",
                        value: function (e) {
                            h.getSiblings(e.target, ".is-selected").forEach(function (e) {
                                return e.classList.remove("is-selected");
                            }),
                                e.target.classList.add("is-selected"),
                                this.onValueChanged(e.target.getAttribute("data-value"), e.target, this.activator),
                                this.close();
                        },
                    },
                    {
                        key: "_onFocusOut",
                        value: function (e) {
                            this.element.contains(e.relatedTarget) || e.relatedTarget === this.activator || this.close();
                        },
                    },
                    {
                        key: "_clickOutside",
                        value: function (e) {
                            e.target.closest(".Popover") || e.target.closest(".Modal") || e.target === this.activator || this.activator.contains(e.target) || this.close();
                        },
                    },
                    {
                        key: "_position",
                        value: function () {
                            var e = this,
                                t = 0,
                                i = 0,
                                n = "",
                                o = "",
                                a = this.threshold;
                            fastdom.measure(function () {
                                var s = window.innerHeight,
                                    r = e.activator.getBoundingClientRect(),
                                    l = s / 2;
                                if ("bottom" === e.preferredPosition) (o = "right"), (n = e.element.clientHeight <= s - (r.bottom + a) || s - r.bottom >= l ? "bottom" : "top");
                                else if ("top" === e.preferredPosition) (o = "right"), (n = e.element.clientHeight <= r.top - a || r.top >= l ? "top" : "bottom");
                                else {
                                    n = "left";
                                    var c = e.element.clientHeight / 2;
                                    o = r.top >= c && s - r.bottom >= c ? "center" : s - r.bottom >= c ? "bottom" : "top";
                                }
                                e.preferredAlignment && (o = e.preferredAlignment),
                                    "top" === n
                                        ? ((t = r.top - e.element.clientHeight - a), (i = "center" === o ? window.innerWidth - r.right - e.element.clientWidth / 2 + 3 : window.innerWidth - r.right))
                                        : "bottom" === n
                                        ? ((t = r.bottom + a), (i = "center" === o ? window.innerWidth - r.right - e.element.clientWidth / 2 + 3 : window.innerWidth - r.right))
                                        : ((i = window.innerWidth - r.left + a), (t = "center" === o ? r.top - e.element.clientHeight / 2 + e.activator.clientHeight / 2 : "top" === o ? r.bottom - e.element.clientHeight : r.top));
                            }),
                                fastdom.mutate(function () {
                                    ["Popover--positionBottom", "Popover--positionTop", "Popover--positionCenter", "Popover--alignTop", "Popover--alignCenter", "Popover--alignBottom"].map(function (t) {
                                        return e.element.classList.remove(t);
                                    }),
                                        e.element.classList.add("Popover--position".concat(n.charAt(0).toUpperCase() + n.slice(1))),
                                        e.element.classList.add("Popover--align".concat(o.charAt(0).toUpperCase() + o.slice(1))),
                                        e.element.setAttribute("style", "top: ".concat(parseInt(t), "px; right: ").concat(parseInt(i), "px;"));
                                });
                        },
                    },
                    {
                        key: "_handleKeyboard",
                        value: function (e) {
                            this.isOpen && 27 === e.keyCode && this.close();
                        },
                    },
                ]),
                t
            );
        })(),
        _ = (function () {
            function t() {
                e(this, t), (this.domDelegate = new domDelegate.Delegate(document.body)), (this.pageTransition = document.querySelector(".PageTransition")), this._attachListeners();
            }
            return (
                i(
                    t,
                    [
                        {
                            key: "_attachListeners",
                            value: function () {
                                this.domDelegate.on("click", 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
                            },
                        },
                        {
                            key: "_onPageUnload",
                            value: function (e, t) {
                                var i = this;
                                if (!(e.defaultPrevented || e.ctrlKey || e.metaKey) && window.theme.showPageTransition && this.pageTransition && (e.preventDefault(), window.theme.showPageTransition && this.pageTransition)) {
                                    this.pageTransition.addEventListener("transitionend", function e(n) {
                                        "opacity" === n.propertyName && (i.pageTransition.removeEventListener("transitionend", e), (window.location.href = t.href));
                                    }),
                                        (this.pageTransition.style.visibility = "visible"),
                                        (this.pageTransition.style.opacity = "1");
                                }
                            },
                        },
                    ],
                    [
                        {
                            key: "getInstance",
                            value: function () {
                                return this.instance || (this.instance = new t()), this.instance;
                            },
                        },
                    ]
                ),
                t
            );
        })(),
        w = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.delegateElement = new domDelegate.Delegate(this.element)), this.delegateElement.on("change", ".ColorSwatch__Radio", this._colorChanged.bind(this));
            }
            return (
                i(t, [
                    {
                        key: "_colorChanged",
                        value: function (e, t) {
                            var i = t.closest(".ProductItem"),
                                n = t.getAttribute("data-variant-url");
                            i.querySelector(".ProductItem__ImageWrapper").setAttribute("href", n), i.querySelector(".ProductItem__Title > a").setAttribute("href", n);
                            var o = i.querySelector(".ProductItem__Image:not(.ProductItem__Image--alternate)");
                            if (t.hasAttribute("data-image-url") && t.getAttribute("data-image-id") !== o.getAttribute("data-image-id")) {
                                var a = document.createElement("img");
                                (a.className = "ProductItem__Image Image--fadeIn Image--lazyLoad"),
                                    a.setAttribute("data-image-id", t.getAttribute("data-image-id")),
                                    a.setAttribute("data-src", t.getAttribute("data-image-url")),
                                    a.setAttribute("data-widths", t.getAttribute("data-image-widths")),
                                    a.setAttribute("data-sizes", "auto"),
                                    "natural" === window.theme.productImageSize && (o.parentNode.style.paddingBottom = "".concat(100 / t.getAttribute("data-image-aspect-ratio"), "%")),
                                    o.parentNode.style.setProperty("--aspect-ratio", t.getAttribute("data-image-aspect-ratio")),
                                    o.parentNode.replaceChild(a, o);
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        b = (function () {
            function t() {
                e(this, t);
            }
            return (
                i(t, null, [
                    {
                        key: "getSizedImageUrl",
                        value: function (e, t) {
                            if (null === t) return e;
                            if ("master" === t) return e.replace(/http(s)?:/, "");
                            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                            if (i) {
                                var n = e.split(i[0]),
                                    o = i[0];
                                return (n[0] + "_" + t + o).replace(/http(s)?:/, "");
                            }
                            return null;
                        },
                    },
                    {
                        key: "getSupportedSizes",
                        value: function (e, t) {
                            var i = [],
                                n = e.width;
                            return (
                                t.forEach(function (e) {
                                    n >= e && i.push(e);
                                }),
                                i
                            );
                        },
                    },
                ]),
                t
            );
        })(),
        k = (function () {
            function t(i, n) {
                e(this, t), (this.element = i), (this.delegateElement = new domDelegate.Delegate(this.element)), (this.delegateRoot = new domDelegate.Delegate(document.body)), (this.slideshow = n), this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off("click");
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this)),
                            this.delegateElement.on("click", ".Product__SlideItem--image,.ProductBundle__GalleryImages--item", this._initPhotoSwipeFromImageClick.bind(this));
                        },
                    },
                    {
                        key: "_initPhotoSwipe",
                        value: function (event) {
                            if(event.target.closest(".ProductBundle__variants-images-top")){
                              var i = h.nodeListToArray(this.element.querySelectorAll(".ProductBundle__variants-image-top:not([hidden]) img, .ProductBundle__variants-image-bottom:not([hidden]) img"));
                              this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(i), 0, true, true);
                            }else if(event.target.closest(".ProductBundle__variants-images-bottom")){
                              var i = h.nodeListToArray(this.element.querySelectorAll(".ProductBundle__variants-image-top:not([hidden]) img, .ProductBundle__variants-image-bottom:not([hidden]) img"));
                              this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(i), 1, true, true);
                            }else{
                            var e = [];
                            this.slideshow.flickityInstance.cells.forEach(function (t) {
                                t.element.classList.contains("Product__SlideItem--image") && e.push(t.element.querySelector("img"));
                            }),
                                this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(e), parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute("data-image-media-position")));
                            }
                        },
                    },
                    {
                        key: "_initPhotoSwipeFromImageClick",
                        value: function (e, t) {
                            //debugger;
                            if (!c.matchesBreakpoint("pocket")) {
                                if(e.target.closest(".ProductBundle__GalleryImages--item-top")){
                                  var i = h.nodeListToArray(this.element.querySelectorAll(".ProductBundle__GalleryImages--item-top:not([hidden]) img, .ProductBundle__GalleryImages--item-bottom:not([hidden]) img"));
                                  this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(i), 0, true, false);
                                }else if(e.target.closest(".ProductBundle__GalleryImages--item-bottom")){
                                  var i = h.nodeListToArray(this.element.querySelectorAll(".ProductBundle__GalleryImages--item-top:not([hidden]) img, .ProductBundle__GalleryImages--item-bottom:not([hidden]) img"));
                                  this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(i), 1, true, false);
                                }else{
                                var i = h.nodeListToArray(this.element.querySelectorAll(".Product__SlideItem--image img"));
                                this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(i), parseInt(t.getAttribute("data-image-media-position")), false);
                                }
                            }
                        },
                    },
                    {
                        key: "_createPhotoSwipeItemsFromImages",
                        value: function (e) {
                            return e.map(function (e) {
                                var t = parseInt(e.getAttribute("data-max-width")),
                                    i = parseInt(e.getAttribute("data-max-height")),
                                    n = c.matchesBreakpoint("phone") ? 1200 : 1800,
                                    o = 1;
                                o = t >= i ? Math.max(t / n, 1) : Math.max(i / n, 1);
                                var a = Math.floor(t / o),
                                    s = Math.floor(i / o);
                                return { msrc: e.currentSrc || e.src, w: a, h: s, initialZoomLevel: 0.65, src: b.getSizedImageUrl(e.getAttribute("data-original-src"), a + "x" + s) };
                            });
                        },
                    },
                    {
                        key: "_createPhotoSwipeInstance",
                        value: function (e, t, isBundleImg, isMobileImg) {
                            var i = this,
                                n = document.querySelector(".pswp");
                            this.photoSwipeInstance = new PhotoSwipe(n, !1, e, {
                                index: t,
                                showHideOpacity: !0,
                                showAnimationDuration: 500,
                                loop: !1,
                                history: !1,
                                closeOnVerticalDrag: !1,
                                allowPanToNext: !1,
                                pinchToClose: !1,
                                errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + "</p>",
                                scaleMode: "zoom",
                                getDoubleTapZoom: function (e, t) {
                                    return e ? 1.6 : t.initialZoomLevel < 0.7 ? 1 : 1.33;
                                },
                                getThumbBoundsFn: function (e) {
                                  //debugger;
                                   if(isBundleImg){
                                     if(isMobileImg){
                                        if(e == 0){
                                        var t = i.element.querySelector('.ProductBundle__variants-image-top:not([hidden]) img');
                                       }else{
                                         var t = i.element.querySelector('.ProductBundle__variants-image-bottom:not([hidden]) img');
                                       }
                                     }else{
                                       if(e == 0){
                                        var t = i.element.querySelector('.ProductBundle__GalleryImages--item-top:not([hidden]) img');
                                       }else{
                                         var t = i.element.querySelector('.ProductBundle__GalleryImages--item-bottom:not([hidden]) img');
                                       }
                                     }
                                   }else{
                                     var t = i.element.querySelector('.Product__Slideshow .Carousel__Cell[data-image-media-position="'.concat(parseInt(e), '"] img'));
                                   }
                                    var n = window.pageYOffset || document.documentElement.scrollTop,
                                        o = t.getBoundingClientRect();
                                    return { x: o.left, y: o.top + n, w: o.width };
                                },
                            });
                            var o = this.photoSwipeInstance.updateSize,
                                a = null;
                            (this.photoSwipeInstance.updateSize = function () {
                                (null !== a && a === window.innerWidth) || o(this, arguments), (a = window.innerWidth);
                            }),
                                this.photoSwipeInstance.listen("beforeChange", this._onSlideChanged.bind(this)),
                                this.photoSwipeInstance.listen("destroy", this._destroyPhotoSwipe.bind(this)),
                                this.photoSwipeInstance.listen("doubleTap", this._onDoubleTap.bind(this)),
                                this.photoSwipeInstance.listen("initialZoomIn", this._onInitialZoomIn.bind(this)),
                                this.photoSwipeInstance.listen("initialZoomOut", this._onInitialZoomOut.bind(this)),
                                this.delegateRoot.on("pswpTap", ".pswp__scroll-wrap", this._onSingleTap.bind(this)),
                                this.delegateRoot.on("pswpTap", ".pswp__button--close", this.photoSwipeInstance.close),
                                this.delegateRoot.on("pswpTap", ".pswp__button--prev", this.photoSwipeInstance.prev),
                                this.delegateRoot.on("pswpTap", ".pswp__button--next", this.photoSwipeInstance.next),
                                this.photoSwipeInstance.init();
                        },
                    },
                    {
                        key: "_onSlideChanged",
                        value: function () {
                            0 === this.photoSwipeInstance.getCurrentIndex()
                                ? this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev").setAttribute("disabled", "disabled")
                                : this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev").removeAttribute("disabled"),
                                this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()
                                    ? this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next").setAttribute("disabled", "disabled")
                                    : this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next").removeAttribute("disabled");
                        },
                    },
                    {
                        key: "_onSingleTap",
                        value: function (e) {
                            if (e.detail && "mouse" !== e.detail.pointerType) {
                                if (e.target.classList.contains("pswp__button")) return;
                                e.target.closest(".pswp").querySelector(".pswp__ui").classList.toggle("pswp__ui--hidden");
                            } else e.target.classList.contains("pswp__img") && this.photoSwipeInstance.toggleDesktopZoom(e.detail.releasePoint);
                        },
                    },
                    {
                        key: "_onDoubleTap",
                        value: function (e) {
                            var t = this.photoSwipeInstance.currItem.initialZoomLevel;
                            this.photoSwipeInstance.getZoomLevel() !== t ? this.photoSwipeInstance.zoomTo(t, e, 333) : this.photoSwipeInstance.zoomTo(t < 0.7 ? 1 : 1.33, e, 333);
                        },
                    },
                    {
                        key: "_onInitialZoomIn",
                        value: function () {
                            document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
                        },
                    },
                    {
                        key: "_onInitialZoomOut",
                        value: function () {
                            document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
                        },
                    },
                    {
                        key: "_destroyPhotoSwipe",
                        value: function () {
                            this.delegateRoot.off("pswpTap"), (this.photoSwipeInstance = null);
                        },
                    },
                ]),
                t
            );
        })(),
        S = (function () {
            function t(i, n) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.delegateRoot = new domDelegate.Delegate(document.documentElement)),
                    (this.stackProductImages = n),
                    this._attachListeners();
                var o = document.createElement("link");
                (o.rel = "stylesheet"),
                    (o.href = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
                    document.head.appendChild(o),
                    window.Shopify.loadFeatures([
                        { name: "model-viewer-ui", version: "1.0", onLoad: this._setupModelViewerUI.bind(this) },
                        { name: "shopify-xr", version: "1.0" },
                    ]);
            }
            return (
                i(t, [
                    { key: "destroy", value: function () {} },
                    {
                        key: "_attachListeners",
                        value: function () {
                            var e = this;
                            this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                                e.element.dispatchEvent(new CustomEvent("model:played", { bubbles: !0 }));
                            }),
                                this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                                    e.element.dispatchEvent(new CustomEvent("model:paused", { bubbles: !0 }));
                                });
                        },
                    },
                    {
                        key: "hasBeenSelected",
                        value: function () {
                            c.matchesBreakpoint("supports-hover") && this.modelUi.play();
                        },
                    },
                    {
                        key: "hasBeenDeselected",
                        value: function () {
                            this.modelUi.pause();
                        },
                    },
                    {
                        key: "_setupModelViewerUI",
                        value: function () {
                            (this.modelElement = this.element.querySelector("model-viewer")), (this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement));
                        },
                    },
                ]),
                t
            );
        })(),
        L = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    this.delegateElement.on("click", ".spr-summary-actions-newreview", this._onNewReviewClicked.bind(this)),
                    (window.SPRCallbacks = {}),
                    (window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this)),
                    (window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this));
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "_updatePagination",
                        value: function (e, t) {
                            SPR.$(t).data("page", parseInt(t.getAttribute("data-page")) + 1);
                        },
                    },
                    {
                        key: "_onFormSuccess",
                        value: function () {
                            var e = this.element.querySelector(".spr-form-message-success");
                            window.scrollTo(0, e.offsetTop - 45);
                        },
                    },
                    {
                        key: "_onReviewsLoad",
                        value: function () {
                            var e = this.element.querySelector(".spr-summary-actions"),
                                t = e.querySelector(".spr-pagination-next"),
                                i = this.element.querySelector(".spr-pagination .spr-pagination-next");
                            t && t.remove(), i && e.insertBefore(i, e.firstChild);
                        },
                    },
                    {
                        key: "_onNewReviewClicked",
                        value: function (e, t) {
                            (t.style.display = "none"), t.previousElementSibling && (t.previousElementSibling.style.display = "none");
                        },
                    },
                ]),
                t
            );
        })(),
        E = (function () {
            function t() {
                e(this, t);
            }
            return (
                i(t, null, [
                    {
                        key: "serialize",
                        value: function (e) {
                            function i(e, t) {
                                var n = e.lastIndexOf("[");
                                if (-1 === n) {
                                    var o = {};
                                    return (o[e] = t), o;
                                }
                                var a = e.substr(0, n),
                                    s = {};
                                return (s[e.substring(n + 1, e.length - 1)] = t), i(a, s);
                            }
                            for (var n = {}, o = 0, a = e.elements.length; o < a; o++) {
                                var s = e.elements[o];
                                if (
                                    "" !== s.name &&
                                    !s.disabled &&
                                    s.name &&
                                    !s.disabled &&
                                    (s.checked || /select|textarea/i.test(s.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(s.type))
                                ) {
                                    var r = i(s.name, s.value);
                                    n = t.extend(n, r);
                                }
                            }
                            return n;
                        },
                    },
                    {
                        key: "extend",
                        value: function () {
                            for (
                                var e = {},
                                    i = 0,
                                    n = function (i) {
                                        for (var n in i) i.hasOwnProperty(n) && ("[object Object]" === Object.prototype.toString.call(i[n]) ? (e[n] = t.extend(e[n], i[n])) : (e[n] = i[n]));
                                    };
                                i < arguments.length;
                                i++
                            )
                                n(arguments[i]);
                            return e;
                        },
                    },
                ]),
                t
            );
        })(),
        I = (function () {
            function t() {
                e(this, t);
            }
            return (
                i(t, null, [
                    {
                        key: "formatMoney",
                        value: function (e, t) {
                            "string" == typeof e && (e = e.replace(".", ""));
                            var i = /\{\{\s*(\w+)\s*\}\}/,
                                n = t || "${{amount}}";
                            function o(e, t) {
                                return null == e || e != e ? t : e;
                            }
                            function a(e, t, i, n) {
                                if (((t = o(t, 2)), (i = o(i, ",")), (n = o(n, ".")), isNaN(e) || null == e)) return 0;
                                var a = (e = (e / 100).toFixed(t)).split(".");
                                return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "");
                            }
                            var s = "";
                            switch (n.match(i)[1]) {
                                case "amount":
                                    s = a(e, 2);
                                    break;
                                case "amount_no_decimals":
                                    s = a(e, 0);
                                    break;
                                case "amount_with_space_separator":
                                    s = a(e, 2, " ", ".");
                                    break;
                                case "amount_no_decimals_with_comma_separator":
                                    s = a(e, 0, ",", ".");
                                    break;
                                case "amount_no_decimals_with_space_separator":
                                    s = a(e, 0, " ");
                                    break;
                                case "amount_with_comma_separator":
                                    s = a(e, 2, ".", ",");
                            }
                            return -1 !== n.indexOf("with_comma_separator") ? n.replace(i, s).replace(",00", "") : n.replace(i, s).replace(".00", "");
                        },
                    },
                ]),
                t
            );
        })(),
        A = (function () {
            function t(i, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                e(this, t),
                    (this.element = i),
                    (this.parentProductVariants = n),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.activator = o.activator || document.querySelector('[aria-controls="'.concat(i.getAttribute("id"), '"]'))),
                    (this.onValueChangedCallback = o.onValueChanged || function () {}),
                    (this.isOpen = !1),
                    (this.pageOverlayElement = document.querySelector(".PageOverlay")),
                    (this.variantChoiceList = h.nodeListToArray(this.element.querySelectorAll(".VariantSelector__Choice"))),
                    (this.variantCarousel = new d(this.element.querySelector(".VariantSelector__Carousel"), { onSelect: this._variantChanged.bind(this), onClick: this._variantSelected.bind(this) })),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.element.removeEventListener("keyup", this._handleKeyboardListener), this.delegateElement.off("click"), this.activator.removeEventListener("click", this._toggleListener), this.variantCarousel.destroy();
                        },
                    },
                    {
                        key: "toggle",
                        value: function () {
                            this.isOpen ? this.close() : this.open();
                        },
                    },
                    {
                        key: "open",
                        value: function () {
                            this.isOpen ||
                                (this.element.setAttribute("aria-hidden", "false"),
                                this.activator.setAttribute("aria-expanded", "true"),
                                m.trapFocus(this.element, "variant-selector"),
                                document.documentElement.classList.add("no-scroll"),
                                this.element.setAttribute("style", ""),
                                this.pageOverlayElement.classList.add("is-visible"),
                                this.pageOverlayElement.addEventListener("click", this._closeListener),
                                (this.isOpen = !0));
                        },
                    },
                    {
                        key: "close",
                        value: function () {
                            this.isOpen &&
                                (this.element.setAttribute("aria-hidden", "true"),
                                this.activator.setAttribute("aria-expanded", "false"),
                                m.removeTrapFocus(this.element, "variant-selector"),
                                document.documentElement.classList.remove("no-scroll"),
                                this.pageOverlayElement.classList.remove("is-visible"),
                                this.pageOverlayElement.removeEventListener("click", this._closeListener),
                                (this.isOpen = !1));
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                                (this._closeListener = this.close.bind(this)),
                                (this._toggleListener = this.toggle.bind(this)),
                                this.element.addEventListener("keyup", this._handleKeyboardListener),
                                this.activator.addEventListener("click", this._toggleListener),
                                this.delegateElement.on("click", '[data-action="select-variant"]', this._onVariantSelect.bind(this)),
                                this.parentProductVariants.delegateElement.on("variant:changed", this._onVariantChanged.bind(this));
                        },
                    },
                    {
                        key: "_variantChanged",
                        value: function (e) {
                            var t = this.variantChoiceList[e];
                            t.classList.add("is-selected"),
                                h.getSiblings(t, ".is-selected").forEach(function (e) {
                                    return e.classList.remove("is-selected");
                                });
                        },
                    },
                    {
                        key: "_variantSelected",
                        value: function (e, t) {
                            this.variantCarousel.getSelectedIndex() === t ? (this.onValueChangedCallback(e.getAttribute("data-option-value"), e, this.activator), this.close()) : this.variantCarousel.selectCell(t);
                        },
                    },
                    {
                        key: "_onVariantChanged",
                        value: function (e) {
                            var t = this,
                                i = e.detail.variant,
                                n = this.element.querySelectorAll(".VariantSelector__ImageWrapper"),
                                o = !1;
                            h.nodeListToArray(n).forEach(function (e) {
                                var t = parseInt(e.parentElement.getAttribute("data-option-position")) - 1,
                                    n = "";
                                i.options.forEach(function (e, i) {
                                    i !== t && (n += e);
                                }),
                                    e.getAttribute("data-variant-title") === n ? (e.setAttribute("aria-hidden", "false"), (o = !0)) : e.setAttribute("aria-hidden", "true");
                            }),
                                o || n.children[0].setAttribute("aria-hidden", "false");
                            var a = 0;
                            h.nodeListToArray(this.element.querySelectorAll(".VariantSelector__ChoicePrice")).forEach(function (e, n) {
                                var o = parseInt(e.getAttribute("data-color-position")) - 1;
                                t.parentProductVariants.productData.variants.forEach(function (t) {
                                    var s = !0;
                                    t.options.forEach(function (e, n) {
                                        n !== o && t.options[n] !== i.options[n] && (s = !1);
                                    }),
                                        s && t.options[o] === i.options[o] && a++ === n && (e.innerHTML = '<span class="Heading Text--subdued">'.concat(I.formatMoney(t.price, window.theme.moneyFormat), "</span>"));
                                });
                            });
                        },
                    },
                    {
                        key: "_onVariantSelect",
                        value: function () {
                            var e = this.variantCarousel.flickityInstance.selectedCell.element;
                            this.onValueChangedCallback(e.getAttribute("data-option-value"), e, this.activator), this.close();
                        },
                    },
                    {
                        key: "_handleKeyboard",
                        value: function (e) {
                            this.isOpen && 27 === e.keyCode && this.close();
                        },
                    },
                ]),
                t
            );
        })(),
        C = (function () {
            function t(i, n) {
                e(this, t), (this.element = i), (this.productTitle = n), (this.existingDrawers = {});
            }
            return (
                i(t, [
                    {
                        key: "updateWithVariant",
                        value: function (e) {
                            this.element && (e ? this._renderAvailabilitySection(e.id) : (this.element.textContent = ""));
                        },
                    },
                    {
                        key: "_renderAvailabilitySection",
                        value: function (e) {
                            var t = this;
                            this.element.innerHTML = "";
                            var i = document.getElementById("StoreAvailabilityModal-".concat(e));
                            return (
                                i && i.remove(),
                                this.existingDrawers["StoreAvailabilityModal-".concat(e)] && (this.existingDrawers["StoreAvailabilityModal-".concat(e)].destroy(), delete this.existingDrawers["StoreAvailabilityModal-".concat(e)]),
                                fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(e, "?section_id=store-availability")).then(function (i) {
                                    return i.text().then(function (i) {
                                        (t.element.innerHTML = i), (t.element.innerHTML = t.element.firstElementChild.innerHTML);
                                        var n = t.element.querySelector(".store-availabilities-modal__product-title");
                                        n && (n.textContent = t.productTitle);
                                        var o = document.getElementById("StoreAvailabilityModal-".concat(e));
                                        document.body.appendChild(o), (t.existingDrawers["StoreAvailabilityModal-".concat(e)] = new v(o));
                                    });
                                })
                            );
                        },
                    },
                ]),
                t
            );
        })(),
        T = (function () {
            function t(i, n,productScope) {
                var o = this;
                this.productScope = productScope;
                e(this, t), (this.element = i), (this.delegateElement = new domDelegate.Delegate(this.element)), (this.options = n);
                if(this.element.querySelector("[data-product-json]")){
                var a = JSON.parse(this.element.querySelector("[data-product-json]").innerHTML);
                (this.productData = a.product),
                    (this.variantsInventories = a.inventories || {}),
                    (this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData.id))),
                    this.productData.variants.forEach(function (e) {
                        e.id === a.selected_variant_id && ((o.currentVariant = e), (o.option1 = e.option1), (o.option2 = e.option2), (o.option3 = e.option3));
                    }),
                    (this.storeAvailability = new C(this.element.querySelector(".ProductMeta__StoreAvailabilityContainer"), this.productData.title)),
                    this.storeAvailability.updateWithVariant(this.currentVariant),
                    this._attachListeners(),
                    this._createSelectors();

                }else{
                  this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
                }

               var quick_buy = this.element.querySelector('.quick-buy');
         
        if(quick_buy) {
              var quick_buy_form_options = JSON.parse(quick_buy.getAttribute('data-section-settings'));
               this.quick_buy_productVariants = new T(quick_buy, quick_buy_form_options);
      }
              
              
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off("click"),
                                this.formPopovers.forEach(function (e) {
                                    return e.destroy();
                                }),
                                this.formVariantSelectors.forEach(function (e) {
                                    return e.destroy();
                                });
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)),
                                this.delegateElement.on("click", '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this)),
                                this.delegateElement.on("click", '[data-action="increase-quantity"]', this._increaseQuantity.bind(this)),
                                this.delegateElement.on("change", '[name="quantity"]', this._validateQuantity.bind(this)),
                                this.delegateElement.on("change", '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
                                this.delegateElement.on("change", '.ProductForm__Option-size-bundle [type="radio"]', this._onOptionChangedBundle.bind(this));
                                this.delegateElement.on("change", '.ProductForm__Option-tone-bundle [type="radio"]', this._onOptionChangedBundleProduct.bind(this));
                          
                        },
                    },
                    {
                        key: "_createSelectors",
                        value: function () {
                            var e = this;
                            (this.formPopovers = []),
                                (this.formVariantSelectors = []),
                                h.nodeListToArray(this.element.querySelectorAll(".OptionSelector")).forEach(function (t) {
                                    var i = new g(t, { preferredPosition: "left", onValueChanged: e._onOptionChanged.bind(e) });
                                    e.formPopovers.push(i);
                                }),
                                h.nodeListToArray(this.element.querySelectorAll(".VariantSelector")).forEach(function (t) {
                                    var i = new A(t, e, { onValueChanged: e._onOptionChanged.bind(e) });
                                    e.formVariantSelectors.push(i);
                                });
                        },
                    },
                    {
                        key: "_onVariantChanged",
                        value: function (e, t) {
                            this._updateProductPrices(t, e),
                                this._updateInventory(t, e),
                                this._updateSku(t, e),
                                this._updateUnitPrice(t, e),
                                this._updateAddToCartButton(t, e),
                                this.storeAvailability.updateWithVariant(t),
                                this.element.dispatchEvent(new CustomEvent("variant:changed", { bubbles: !0, detail: { variant: t, previousVariant: e } }));
                        },
                    },
                    {
                        key: "_updateProductPrices",
                        value: function (e, t) {
                            var i = this.element.querySelector(".ProductMeta__PriceList"),
                                n = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                            if (i)
                                if (e) {
                                    if (t && t.price === e.price && t.compare_at_price === e.compare_at_price) return;
                                    (i.innerHTML = ""),
                                        e.compare_at_price > e.price
                                            ? ((i.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(e.price, n), "</span>")),
                                              (i.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(e.compare_at_price, n), "</span>")))
                                            : (i.innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(e.price, n), "</span>")),
                                        (i.style.display = "");
                                } else i.style.display = "none";
                        },
                    },
                    {
                        key: "_updateInventory",
                        value: function (e) {
                            if (this.options.showInventoryQuantity) {
                                var t = this.element.querySelector(".ProductForm__Inventory"),
                                    i = e ? this.variantsInventories[e.id] : null;
                                !e || null === i.inventory_management || i.inventory_quantity <= 0 || (this.options.inventoryQuantityThreshold > 0 && i.inventory_quantity > this.options.inventoryQuantityThreshold)
                                    ? (t.style.display = "none")
                                    : ((t.innerHTML = i.inventory_message), (t.style.display = ""));
                            }
                        },
                    },
                    {
                        key: "_updateSku",
                        value: function (e) {
                            if (this.options.showSku && e) {
                                var t = this.element.querySelector(".ProductMeta__SkuNumber");
                                t && e.sku && (t.innerText = e.sku);
                            }
                        },
                    },
                    {
                        key: "_updateUnitPrice",
                        value: function (e) {
                            if (e) {
                                var t = this.element.querySelector(".ProductMeta__UnitPriceMeasurement");
                                if (t)
                                    if (e.hasOwnProperty("unit_price")) {
                                        (t.style.display = "block"),
                                            (t.querySelector(".UnitPriceMeasurement__Price").innerHTML = I.formatMoney(e.unit_price, window.theme.moneyFormat)),
                                            (t.querySelector(".UnitPriceMeasurement__ReferenceUnit").textContent = e.unit_price_measurement.reference_unit);
                                        var i = t.querySelector(".UnitPriceMeasurement__ReferenceValue");
                                        (i.textContent = e.unit_price_measurement.reference_value), (i.style.display = 1 === e.unit_price_measurement.reference_value ? "none" : "inline");
                                    } else t.style.display = "none";
                            }
                        },
                    },
                    {
                        key: "_updateAddToCartButton",
                        value: function (e) {
                            var t = this.element.querySelector(".ProductForm__AddToCart"),
                                i = this.element.querySelector(".shopify-payment-button");
                            t &&
                                (t.classList.remove("Button--secondary"),
                                t.classList.remove("Button--primary"),
                                e
                                    ? e.available
                                        ? (t.removeAttribute("disabled"),
                                          t.classList.add("true" === t.getAttribute("data-use-primary-button") ? "Button--primary" : "Button--secondary"),
                                          t.setAttribute("data-action", "add-to-cart"),
                                          void 0 === this.options.showPriceInButton || this.options.showPriceInButton
                                              ? (t.innerHTML = "\n            <span>"
                                                    .concat(window.languages.productFormAddToCart, '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>')
                                                    .concat(I.formatMoney(e.price, window.theme.moneyFormat), "</span>\n          "))
                                              : (t.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>")))
                                        : (t.setAttribute("disabled", "disabled"), t.classList.add("Button--secondary"), t.removeAttribute("data-action"), (t.innerHTML = window.languages.productFormSoldOut))
                                    : (t.setAttribute("disabled", "disabled"), t.removeAttribute("data-action"), t.classList.add("Button--secondary"), (t.innerHTML = window.languages.productFormUnavailable))),
                                this.options.showPaymentButton && i && (e && e.available ? (i.style.display = "block") : (i.style.display = "none"));
                        },
                    },
                    {
                        key: "_onOptionChangedBundleProduct",
                        value: function (e, t, i) {
                            var productID = t.getAttribute("data-product_id");

                            var template = document.querySelector(".bundleProducts__Data" + "[data-product-id='"+productID+"']");

                            if(template){
                              //debugger;
                              var templateClone = template.content.cloneNode(true);
                              var productGalleryLabels = templateClone.querySelector(".Product__GalleryLabels");
                              if(productGalleryLabels && this.element.querySelector(".Product__GalleryLabels")){
                                this.element.querySelector(".Product__GalleryLabels").innerHTML = productGalleryLabels.innerHTML;               
                              }else if(this.element.querySelector(".Product__GalleryLabels")){
                                this.element.querySelector(".Product__GalleryLabels").innerHTML = "";
                              }
                              var productSlideshowNavScroller = templateClone.querySelector(".Product__SlideshowNavScroller");
                              if(productSlideshowNavScroller && this.element.querySelector(".Product__SlideshowNavScroller")){
                                this.element.querySelector(".Product__SlideshowNavScroller").innerHTML = productSlideshowNavScroller.innerHTML;               
                              }
                              var productSlideshow = templateClone.querySelector(".Product__Slideshow");
                              if(productSlideshow && this.element.querySelector(".Product__Slideshow")){
                                if(window.innerWidth <= 1007){
                                  this.element.querySelector(".Product__Slideshow .flickity-slider").innerHTML = productSlideshow.innerHTML;    
                                }else{
                                  this.element.querySelector(".Product__Slideshow").innerHTML = productSlideshow.innerHTML;    
                                }               
                                 Flickity.data(".Product__Slideshow").reloadCells();
                              }
                              var productSlideshowMobileNav = templateClone.querySelector(".Product__SlideshowMobileNav .flickity-page-dots");
                              if(productSlideshowMobileNav && this.element.querySelector(".Product__SlideshowMobileNav .flickity-page-dots")){
                                this.element.querySelector(".Product__SlideshowMobileNav .flickity-page-dots").innerHTML = productSlideshowMobileNav.innerHTML;               
                              }

                              var o = this.productScope.element.querySelector(".Product__Slideshow");
                              
                              o &&
                                  (//(this.productScope.productSlideshow = new d(o, { onSelect: this._onImageChanged.bind(this), onSettle: this._onImageSettled.bind(this) }, { draggable: !c.matchesBreakpoint("supports-hover") })),
                                  (this.mediaList = {}),
                                  (this.previouslySelectedMedia = null),
                                  // o.querySelectorAll('[data-media-type="model"]').forEach(function (e) {
                                  //     n.mediaList[e.getAttribute("data-media-id")] = new S(e, n.options.stackProductImages);
                                  // }),
                                  // o.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (e) {
                                  //     n.mediaList[e.getAttribute("data-media-id")] = new P(e, n.options.stackProductImages, n.options.enableVideoLooping);
                                  // }),
                                  this.productScope.options.stackProductImages &&
                                      ((this.productScope.slideshowNavDots = this.productScope.element.querySelector(".Product__SlideshowNav--dots")), (this.productScope.slideshowNavDotsItems = this.productScope.slideshowNavDots ? h.nodeListToArray(this.productScope.slideshowNavDots.querySelectorAll("a")) : [])),
                                  this.productScope.options.showThumbnails &&
                                      ((this.productScope.slideshowNavThumbnails = this.productScope.element.querySelector(".Product__SlideshowNav--thumbnails")),
                                      (this.productScope.slideshowNavThumbnailsItems = this.productScope.slideshowNavThumbnails ? h.nodeListToArray(this.productScope.slideshowNavThumbnails.querySelectorAll(".Product__SlideshowNavImage")) : [])),
                                  (this.productScope.slideshowImages = h.nodeListToArray(o.querySelectorAll(".Carousel__Cell"))),
                                  setTimeout(() => { this.productScope._setupDeviceFeatures()},500)     
                                  )
                              
                              }
                          
                            // if(t.closest(".ProductForm__Variants-top")){
                            //   var images = document.querySelectorAll(".ProductBundle__GalleryImages--item-top,.ProductBundle__variants-image-top");
                            //   var sizeBlocks = document.querySelectorAll(".ProductForm__Variants-top .ProductForm__Option-size-bundle");
                            // }else{
                            //   var images = document.querySelectorAll(".ProductBundle__GalleryImages--item-bottom,.ProductBundle__variants-image-bottom");
                            //   var sizeBlocks = document.querySelectorAll(".ProductForm__Variants-bottom .ProductForm__Option-size-bundle");
                            // }    

                            // images.forEach(function(image){
                            //   if(image.getAttribute("data-bundle-product-id") == productID){
                            //     image.removeAttribute("hidden");
                            //   }else{
                            //      image.setAttribute("hidden","");
                            //   }
                            // });

                            // if(t.closest(".ProductForm__Variants-top")){
                            //   var sizeBlocks = document.querySelectorAll(".ProductForm__Variants-top .ProductForm__Option-size-bundle");
                            // }else{
                            //   var sizeBlocks = document.querySelectorAll(".ProductForm__Variants-bottom .ProductForm__Option-size-bundle");
                            // }    

                           var sizeBlocks = t.closest(".ProductForm__Variants--bundles").querySelectorAll(".ProductForm__Option-size-bundle"); 
                           sizeBlocks.forEach(function(sizeBlock){
                              if(sizeBlock.getAttribute("data-bundle-product-id") == productID){
                                sizeBlock.removeAttribute("hidden");                        
                              }else{
                                 sizeBlock.setAttribute("hidden","");
                              }
                            });


                            var totalPriceSum = 0;
                            var totalCompareAtPriceSum = 0;
                            var availability = true;
                          

                            var ProductForm__Variants  = document.querySelectorAll(".ProductForm__Variants--bundles");

                            ProductForm__Variants.forEach(function(ProductForm__Variant){
                                var checkedInput = ProductForm__Variant.querySelector(".ProductForm__Option-size-bundle:not([hidden]) input:checked"); 
                                var price = checkedInput.getAttribute("data-product_price") * 1;
                                var compareAtPrice = checkedInput.getAttribute("data-product_compare_at_price") * 1;
                                var inputAvailability = checkedInput.getAttribute("data-variant-available");

                                totalPriceSum = totalPriceSum + price;
                                totalCompareAtPriceSum = totalCompareAtPriceSum + compareAtPrice;
                                if(inputAvailability != "true"){
                                  availability = false;
                                }                         
                            })

                            var bundlePriceContainer = document.querySelector(".ProductMeta__PriceList-bundle");

                            var n = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                            if (bundlePriceContainer){
                              bundlePriceContainer.innerHTML = "";
                              if(totalCompareAtPriceSum > totalPriceSum){
                                bundlePriceContainer.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(totalPriceSum, n), "</span>");
                                bundlePriceContainer.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(totalCompareAtPriceSum, n), "</span>");
                              }else{
                                bundlePriceContainer.innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(totalPriceSum, n), "</span>");
                              }
                            }

                            var addToCartButton = document.querySelector(".ProductForm__AddToCart-bundle");

                            if(addToCartButton){
                              if(availability == true){
                                addToCartButton.removeAttribute("disabled");
                                addToCartButton.classList.add("Button--primary");
                                addToCartButton.classList.remove("Button--secondary");
                                addToCartButton.setAttribute("data-action", "add-to-cart");
                                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
                              }else{
                                addToCartButton.setAttribute("disabled","disabled");
                                addToCartButton.classList.remove("Button--primary");
                                addToCartButton.classList.add("Button--secondary");
                                addToCartButton.removeAttribute("data-action");
                                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormSelectAvailableSize, "</span>");
                              }
                            }
                            
                        },
                    },
                     {
                        key: "_onOptionChangedBundle",
                        value: function (e, t, i) {
                            var totalPriceSum = 0;
                            var totalCompareAtPriceSum = 0;
                            var availability = true;
                          
                            var ProductForm__Variants  = document.querySelectorAll(".ProductForm__Variants--bundles");

                            ProductForm__Variants.forEach(function(ProductForm__Variant){
                                var checkedInput = ProductForm__Variant.querySelector(".ProductForm__Option-size-bundle:not([hidden]) input:checked"); 
                                var price = checkedInput.getAttribute("data-product_price") * 1;
                                var compareAtPrice = checkedInput.getAttribute("data-product_compare_at_price") * 1;
                                var inputAvailability = checkedInput.getAttribute("data-variant-available");

                                totalPriceSum = totalPriceSum + price;
                                totalCompareAtPriceSum = totalCompareAtPriceSum + compareAtPrice;
                                if(inputAvailability != "true"){
                                  availability = false;
                                }                         
                            })

                            var bundlePriceContainer = document.querySelector(".ProductMeta__PriceList-bundle");

                            var n = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                            if (bundlePriceContainer){
                              bundlePriceContainer.innerHTML = "";
                              if(totalCompareAtPriceSum > totalPriceSum){
                                bundlePriceContainer.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(totalPriceSum, n), "</span>");
                                bundlePriceContainer.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(totalCompareAtPriceSum, n), "</span>");
                              }else{
                                bundlePriceContainer.innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(I.formatMoney(totalPriceSum, n), "</span>");
                              }
                            }

                            var addToCartButton = document.querySelector(".ProductForm__AddToCart-bundle");

                            if(addToCartButton){
                              if(availability == true){
                                addToCartButton.removeAttribute("disabled");
                                addToCartButton.classList.add("Button--primary");
                                addToCartButton.classList.remove("Button--secondary");
                                addToCartButton.setAttribute("data-action", "add-to-cart");
                                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
                              }else{
                                addToCartButton.setAttribute("disabled","disabled");
                                addToCartButton.classList.remove("Button--primary");
                                addToCartButton.classList.add("Button--secondary");
                                addToCartButton.removeAttribute("data-action");
                                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormSelectAvailableSize, "</span>");
                              }
                            }

                            var optionSelectedValueContainers = t.closest(".ProductForm__Variants").querySelectorAll(".ProductForm__SelectedValue");

                             var SelectedValueName = t.value;
                                if (t.value == 'S') {
                                  SelectedValueName = 'Small';
                                } else if (t.value == 'M') {
                                  SelectedValueName = 'Medium';
                                } else if (t.value == 'L') {
                                  SelectedValueName = 'Large';
                                } else if (t.value == 'XL') {
                                  SelectedValueName = 'X-Large';
                                } else if (t.value == 'XXL') {
                                  SelectedValueName = 'XX-Large';
                                }
                                 optionSelectedValueContainers.forEach(function(optionSelectedValueContainer){
                                  optionSelectedValueContainer.innerHTML = SelectedValueName
                                });

                              SelectedValueName = t.value;

                              var otherOptionInputs = t.closest(".ProductForm__Variants").querySelectorAll("input");
                              otherOptionInputs.forEach(function(otherOptionInput){
                          
                                if(otherOptionInput.value == SelectedValueName){
                                  otherOptionInput.checked = true;
                                }
                              });
                        },
                    },
                    {
                        key: "_onOptionChanged",
                        value: function (e, t, i) {
                            if (i) (this["option" + t.getAttribute("data-option-position")] = e), (i.querySelector(".ProductForm__SelectedValue").innerHTML = e);
                            else {
                                this["option" + t.getAttribute("data-option-position")] = t.value;
                                var n = t.closest(".ProductForm__Option").querySelector(".ProductForm__SelectedValue");
                                var SelectedValueName = t.value;
                                if (t.value == 'S') {
                                  SelectedValueName = 'Small';
                                } else if (t.value == 'M') {
                                  SelectedValueName = 'Medium';
                                } else if (t.value == 'L') {
                                  SelectedValueName = 'Large';
                                } else if (t.value == 'XL') {
                                  SelectedValueName = 'X-Large';
                                } else if (t.value == 'XXL') {
                                  SelectedValueName = 'XX-Large';
                                }
                                n && (n.innerHTML = SelectedValueName);
                            }
                            var o = this.currentVariant;
                            (this.currentVariant = this._getCurrentVariantFromOptions()),
                                this._onVariantChanged(o, this.currentVariant),
                                this.currentVariant &&
                                    (this.options.enableHistoryState && this._updateHistoryState(this.currentVariant),
                                    this.masterSelector.querySelector("[selected]").removeAttribute("selected"),
                                    this.masterSelector.querySelector('[value="'.concat(this.currentVariant.id, '"]')).setAttribute("selected", "selected"),
                                    this.masterSelector.dispatchEvent(new Event("change", { bubbles: !0 })));
                        },
                    },
                    {
                        key: "_getCurrentVariantFromOptions",
                        value: function () {
                            var e = this,
                                t = !1;
                            return (
                                this.productData.variants.forEach(function (i) {
                                    i.option1 === e.option1 && i.option2 === e.option2 && i.option3 === e.option3 && (t = i);
                                }),
                                t || null
                            );
                        },
                    },
                    {
                        key: "_updateHistoryState",
                        value: function (e) {
                            if (history.replaceState) {
                                var t = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(e.id);
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function (e) {
                            var t = this;
                            if (this.options.useAjaxCart) {
                                e.preventDefault();
                                var i = this.element.querySelector(".ProductForm__AddToCart");
                                i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var n = this.element.querySelector('form[action*="/cart/add"]');
                                if(i.classList.contains("ProductForm__AddToCart-bundle")){

                                 var formData = {
                                        'items': []
                                 };
                              var ProductForm__Variants  = document.querySelectorAll(".ProductForm__Variants--bundles");    
                              ProductForm__Variants.forEach(function(ProductForm__Variant){
                                var checkedInput = ProductForm__Variant.querySelector(".ProductForm__Option-size-bundle:not([hidden]) input:checked"); 
                                var productID = checkedInput.getAttribute("data-variant-id");
                                var item = {
                                   'id': productID,
                                   'quantity': 1
                                }
                                formData.items.push(item);
                       
                             });
                                
                                  formData = JSON.stringify(formData);
                                }else{
                                  var formData = JSON.stringify(E.serialize(n));
                                }
                                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                    body: formData ,
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                }).then(function (e) {
                                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                    var o = n.querySelector('[name="quantity"]');
                                    e.ok
                                        ? (i.removeAttribute("disabled"), t.element.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { variant: t.currentVariant, quantity: o ? parseInt(o.value) : 1 } })))
                                        : e.json().then(function (e) {
                                              var t = document.createElement("span");
                                              (t.className = "ProductForm__Error Alert Alert--error"),
                                                  (t.innerHTML = e.description),
                                                  i.removeAttribute("disabled"),
                                                  i.insertAdjacentElement("afterend", t),
                                                  setTimeout(function () {
                                                      t.remove();
                                                  }, 2500);
                                          });
                                }),
                                    e.preventDefault();
                            }
                        },
                    },
                    {
                        key: "_decreaseQuantity",
                        value: function (e, t) {
                            t.nextElementSibling.value = Math.max(parseInt(t.nextElementSibling.value) - 1, 1);
                        },
                    },
                    {
                        key: "_increaseQuantity",
                        value: function (e, t) {
                            t.previousElementSibling.value = parseInt(t.previousElementSibling.value) + 1;
                        },
                    },
                    {
                        key: "_validateQuantity",
                        value: function (e, t) {
                            t.value = Math.max(parseInt(t.value) || 1, 1);
                        },
                    },
                ]),
                t
            );
        })(),
        P = (function () {
            function t(i, n, o) {
                switch (
                    (e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.stackProductImages = n),
                    (this.enableVideoLooping = o),
                    (this.player = null),
                    this.element.getAttribute("data-media-type"))
                ) {
                    case "video":
                        var a = document.createElement("link");
                        (a.rel = "stylesheet"),
                            (a.href = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
                            document.head.appendChild(a),
                            window.Shopify.loadFeatures([{ name: "video-ui", version: "1.0", onLoad: this._setupHtml5Video.bind(this) }]);
                        break;
                    case "external_video":
                        this._setupExternalVideo();
                }
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.player && this.player.destroy();
                        },
                    },
                    {
                        key: "hasBeenSelected",
                        value: function () {
                            c.matchesBreakpoint("supports-hover") && this.play();
                        },
                    },
                    {
                        key: "hasBeenDeselected",
                        value: function () {
                            this.pause();
                        },
                    },
                    {
                        key: "play",
                        value: function () {
                            switch (this.element.getAttribute("data-media-type")) {
                                case "video":
                                    this.player.play();
                                    break;
                                case "external_video":
                                    this.player.playVideo();
                            }
                        },
                    },
                    {
                        key: "pause",
                        value: function () {
                            switch (this.element.getAttribute("data-media-type")) {
                                case "video":
                                    this.player.pause();
                                    break;
                                case "external_video":
                                    this.player.pauseVideo();
                            }
                        },
                    },
                    {
                        key: "_setupHtml5Video",
                        value: function () {
                            var e = this;
                            (this.player = new Shopify.Plyr(this.element.querySelector("video"), {
                                controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                                loop: { active: this.enableVideoLooping },
                                hideControlsOnPause: !0,
                                clickToPlay: !0,
                                iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                                tooltips: { controls: !1, seek: !0 },
                            })),
                                this.player.on("play", function () {
                                    e.element.dispatchEvent(new CustomEvent("video:played", { bubbles: !0 }));
                                }),
                                this.player.on("pause", function () {
                                    e.element.dispatchEvent(new CustomEvent("video:paused", { bubbles: !0 }));
                                });
                        },
                    },
                    {
                        key: "_setupExternalVideo",
                        value: function () {
                            "youtube" === this.element.getAttribute("data-video-host") && this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
                        },
                    },
                    {
                        key: "_setupYouTubePlayer",
                        value: function () {
                            var e = this,
                                t = setInterval(function () {
                                    void 0 !== window.YT &&
                                        void 0 !== window.YT.Player &&
                                        ((e.player = new YT.Player(e.element.querySelector("iframe"), {
                                            videoId: e.element.getAttribute("data-video-id"),
                                            events: {
                                                onStateChange: function (t) {
                                                    t.data === window.YT.PlayerState.PLAYING
                                                        ? e.element.dispatchEvent(new CustomEvent("video:played", { bubbles: !0 }))
                                                        : t.data === YT.PlayerState.PAUSED && e.element.dispatchEvent(new CustomEvent("video:paused", { bubbles: !0 })),
                                                        t.data === window.YT.PlayerState.ENDED && e.enableVideoLooping && t.target.seekTo(0);
                                                },
                                            },
                                        })),
                                        clearInterval(t));
                                }, 50);
                        },
                    },
                    {
                        key: "_loadYouTubeScript",
                        value: function () {
                            return new Promise(function (e, t) {
                                var i = document.createElement("script");
                                document.body.appendChild(i), (i.onload = e), (i.onerror = t), (i.async = !0), (i.src = "//www.youtube.com/iframe_api");
                            });
                        },
                    },
                ]),
                t
            );
        })(),
        x = (function () {
            function t(i, n, o) {
                var a = this;
                e(this, t),
                    (this.container = i),
                    (this.targets = []),
                    (this.targetIndices = {}),
                    (this.indicesInViewPort = []),
                    (this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), o)),
                    n.forEach(function (e, t) {
                        a.targets.push(e), (a.targetIndices[e.id] = t), a.observer.observe(e);
                    });
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.observer.disconnect();
                        },
                    },
                    {
                        key: "_onIntersectionChange",
                        value: function (e) {
                            //console.log("here2");
                            for (var t = this.indicesInViewPort[0] || 0, i = e.length - 1; i >= 0; i--) this._updateIndicesInViewPort(e[i], t);
                            if (
                                ((this.indicesInViewPort = this.indicesInViewPort.filter(function (e, t, i) {
                                    return i.indexOf(e) === t;
                                })),
                                0 !== this.indicesInViewPort.length && t !== this.indicesInViewPort[0])
                            ) {
                                var n = new CustomEvent("scrollspy:target:changed", { detail: { newTarget: this.targets[this.indicesInViewPort[0]], oldTarget: this.targets[t] } });
                                this.container.dispatchEvent(n);
                            }
                        },
                    },
                    {
                        key: "_updateIndicesInViewPort",
                        value: function (e, t) {
                            var i = this.targetIndices[e.target.id];
                            if (0 === e.intersectionRatio) {
                                var n = this.indicesInViewPort.indexOf(i);
                                -1 !== n && this.indicesInViewPort.splice(n, 1);
                            } else i < t ? this.indicesInViewPort.unshift(i) : i > this.indicesInViewPort[this.indicesInViewPort.length - 1] ? this.indicesInViewPort.push(i) : (this.indicesInViewPort.push(i), this.indicesInViewPort.sort());
                        },
                    },
                ]),
                t
            );
        })(),
        M = (function () {
            function t() {
                e(this, t),
                    (this.documentDelegate = new domDelegate.Delegate(document.body)),
                    (this.searchElement = document.getElementById("Search")),
                    (this.searchInputElement = this.searchElement.querySelector('[name="q"]')),
                    (this.searchResultsElement = this.searchElement.querySelector(".Search__Results")),
                    (this.queryMap = {}),
                    (this.isOpen = !1),
                    (this.pageOverlayElement = document.querySelector(".PageOverlay")),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.searchInputElement.removeEventListener("keydown", this._preventSubmissionListener), this.searchInputElement.removeEventListener("input", this._onInputListener), this.documentDelegate.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._preventSubmissionListener = this._preventSubmission.bind(this)),
                                (this._onInputListener = this._debounce(this._onInput.bind(this), 250)),
                                this.searchInputElement.addEventListener("keydown", this._preventSubmissionListener),
                                this.searchInputElement.addEventListener("input", this._onInputListener),
                                this.documentDelegate.on("click", '[data-action="toggle-search"]', this._toggleSearch.bind(this)),
                                this.documentDelegate.on("click", '[data-action="open-search"]', this._openSearch.bind(this)),
                                this.documentDelegate.on("click", '[data-action="close-search"]', this._closeSearch.bind(this)),
                                this.documentDelegate.on("search:close", this._closeSearch.bind(this));
                        },
                    },
                    {
                        key: "_toggleSearch",
                        value: function (e) {
                            this.isOpen ? this._closeSearch(e) : this._openSearch(e), e.preventDefault();
                        },
                    },
                    {
                        key: "_openSearch",
                        value: function () {
                            var e = this;
                            this.searchElement.setAttribute("aria-hidden", "false"), document.documentElement.classList.add("no-scroll"), m.trapFocus(this.searchElement, "search", this.searchElement.querySelector('[name="q"]'));
                            this.searchElement.addEventListener("transitionend", function t() {
                                e.searchInputElement.focus(), e.searchElement.removeEventListener("transitionend", t);
                            }),
                                (this.isOpen = !0),
                                this.pageOverlayElement.classList.add("is-visible"),
                                (document.querySelector("#shopify-section-header").style.zIndex = 10);
                        },
                    },
                    {
                        key: "_closeSearch",
                        value: function () {
                            var e = this;
                            this.searchElement.setAttribute("aria-hidden", "true"), document.documentElement.classList.remove("no-scroll"), m.removeTrapFocus(this.searchElement, "search"), (this.isOpen = !1);
                            this.pageOverlayElement.addEventListener("transitionend", function t(i) {
                                "visibility" === i.propertyName && ((document.querySelector("#shopify-section-header").style.zIndex = ""), e.pageOverlayElement.removeEventListener("transitionend", t));
                            }),
                                this.pageOverlayElement.classList.remove("is-visible");
                        },
                    },
                    {
                        key: "_preventSubmission",
                        value: function (e) {
                            13 === e.keyCode && "product" !== window.theme.searchMode && e.preventDefault();
                        },
                    },
                    {
                        key: "_onInput",
                        value: function (e) {
                            var t = this;
                            if (13 !== e.keyCode)
                                if (((this.lastInputValue = e.target.value), "" !== this.lastInputValue)) {
                                    var i = { method: "GET", credentials: "same-origin" },
                                        n = [fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "*&type=product"), i)];
                                    "product" !== window.theme.searchMode &&
                                        n.push(
                                            fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "*&type=").concat(window.theme.searchMode.replace("product,", "")), i)
                                        ),
                                        (this.queryMap[this.lastInputValue] = !0),
                                        document.dispatchEvent(new CustomEvent("theme:loading:start")),
                                        Promise.all(n).then(function (i) {
                                            t.lastInputValue === e.target.value &&
                                                (delete t.queryMap[e.target.value],
                                                Promise.all(
                                                    i.map(function (e) {
                                                        return e.text();
                                                    })
                                                ).then(function (e) {
                                                    "product" === window.theme.searchMode
                                                        ? (t.searchResultsElement.innerHTML = e[0])
                                                        : (t.searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">'
                                                              .concat(e[0], '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">')
                                                              .concat(e[1], "</div>\n            </div>")),

        t.form_container_arr = t.searchResultsElement.querySelectorAll('.ProductFormWrapper'); 
            for (var i = 0; i < t.form_container_arr.length; ++i) {
              var form_container = t.form_container_arr[i];
              var form_options = JSON.parse(form_container.getAttribute('data-section-settings'));
            
              t.productVariants = new T(form_container, form_options);
            }
                                                        t.searchResultsElement.setAttribute("aria-hidden", "false");
                                                }),
                                                document.dispatchEvent(new CustomEvent("theme:loading:end")));
                                        });
                                } else this._resetSearch();
                        },
                    },
                    {
                        key: "_resetSearch",
                        value: function () {
                            "product" === window.theme.searchMode
                                ? (this.searchResultsElement.innerHTML = "")
                                : (this.searchResultsElement.innerHTML =
                                      '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>'),
                                this.searchResultsElement.setAttribute("aria-hidden", "true"),
                                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                        },
                    },
                    {
                        key: "_debounce",
                        value: function (e, t) {
                            var i = this,
                                n = null;
                            return function () {
                                for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
                                clearTimeout(n),
                                    (n = setTimeout(function () {
                                        e.apply(i, a);
                                    }, t));
                            };
                        },
                    },
                ]),
                t
            );
        })(),
        q = (function () {
            function t(i, n) {
                e(this, t), (this.countrySelect = i), (this.provinceSelect = n), this.countrySelect && this.provinceSelect && (this._attachListeners(), this._initSelectors());
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            this.countrySelect && this.countrySelect.removeEventListener("change", this._onCountryChangedListener);
                        },
                    },
                    {
                        key: "_initSelectors",
                        value: function () {
                            var e = this.countrySelect.getAttribute("data-default");
                            if (e) {
                                for (var t = 0; t !== this.countrySelect.options.length; ++t)
                                    if (this.countrySelect.options[t].text === e) {
                                        this.countrySelect.selectedIndex = t;
                                        break;
                                    }
                            } else this.countrySelect.selectedIndex = 0;
                            var i = new Event("change", { bubbles: !0 });
                            this.countrySelect.dispatchEvent(i);
                            var n = this.provinceSelect.getAttribute("data-default");
                            if (n)
                                for (var o = 0; o !== this.provinceSelect.options.length; ++o)
                                    if (this.provinceSelect.options[o].text === n) {
                                        this.provinceSelect.selectedIndex = o;
                                        break;
                                    }
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onCountryChangedListener = this._onCountryChanged.bind(this)), this.countrySelect.addEventListener("change", this._onCountryChangedListener);
                        },
                    },
                    {
                        key: "_onCountryChanged",
                        value: function () {
                            var e = this,
                                t = this.countrySelect.options[this.countrySelect.selectedIndex],
                                i = JSON.parse(t.getAttribute("data-provinces") || "[]");
                            (this.provinceSelect.innerHTML = ""),
                                0 !== i.length
                                    ? (i.forEach(function (t) {
                                          e.provinceSelect.options.add(new Option(t[1], t[0]));
                                      }),
                                      (this.provinceSelect.parentNode.style.display = "block"))
                                    : (this.provinceSelect.parentNode.style.display = "none");
                        },
                    },
                ]),
                t
            );
        })(),
        O = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.countrySelector = new q(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'))),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off("click"), this.countrySelector.destroy();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", ".ShippingEstimator__Submit", this._fetchRates.bind(this));
                        },
                    },
                    {
                        key: "_fetchRates",
                        value: function () {
                            var e = this,
                                t = this.element.querySelector('[name="country"]').value,
                                i = this.element.querySelector('[name="province"]').value,
                                n = this.element.querySelector('[name="zip"]').value;
                            document.dispatchEvent(new CustomEvent("theme:loading:start")),
                                fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(n, "&shipping_address[country]=").concat(t, "&shipping_address[province]=").concat(i), {
                                    credentials: "same-origin",
                                    method: "GET",
                                }).then(function (t) {
                                    t.json().then(function (i) {
                                        document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                        var n = e.element.querySelector(".ShippingEstimator__Results"),
                                            o = e.element.querySelector(".ShippingEstimator__Error");
                                        if (t.ok) {
                                            var a = i.shipping_rates;
                                            if (0 === a.length) n.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
                                            else {
                                                var s = "";
                                                1 === a.length
                                                    ? (s += "<p>".concat(window.languages.shippingEstimatorOneResult, "</p><ul>"))
                                                    : (s += "<p>".concat(window.languages.shippingEstimatorMoreResults.replace("{{count}}", a.length), "</p><ul>")),
                                                    a.forEach(function (e) {
                                                        s += "<li>".concat(e.name, ": ").concat(I.formatMoney(e.price, window.theme.moneyFormat), "</li>");
                                                    }),
                                                    (s += "</ul>"),
                                                    (n.firstElementChild.innerHTML = s);
                                            }
                                            TweenLite.fromTo(n.firstElementChild, 0.6, { autoAlpha: 0, y: -15 }, { autoAlpha: 1, y: 0, delay: 0.35 }), (o.style.display = "none"), (n.style.display = "block"), u.slideDown(n);
                                        } else {
                                            var r = "";
                                            Object.keys(i).forEach(function (e) {
                                                r += '<li class="Alert__ErrorItem">'.concat(e, " ").concat(i[e], "</li>");
                                            }),
                                                (o.innerHTML = '<ul class="Alert__ErrorList">'.concat(r, "</ul>")),
                                                (n.style.display = "none"),
                                                (o.style.display = "block");
                                        }
                                    });
                                });
                        },
                    },
                ]),
                t
            );
        })(),
        D = function t() {
            var i = this;
            e(this, t),
                (this.countrySelectors = []),
                h.nodeListToArray(document.querySelectorAll(".Modal--address")).forEach(function (e) {
                    i.countrySelectors.push(new q(e.querySelector('[name="address[country]"]'), e.querySelector('[name="address[province]"]')));
                });
        },
        H = (function () {
            function t(i) {
                var n = this;
                e(this, t),
                    (this.element = i),
                    window.theme.showElementStaggering &&
                        ((this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 })),
                        (this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this))),
                        h.nodeListToArray(this.element.querySelectorAll(".ArticleItem")).forEach(function (e) {
                            n.intersectionObserver.observe(e);
                        }));
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            window.theme.showElementStaggering && (this.intersectionObserver.disconnect(), this.timeline.kill());
                        },
                    },
                    {
                        key: "_reveal",
                        value: function (e) {
                            var t = this,
                                i = [];
                            e.forEach(function (e) {
                                (e.isIntersecting || e.intersectionRatio > 0) && (i.push(e.target), t.intersectionObserver.unobserve(e.target));
                            }),
                                0 !== i.length && this.timeline.staggerFromTo(i, 0.45, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0 }, 0.2);
                        },
                    },
                ]),
                t
            );
        })(),
        B = (function () {
            function t(i) {
                var n = this;
                e(this, t),
                    (this.element = i),
                    (this.toolbarElement = this.element.querySelector(".ArticleToolbar")),
                    (this.articleNavElement = this.element.querySelector(".ArticleNav")),
                    this.element.querySelector(".Article__Image") && window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches && (this.parallaxInstance = new Rellax(".Article__Image", { speed: -7, center: !1, round: !0 })),
                    window.theme.showElementStaggering &&
                        ((this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 })),
                        (this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this))),
                        h.nodeListToArray(this.element.querySelectorAll(".ArticleItem")).forEach(function (e) {
                            n.intersectionObserver.observe(e);
                        })),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.parallaxInstance && this.parallaxInstance.destroy(),
                                window.theme.showElementStaggering && (this.intersectionObserver.disconnect(), this.timeline.kill()),
                                window.removeEventListener("scroll", this._onScrollListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onScrollListener = this._checkToolbarVisibility.bind(this)), window.addEventListener("scroll", this._onScrollListener);
                        },
                    },
                    {
                        key: "_checkToolbarVisibility",
                        value: function () {
                            var e = this,
                                t = 0,
                                i = 0,
                                n = 0,
                                o = 0,
                                a = document.querySelector(".Header");
                            fastdom.measure(function () {
                                (t = window.pageYOffset),
                                    (i = a.offsetHeight),
                                    (o = parseInt(window.getComputedStyle(document.body).getPropertyValue("--use-sticky-header") || 0)),
                                    e.articleNavElement && (n = e.articleNavElement.offsetTop + e.articleNavElement.clientHeight - i);
                            }),
                                fastdom.mutate(function () {
                                    (e.toolbarElement.style.top = o ? i + "px" : null),
                                        e.articleNavElement
                                            ? t > 150 && e.articleNavElement && t < n
                                                ? e.toolbarElement.classList.add("is-visible")
                                                : e.toolbarElement.classList.remove("is-visible")
                                            : t > 150
                                            ? e.toolbarElement.classList.add("is-visible")
                                            : e.toolbarElement.classList.remove("is-visible");
                                });
                        },
                    },
                    {
                        key: "_reveal",
                        value: function (e) {
                            var t = this,
                                i = [];
                            e.forEach(function (e) {
                                (e.isIntersecting || e.intersectionRatio > 0) && (i.push(e.target), t.intersectionObserver.unobserve(e.target));
                            }),
                                0 !== i.length && this.timeline.staggerFromTo(i, 0.45, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0 }, 0.2);
                        },
                    },
                ]),
                t
            );
        })(),
        N = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.documentDelegate = new domDelegate.Delegate(document.documentElement)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.itemCount = this.options.itemCount),
                    (this.isCartNoteOpen = !1),
                    this.options.drawer && (this.sidebarDrawer = new v(this.element, { onClose: this._onDrawerClosed.bind(this) })),
                    this.options.hasShippingEstimator && (this.shippingEstimator = new O(this.element.querySelector(".ShippingEstimator"))),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.options.hasShippingEstimator && this.shippingEstimator.destroy(), this.delegateElement.off(), document.removeEventListener("product:added", this._onProductAddedListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onProductAddedListener = this._onProductAdded.bind(this)),
                                this.delegateElement.on("change", "#cart-note", this._updateCartNote.bind(this)),
                                "page" !== this.options.type
                                    ? (this.delegateElement.on("click", '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this)),
                                      this.delegateElement.on("change", ".QuantitySelector__CurrentQuantity", this._updateItemQuantity.bind(this)))
                                    : this.delegateElement.on("change", ".QuantitySelector__CurrentQuantity", this._reloadPageWithQuantity.bind(this)),
                                this.options.drawer && this.delegateElement.on("click", '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this)),
                                document.addEventListener("product:added", this._onProductAddedListener),
                                this.documentDelegate.on("cart:refresh", this._rerenderCart.bind(this, !1));
                        },
                    },
                    {
                        key: "_updateCartNote",
                        value: function (e, t) {
                            fetch("".concat(window.routes.cartUrl, "/update.js"), {
                                body: JSON.stringify({ note: t.value }),
                                credentials: "same-origin",
                                method: "POST",
                                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                            });
                        },
                    },
                    {
                        key: "_toggleCartNote",
                        value: function () {
                            var e = this,
                                t = this.element.querySelector(".Cart__OffscreenNoteContainer"),
                                i = this.element.querySelector("#cart-note");
                            if (
                                (this.element.classList.toggle("has-note-open"),
                                (this.element.querySelector(".Cart__NoteButton").innerHTML = "" !== i.value ? window.languages.cartEditNote : window.languages.cartAddNote),
                                t.setAttribute("aria-hidden", "true" === t.getAttribute("aria-hidden") ? "false" : "true"),
                                (this.isCartNoteOpen = "false" === t.getAttribute("aria-hidden")),
                                this.element.classList.contains("has-note-open"))
                            ) {
                                t.addEventListener("transitionend", function i() {
                                    e.element.querySelector("#cart-note").focus(), t.removeEventListener("transitionend", i);
                                });
                            }
                        },
                    },
                    {
                        key: "_updateItemQuantity",
                        value: function (e, t) {
                            var i = this;
                            document.dispatchEvent(new CustomEvent("theme:loading:start"));
                            var n = null,
                                o = null;
                            0 === (n = "INPUT" === t.tagName ? parseInt(Math.max(parseInt(t.value) || 1, 1)) : parseInt(t.getAttribute("data-quantity"))) && (o = t.closest(".CartItemWrapper")),
                                fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                                    body: JSON.stringify({ line: t.getAttribute("data-line"), quantity: n }),
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                }).then(function (e) {
                                    e.json().then(function (e) {
                                        (i.itemCount = e.item_count), i._rerenderCart(o), document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                    });
                                }),
                                e.preventDefault();
                        },
                    },
                    {
                        key: "_reloadPageWithQuantity",
                        value: function (e, t) {
                            window.location.href = "".concat(window.routes.cartChangeUrl, "?quantity=").concat(parseInt(t.value), "&line=").concat(t.getAttribute("data-line"));
                        },
                    },
                    {
                        key: "_onProductAdded",
                        value: function (e) {
                            var t = this;
                            (this.itemCount += e.detail.quantity),
                                this._rerenderCart().then(function () {
                                    t.sidebarDrawer.open();
                                });
                        },
                    },
                    {
                        key: "_onDrawerClosed",
                        value: function () {
                            this.isCartNoteOpen && this._toggleCartNote();
                        },
                    },
                    {
                        key: "_rerenderCart",
                        value: function (e) {
                            var t = this;
                            return fetch(
                                ""
                                    .concat(window.routes.cartUrl, "?section_id=")
                                    .concat(this.options.drawer && "cart" !== window.theme.pageType ? "mini-cart" : "main-cart", "&timestamp=")
                                    .concat(Date.now()),
                                { credentials: "same-origin", method: "GET" }
                            ).then(function (i) {
                                if (t.options.drawer && e) {
                                    var n = new TimelineLite({
                                        onComplete: function () {
                                            i.text().then(function (e) {
                                                t._replaceContent(e);
                                            });
                                        },
                                    });
                                    n.to(e, 0.5, { height: 0, opacity: 0, ease: Cubic.easeOut }, 0), 0 === t.itemCount && n.to(t.element.querySelector(".Drawer__Footer"), 0.5, { y: "100%", transition: "none", ease: Cubic.easeInOut }, 0);
                                } else
                                    i.text().then(function (e) {
                                        t._replaceContent(e);
                                    });
                            });
                        },
                    },
                    {
                        key: "_replaceContent",
                        value: function (e) {
                            var t = this,
                                i = document.createElement("div");
                            i.innerHTML = e;
                            var n = this.element.querySelector(".Cart").parentNode;
                            if (this.options.drawer && "cart" !== window.theme.pageType) {
                                var o = this.element.querySelector(".Drawer__Main").scrollTop;
                                n.replaceChild(i.querySelector(".Cart"), this.element.querySelector(".Cart")), (this.element.querySelector(".Drawer__Main").scrollTop = o);
                            } else
                                0 === this.itemCount
                                    ? (this.element.innerHTML = i.querySelector(".shopify-section").firstElementChild.innerHTML)
                                    : (n.replaceChild(i.querySelector(".Cart"), this.element.querySelector(".Cart")), (this.element.querySelector(".PageHeader").innerHTML = i.querySelector(".PageHeader").innerHTML));
                            var a = JSON.parse(i.querySelector('[data-section-type="cart"]').getAttribute("data-section-settings")),
                                s = h.nodeListToArray(document.querySelectorAll(".Header__CartDot")),
                                r = h.nodeListToArray(document.querySelectorAll(".Header__CartCount"));
                            (this.itemCount = a.itemCount),
                                s.forEach(function (e) {
                                    0 === t.itemCount ? e.classList.remove("is-visible") : e.classList.add("is-visible");
                                }),
                                r.forEach(function (e) {
                                    e.textContent = t.itemCount;
                                });
                        },
                    },
                ]),
                t
            );
        })(),
        V = (function () {
            function t(i) {
                e(this, t), (this.element = i);
                var n = this.element.querySelector("[data-flickity-config]");
                n && (this.carousel = new d(n));
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.carousel && this.carousel.destroy();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.carousel && this.carousel.selectCell(e.target.getAttribute("data-slide-index"), !0, !e.detail.load);
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function () {
                            this.carousel && this.carousel.unpausePlayer();
                        },
                    },
                ]),
                t
            );
        })(),
        R = (function () {
            function t(i) {
                e(this, t), i && ((this.element = i), (this.lastKnownY = window.scrollY), (this.currentTop = 0), (this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top)), this._attachListeners());
            }
            return (
                i(t, [
                    {
                        key: "destroy",
                        value: function () {
                            window.removeEventListener("scroll", this._checkPositionListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._checkPositionListener = this._checkPosition.bind(this)), window.addEventListener("scroll", this._checkPositionListener);
                        },
                    },
                    {
                        key: "_checkPosition",
                        value: function () {
                            var e = this;
                            fastdom.measure(function () {
                                var t = e.element.getBoundingClientRect().top + window.scrollY - e.element.offsetTop + e.initialTopOffset,
                                    i = e.element.clientHeight - window.innerHeight;
                                window.scrollY < e.lastKnownY ? (e.currentTop -= window.scrollY - e.lastKnownY) : (e.currentTop += e.lastKnownY - window.scrollY),
                                    (e.currentTop = Math.min(Math.max(e.currentTop, -i), t, e.initialTopOffset)),
                                    (e.lastKnownY = window.scrollY);
                            }),
                                fastdom.mutate(function () {
                                    e.element.style.top = "".concat(e.currentTop, "px");
                                });
                        },
                    },
                ]),
                t
            );
        })(),
        F = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.toolbarElement = this.element.querySelector(".CollectionToolbar")),
                    (this.collectionInnerElement = this.element.querySelector(".CollectionInner__Products")),
                    (this.settings = JSON.parse(this.element.getAttribute("data-section-settings")));
                var n = document.getElementById("collection-sort-popover");
                n && (this.sortPopover = new g(n, { onValueChanged: this._sortByChanged.bind(this) }));
                var o = document.getElementById("collection-filter-drawer");
                o && (this.filterDrawer = new v(o)),
                    "sidebar" === this.settings.filterPosition && (this.filterInnerSidebarScroller = new R(this.element.querySelector(".CollectionInner__Sidebar"))),
                    this.element.querySelector(".PageHeader__ImageWrapper") &&
                        window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches &&
                        (this.parallaxInstance = new Rellax(".PageHeader__ImageWrapper", { speed: -7, center: !1, round: !0 })),
                    new w(this.element.querySelector(".ProductList")),
                    (this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 })),
                    this._setupAnimation(),
                    this._attachListeners();

                             this.form_container_arr = this.element.querySelectorAll('.ProductFormWrapper'); 
                  
      for (var i = 0; i < this.form_container_arr.length; ++i) {
        var form_container = this.form_container_arr[i];
        var form_options = JSON.parse(form_container.getAttribute('data-section-settings'));
        this.productVariants = new T(form_container, form_options);
      }
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off("click"),
                                this.sortPopover && this.sortPopover.destroy(),
                                this.filterDrawer && this.filterDrawer.destroy(),
                                this.filterInnerSidebarScroller && this.filterInnerSidebarScroller.destroy(),
                                this.parallaxInstance && this.parallaxInstance.destroy(),
                                window.theme.showElementStaggering && (this.intersectionObserver.disconnect(), this.timeline.kill());
                        },
                    },
                    {
                        key: "_setupAnimation",
                        value: function () {
                            var e = this,
                                t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                            window.theme.showElementStaggering &&
                                (this.intersectionObserver && this.intersectionObserver.disconnect(),
                                t
                                    ? (this.timeline.clear(), this.timeline.staggerFromTo(this.element.querySelectorAll(".ProductList .ProductItem"), 0.25, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.1))
                                    : ((this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), { threshold: 0.3 })),
                                      h.nodeListToArray(this.element.querySelectorAll(".ProductList .ProductItem")).forEach(function (t) {
                                          e.intersectionObserver.observe(t);
                                      })));
                        },
                    },
                    {
                        key: "_reveal",
                        value: function (e) {
                            var t = this,
                                i = [];
                            e.forEach(function (e) {
                                (e.isIntersecting || e.intersectionRatio > 0) && (i.push(e.target), t.intersectionObserver.unobserve(e.target));
                            }),
                                0 !== i.length && this.timeline.staggerFromTo(i, 0.35, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.15);
                        },
                    },
                    {
                        key: "_changeLayoutMode",
                        value: function (e, t) {
                            var i,
                                n,
                                o,
                                a = this,
                                s = t.getAttribute("data-grid-type"),
                                r = parseInt(t.getAttribute("data-count")),
                                l = this.collectionInnerElement.querySelector(".ProductList");
                            if (l) {
                                var c = parseInt(l.getAttribute("data-".concat(s, "-count")));
                                if (c === r) return;
                                l.setAttribute("data-".concat(s, "-count"), r),
                                    h.nodeListToArray(l.querySelectorAll(".Grid__Cell")).forEach(function (e) {
                                        if ("mobile" === s) e.classList.remove("1/".concat(c, "--phone")), e.classList.add("1/".concat(r, "--phone"));
                                        else {
                                            var t = 2 === c ? 2 : 3,
                                                i = 2 === r ? 2 : 3;
                                            "drawer" === a.settings.filterPosition
                                                ? (e.classList.remove("1/".concat(c, "--lap-and-up")), e.classList.add("1/".concat(r, "--lap-and-up")))
                                                : (e.classList.remove("1/".concat(c, "--desk")), e.classList.add("1/".concat(r, "--desk"))),
                                                e.classList.remove("1/".concat(t, "--tablet-and-up")),
                                                e.classList.add("1/".concat(i, "--tablet-and-up"));
                                        }
                                        window.theme.showElementStaggering && (e.firstElementChild.style.visibility = "hidden");
                                    }),
                                    lazySizes.autoSizer.checkElems();
                            }
                            t.classList.add("is-active"),
                                h.getSiblings(t)[0].classList.remove("is-active"),
                                this._setupAnimation(),
                                fetch("".concat(window.routes.cartUrl, "/update.js"), {
                                    body: JSON.stringify({
                                        attributes: ((i = {}), (n = "collection_".concat(s, "_items_per_row")), (o = r), n in i ? Object.defineProperty(i, n, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : (i[n] = o), i),
                                    }),
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                });
                        },
                    },
                    {
                        key: "_sortByChanged",
                        value: function (e) {
                            var t = new URL(location.href);
                            t.searchParams.set("sort_by", e), t.searchParams.delete("page"), this._reloadProducts(t.toString());
                        },
                    },
                    {
                        key: "_onFiltersCleared",
                        value: function (e) {
                            this._reloadProducts(e.target.getAttribute("data-url"));
                        },
                    },
                    {
                        key: "_onFilterChanged",
                        value: function (e) {
                            var t = new FormData(e.target.closest("form")),
                                i = new URLSearchParams(t).toString();
                            this._reloadProducts("".concat(window.location.pathname, "?").concat(i));
                        },
                    },
                    {
                        key: "_reloadProducts",
                        value: function (e) {
                            var t = this;
                            this.abortController && this.abortController.abort(), document.dispatchEvent(new CustomEvent("theme:loading:start")), history.replaceState && window.history.pushState({ path: e }, "", e);
                            var i = new URL(window.location);
                            i.searchParams.set("section_id", this.settings.sectionId);
                            try {
                                (this.abortController = new AbortController()),
                                    fetch(i.toString(), { signal: this.abortController.signal }).then(function (e) {
                                        e.text().then(function (e) {
                                            var i = document.createElement("div");
                                            (i.innerHTML = e), (t.collectionInnerElement.innerHTML = i.querySelector(".CollectionInner__Products").innerHTML);
                                            var n = i.querySelector(".CollectionToolbar__Item--filter");
                                            if (n) {
                                                var o = t.element.querySelector(".CollectionToolbar__Item--filter");
                                                (o.innerHTML = n.innerHTML), (o.className = n.className);
                                            }
                                            var a = t.element.querySelector("#collection-filters-drawer-form"),
                                                s = t.element.querySelector("#collection-filters-sidebar-form");
                                            if (a) {
                                                var r = i.querySelector("#collection-filters-drawer-form");
                                                Array.from(a.querySelectorAll(".Collapsible")).forEach(function (e) {
                                                    var t = r.querySelector('[data-filter-index="'.concat(e.getAttribute("data-filter-index"), '"]'));
                                                    "true" === e.firstElementChild.getAttribute("aria-expanded") &&
                                                        ((t.style.overflow = "visible"),
                                                        t.firstElementChild.setAttribute("aria-expanded", "true"),
                                                        (t.lastElementChild.style.height = "auto"),
                                                        (t.lastElementChild.style.overflow = "visible"));
                                                }),
                                                    (a.innerHTML = r.innerHTML),
                                                    new w(t.element.querySelector(".ProductList"));
                                            }
                                            if (s) {
                                                var l = i.querySelector("#collection-filters-sidebar-form");
                                                Array.from(s.querySelectorAll(".Collapsible")).forEach(function (e) {
                                                    var t = l.querySelector('[data-filter-index="'.concat(e.getAttribute("data-filter-index"), '"]'));
                                                    "true" === e.firstElementChild.getAttribute("aria-expanded") &&
                                                        ((t.style.overflow = "visible"),
                                                        t.firstElementChild.setAttribute("aria-expanded", "true"),
                                                        (t.lastElementChild.style.height = "auto"),
                                                        (t.lastElementChild.style.overflow = "visible"));
                                                }),
                                                    (s.innerHTML = l.innerHTML);
                                            }
                                            document.dispatchEvent(new CustomEvent("theme:loading:end")), t._setupAnimation(!0);
                                            var d = t.element.querySelector(".CollectionMain").getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue("--header-height"));
                                            c.matchesBreakpoint("lap-and-up") && t.toolbarElement && 0 === t.toolbarElement.clientHeight && (d -= 50), d < 0 && window.scrollBy({ top: d, behavior: "smooth" });
                                        });
                                    });
                            } catch (e) {}
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._changeLayoutModeListener = this._changeLayoutMode.bind(this)),
                                this.delegateElement.on("click", '[data-action="change-layout-mode"]', this._changeLayoutModeListener),
                                this.delegateElement.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this)),
                                this.delegateElement.on("change", '[name^="filter."]', this._onFilterChanged.bind(this)),
                                window.addEventListener("popstate", function (e) {
                                    e.state.path && (window.location.href = e.state.path);
                                });
                        },
                    },
                ]),
                t
            );
        })(),
        z = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.delegateElement = new domDelegate.Delegate(this.element)), this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this._openItem(e.target);
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function (e) {
                            this._closeItem(e.target);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", ".Faq__Question", this._toggleItem.bind(this)), this.delegateElement.on("click", ".FaqSummary__Item", this._switchToCategory.bind(this));
                        },
                    },
                    {
                        key: "_switchToCategory",
                        value: function (e, t) {
                            t.classList.add("is-active"),
                                h.getSiblings(t, ".is-active").forEach(function (e) {
                                    e.classList.remove("is-active");
                                });
                        },
                    },
                    {
                        key: "_toggleItem",
                        value: function (e, t) {
                            var i = t.closest(".Faq__Item");
                            "true" === i.getAttribute("aria-expanded") ? this._closeItem(i) : this._openItem(i);
                        },
                    },
                    {
                        key: "_openItem",
                        value: function (e) {
                            var t = e.querySelector(".Faq__AnswerWrapper");
                            e.setAttribute("aria-expanded", "true"),
                                t.setAttribute("aria-hidden", "false"),
                                u.slideDown(t, !0),
                                h.getSiblings(e, '[aria-expanded="true"]').forEach(function (e) {
                                    var t = e.querySelector(".Faq__AnswerWrapper");
                                    e.setAttribute("aria-expanded", "false"), t.setAttribute("aria-hidden", "true"), u.slideUp(t);
                                });
                        },
                    },
                    {
                        key: "_closeItem",
                        value: function (e) {
                            var t = e.querySelector(".Faq__AnswerWrapper");
                            e.setAttribute("aria-expanded", "false"), t.setAttribute("aria-hidden", "true"), u.slideUp(t);
                        },
                    },
                ]),
                t
            );
        })(),
        U = (function () {
            function t(i) {
                var n = this;
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-settings"))),
                    (this.carousels = []),
                    h.nodeListToArray(this.element.querySelectorAll("[data-flickity-config]")).forEach(function (e) {
                        n.carousels.push(new d(e));
                    }),
                    new w(this.element),
                    this._setupAnimation(),
                    this._attachListeners();

                               this.form_container_arr = this.element.querySelectorAll('.ProductFormWrapper'); 
      for (var i = 0; i < this.form_container_arr.length; ++i) {
        var form_container = this.form_container_arr[i];
        var form_options = JSON.parse(form_container.getAttribute('data-section-settings'));
           this.productVariants = new T(form_container, form_options);
      }
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.carousels.forEach(function (e) {
                                return e.destroy();
                            }),
                                this.delegateElement.off("click"),
                                this.intersectionObserver.disconnect(),
                                this.timeline.kill();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.element.querySelector('[aria-controls="'.concat(e.target.id, '"]')).click();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="toggle-tab"]', this._switchTab.bind(this));
                        },
                    },
                    {
                        key: "_switchTab",
                        value: function (e, t) {
                            var i = this;
                            if (!t.classList.contains("is-active")) {
                                t.classList.add("is-active"),
                                    h.getSiblings(t, ".is-active").forEach(function (e) {
                                        e.classList.remove("is-active");
                                    });
                                var n = this.element.querySelector("#".concat(t.getAttribute("aria-controls")));
                                this.timeline.eventCallback("onReverseComplete", function () {
                                    n.setAttribute("aria-hidden", "false"),
                                        h.getSiblings(n, '.TabPanel[aria-hidden="false"]').forEach(function (e) {
                                            e.setAttribute("aria-hidden", "true");
                                        }),
                                        c.matchesBreakpoint("lap-and-up") &&
                                            i.carousels.forEach(function (e) {
                                                e.flickityInstance.activate(), e.flickityInstance.resize();
                                            }),
                                        i.timeline.clear(),
                                        i._setupAnimation();
                                }),
                                    "grid" === this.options.layout && window.theme.showElementStaggering ? this.timeline.reverse().timeScale(3) : this.timeline.reverse();
                            }
                        },
                    },
                    {
                        key: "_setupAnimation",
                        value: function () {
                            var e = this;
                            if ((this.intersectionObserver && this.intersectionObserver.disconnect(), (this.timeline = new TimelineLite({ delay: 0.5 })), "grid" === this.options.layout && window.theme.showElementStaggering))
                                (this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this))),
                                    h.nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (t) {
                                        e.intersectionObserver.observe(t);
                                    });
                            else {
                                var t = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');
                                t && this.timeline.fromTo(t, 0.6, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 });
                            }
                        },
                    },
                    {
                        key: "_reveal",
                        value: function (e) {
                            var t = this,
                                i = [];
                            e.forEach(function (e) {
                                (e.isIntersecting || e.intersectionRatio > 0) && (i.push(e.target), t.intersectionObserver.unobserve(e.target));
                            }),
                                0 !== i.length && this.timeline.staggerFromTo(i, 0.45, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.2);
                        },
                    },
                ]),
                t
            );
        })(),
        W = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    this.options.usePlaceholder || (this.productVariants = new T(i, this.options));
                var n = this.element.querySelector(".Product__OffScreen");
                n && this.element.appendChild(n), this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off("click"), this.productVariants && this.productVariants.destroy();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("variant:changed", this._updateMainImage.bind(this));
                        },
                    },
                    {
                        key: "_updateMainImage",
                        value: function (e) {
                            var t = e.detail.variant,
                                i = e.detail.previousVariant;
                            if (t && t.featured_image && (!i.featured_image || i.featured_image.id !== t.featured_image.id)) {
                                var n = t.featured_image,
                                    o = this.element.querySelector(".FeaturedProduct__Gallery .AspectRatio");
                                o.style.cssText = "max-width: ".concat(n.width, "px; --aspect-ratio: ").concat(n.width / n.height);
                                var a = document.createElement("img");
                                a.classList.add("Image--lazyLoad"),
                                    a.setAttribute("data-src", b.getSizedImageUrl(n.src, "1x1").replace("_1x1.", "_{width}x.")),
                                    a.setAttribute("data-widths", "[".concat(b.getSupportedSizes(n, [200, 400, 600, 700, 800, 900, 1e3]).join(","), "]")),
                                    a.setAttribute("data-sizes", "auto"),
                                    o.replaceChild(a, o.querySelector("img"));
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        j = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))), this._loadScript().then(this._setupPlayer.bind(this));
            }
            return (
                i(t, [
                    {
                        key: "_loadScript",
                        value: function () {
                            var e = this;
                            return new Promise(function (t, i) {
                                var n = document.createElement("script");
                                document.body.appendChild(n), (n.onload = t), (n.onerror = i), (n.async = !0), (n.src = "youtube" === e.options.videoType ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js");
                            });
                        },
                    },
                    {
                        key: "onUnload",
                        value: function () {
                            this.player && this.player.destroy();
                        },
                    },
                    {
                        key: "_setupPlayer",
                        value: function () {
                            var e = this,
                                t = this.element.querySelector(".ImageHero__VideoHolder"),
                                i = setInterval(function () {
                                    "youtube" === e.options.videoType
                                        ? window.YT &&
                                          ((e.player = new YT.Player(t, {
                                              videoId: e.options.videoId,
                                              playerVars: {
                                                  showinfo: 0,
                                                  controls: 0,
                                                  fs: 0,
                                                  rel: 0,
                                                  height: "100%",
                                                  width: "100%",
                                                  iv_load_policy: 3,
                                                  html5: 1,
                                                  loop: 1,
                                                  playsinline: 1,
                                                  modestbranding: 1,
                                                  disablekb: 1,
                                                  origin: e.options.requestHost,
                                              },
                                              events: { onReady: e._onYouTubeReady.bind(e), onStateChange: e._onYouTubeStateChange.bind(e) },
                                          })),
                                          clearInterval(i))
                                        : window.Vimeo && ((e.player = new Vimeo.Player(t.parentNode, { id: e.options.videoId, autoplay: !0, autopause: !1, muted: !0, background: !0, loop: !0 })), clearInterval(i));
                                }, 50);
                        },
                    },
                    {
                        key: "_onYouTubeReady",
                        value: function (e) {
                            this.player.mute(), this.player.playVideo();
                        },
                    },
                    {
                        key: "_onYouTubeStateChange",
                        value: function (e) {
                            e.data === YT.PlayerState.ENDED && this.player.playVideo();
                        },
                    },
                ]),
                t
            );
        })(),
        Y = (function () {
            function t(i) {
                e(this, t), (this.element = i), this._createQrCode(), this._setupPrint();
            }
            return (
                i(t, [
                    {
                        key: "_createQrCode",
                        value: function () {
                            var e = document.getElementById("QrCode");
                            new QRCode(e, { text: e.getAttribute("data-identifier"), width: 120, height: 120 });
                        },
                    },
                    {
                        key: "_setupPrint",
                        value: function () {
                            var e = document.getElementById("PrintGiftCard");
                            e &&
                                e.addEventListener("click", function () {
                                    window.print();
                                });
                        },
                    },
                ]),
                t
            );
        })(),
        Q = (function () {
            function t(i) {
                var n = this;
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.lastScrollPosition = -1),
                    (this.isTouch = window.matchMedia("(-moz-touch-enabled: 1), (hover: none)").matches),
                    this.options.isSticky && Stickyfill.addOne(this.element.parentNode),
                    (this.searchBar = new M()),
                    this._attachListeners(),
                    this._verifyNavigationOverlap();
                var o = this.element.querySelector(".Header__LogoImage--primary");
                o && !o.complete
                    ? o.addEventListener("load", function () {
                          fastdom.measure(function () {
                              document.documentElement.style.setProperty("--header-height", n.element.clientHeight + "px"), document.documentElement.style.setProperty("--header-is-not-transparent", n.options.hasTransparentHeader ? 0 : 1);
                          });
                      })
                    : fastdom.measure(function () {
                          document.documentElement.style.setProperty("--header-height", n.element.clientHeight + "px"), document.documentElement.style.setProperty("--header-is-not-transparent", n.options.hasTransparentHeader ? 0 : 1);
                      }),
                    window.addEventListener("pageshow", this._checkTransparentHeader.bind(this)),
                    this._setupLocalizationPopovers();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.element.removeEventListener("mouseleave", this._closeNavigationListener),
                                this.element.removeEventListener("mouseenter", this._focusNavigationListener),
                                this.element.removeEventListener("focusin", this._focusNavigationListener),
                                this.delegateElement.off(),
                                window.removeEventListener("scroll", this._checkTransparentHeaderListener),
                                window.removeEventListener("resize", this._verifyNavigationOverlapListener),
                                this.options.isSticky && Stickyfill.removeOne(this.element.parentNode),
                                this.searchBar.destroy(),
                                this.localizationPopovers.forEach(function (e) {
                                    e.destroy();
                                });
                        },
                    },
                    {
                        key: "onSelect",
                        value: function () {
                            this._checkTransparentHeader();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            var t = this,
                                i = e.target.closest(".HorizontalList__Item");
                            fastdom.mutate(function () {
                                e.target.setAttribute("aria-hidden", "false"),
                                    i &&
                                        (i.classList.add("is-expanded"),
                                        h.getSiblings(i, ".is-expanded").forEach(function (e) {
                                            e.classList.remove("is-expanded");
                                        })),
                                    t.element.classList.remove("Header--transparent");
                            });
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function (e) {
                            var t = e.target.closest(".HorizontalList__Item");
                            fastdom.mutate(function () {
                                e.target.setAttribute("aria-hidden", "true"), t && t.classList.remove("is-expanded");
                            }),
                                this._checkTransparentHeader();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this)),
                                (this._closeNavigationListener = this._closeNavigation.bind(this)),
                                (this._focusNavigationListener = this._focusNavigation.bind(this)),
                                (this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this)),
                                this.element.addEventListener("mouseleave", this._closeNavigationListener),
                                this.delegateElement.on("mouseenter", ".Header__MainNav .HorizontalList__Item, [aria-haspopup]", this._openMenu.bind(this), !0),
                                this.delegateElement.on("focusin", "[aria-haspopup]", this._openMenu.bind(this), !0),
                                this.delegateElement.on("focusout", "[aria-haspopup]", this._closeMenu.bind(this), !1),
                                this.delegateElement.on("click", '[data-action="toggle-search"]', this._closeNavigationListener),
                                this.delegateElement.on("mouseleave", ".DropdownMenu [aria-haspopup]", this._closeMenu.bind(this), !0),
                                this.delegateElement.on("mouseenter", ".DropdownMenu [aria-haspopup]", this._adjustDropdownPosition.bind(this), !0),
                                this.isTouch && this.delegateElement.on("click", ".Header__MainNav [aria-haspopup]", this._handleTouchMenu.bind(this)),
                                this.options.hasTransparentHeader && (this.element.addEventListener("mouseenter", this._focusNavigationListener), this.element.addEventListener("focusin", this._focusNavigationListener)),
                                this.options.isSticky && this.options.hasTransparentHeader && window.addEventListener("scroll", this._checkTransparentHeaderListener),
                                ("inline" !== this.options.navigationStyle && "logoLeft" !== this.options.navigationStyle) || window.addEventListener("resize", this._verifyNavigationOverlapListener);
                        },
                    },
                    {
                        key: "_setupLocalizationPopovers",
                        value: function () {
                            (this.localizationPopovers = []),
                                h.nodeListToArray(document.querySelectorAll("#header-locale-popover")).forEach(function (e, t) {
                                    e.id = "".concat(e.id, "-").concat(t);
                                }),
                                h.nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (e, t) {
                                    e.setAttribute("aria-controls", "".concat(e.getAttribute("aria-controls"), "-").concat(t));
                                }),
                                h.nodeListToArray(document.querySelectorAll("#header-currency-popover")).forEach(function (e, t) {
                                    e.id = "".concat(e.id, "-").concat(t);
                                }),
                                h.nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (e, t) {
                                    e.setAttribute("aria-controls", "".concat(e.getAttribute("aria-controls"), "-").concat(t));
                                });
                            var e = document.getElementById("header-locale-popover-0");
                            e && this.localizationPopovers.push(new g(e, { preferredAlignment: "center", preferredPosition: "bottom", threshold: 12 }));
                            var t = document.getElementById("header-locale-popover-1");
                            t && this.localizationPopovers.push(new g(t, { preferredAlignment: "center", preferredPosition: "bottom", threshold: 12 }));
                            var i = document.getElementById("header-currency-popover-0");
                            i && this.localizationPopovers.push(new g(i, { preferredAlignment: "center", preferredPosition: "bottom", threshold: 12 }));
                            var n = document.getElementById("header-currency-popover-1");
                            n && this.localizationPopovers.push(new g(n, { preferredAlignment: "center", preferredPosition: "bottom", threshold: 12 }));
                        },
                    },
                    {
                        key: "_focusNavigation",
                        value: function () {
                            var e = this;
                            fastdom.mutate(function () {
                                (e.isTouch && !c.matchesBreakpoint("desk")) || e.element.classList.remove("Header--transparent");
                            });
                        },
                    },
                    {
                        key: "_closeNavigation",
                        value: function () {
                            var e = this;
                            fastdom.mutate(function () {
                                h.nodeListToArray(e.element.querySelectorAll(".is-expanded")).forEach(function (e) {
                                    e.classList.remove("is-expanded");
                                }),
                                    h.nodeListToArray(e.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (e) {
                                        e.setAttribute("aria-hidden", "true");
                                    });
                            }),
                                this.options.hasTransparentHeader && this._checkTransparentHeader();
                        },
                    },
                    {
                        key: "_openMenu",
                        value: function (e, t) {
                            ("mouseenter" === e.type && t !== e.target) ||
                                fastdom.mutate(function () {
                                    t.classList.add("is-expanded"),
                                        h.nodeListToArray(t.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (e) {
                                            e.setAttribute("aria-hidden", "false");
                                        }),
                                        h.getSiblings(t, ".is-expanded").forEach(function (e) {
                                            e.classList.remove("is-expanded"),
                                                h.nodeListToArray(e.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (e) {
                                                    e.setAttribute("aria-hidden", "true");
                                                });
                                        });
                                });
                        },
                    },
                    {
                        key: "_closeMenu",
                        value: function (e, t) {
                            ("mouseleave" === e.type && t !== e.target) ||
                                fastdom.mutate(function () {
                                    t.classList.remove("is-expanded"),
                                        h.nodeListToArray(t.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (e) {
                                            e.setAttribute("aria-hidden", "true");
                                        });
                                });
                        },
                    },
                    {
                        key: "_adjustDropdownPosition",
                        value: function (e, t) {
                            var i = h.nodeListToArray(t.querySelectorAll(".DropdownMenu")),
                                n = !1;
                            fastdom.measure(function () {
                                var e = window.innerWidth,
                                    o = t.getBoundingClientRect().right;
                                i.forEach(function (t) {
                                    o + t.offsetWidth > e && (n = !0);
                                });
                            }),
                                fastdom.mutate(function () {
                                    n
                                        ? i.forEach(function (e) {
                                              e.classList.add("DropdownMenu--reversed");
                                          })
                                        : i.forEach(function (e) {
                                              e.classList.remove("DropdownMenu--reversed");
                                          });
                                });
                        },
                    },
                    {
                        key: "_handleTouchMenu",
                        value: function (e, t) {
                            t.classList.contains("is-expanded") || e.preventDefault();
                        },
                    },
                    {
                        key: "_verifyNavigationOverlap",
                        value: function () {
                            var e = this,
                                t = !1,
                                i = this.element.querySelector(".Header__MainNav");
                            fastdom.measure(function () {
                                if (i) {
                                    var e = h.outerHeightWithMargin(i.querySelector(".HorizontalList__Item"));
                                    i.scrollHeight > e && (t = !0);
                                }
                            }),
                                this.element.classList.remove("Header--logoLeft", "Header--inline", "Header--center"),
                                this.element.classList.add("Header--".concat(this.options.navigationStyle)),
                                this.element.clientWidth,
                                fastdom.mutate(function () {
                                    if (t) {
                                        if ((e.element.classList.remove("Header--".concat(e.options.navigationStyle)), e.element.classList.add("Header--center"), i)) {
                                            var n = new Set();
                                            Array.from(i.querySelectorAll(".HorizontalList__Item")).forEach(function (e) {
                                                n.add(e.getBoundingClientRect().top);
                                            }),
                                                (t = n.size > 1);
                                        }
                                    } else e.element.classList.add("Header--".concat(e.options.navigationStyle)), e.element.classList.remove("Header--center");
                                    e.element.querySelector(".Header__FlexItem--logo").classList.toggle("Header__FlexItem--increaseSpace", t),
                                        e.element.classList.add("Header--initialized"),
                                        fastdom.measure(function () {
                                            document.documentElement.style.setProperty("--header-height", e.element.clientHeight + "px");
                                        });
                                });
                        },
                    },
                    {
                        key: "_checkTransparentHeader",
                        value: function () {
                            var e = this;
                            if (this.options.hasTransparentHeader) {
                                fastdom.measure(function () {
                                    e.lastScrollPosition = window.pageYOffset;
                                }),
                                    fastdom.mutate(function () {
                                        e.lastScrollPosition <= 10 ? e.element.classList.add("Header--transparent") : e.element.classList.remove("Header--transparent");
                                    });
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        K = (function () {
            function t(i) {
                e(this, t), (this.element = i);
                var n = document.getElementById("footer-locale-popover");
                n && (this.localePopover = new g(n, { preferredAlignment: "center", preferredPosition: "top", threshold: 12 }));
                var o = document.getElementById("footer-currency-popover");
                o && (this.currencyPopover = new g(o, { preferredAlignment: "center", preferredPosition: "top", threshold: 12 }));
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.localePopover && this.localePopover.destroy(), this.currencyPopover && this.currencyPopover.destroy();
                        },
                    },
                ]),
                t
            );
        })(),
        Z = (function () {
            function t(i) {
                e(this, t), (this.element = i);
            }
            return i(t, [{ key: "onUnload", value: function () {} }]), t;
        })(),
        J = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.timelineLite = new TimelineLite()),
                    (this.customerLoginForm = this.element.querySelector("#customer_login")),
                    (this.recoverPasswordForm = this.element.querySelector("#recover_customer_password")),
                    this.delegateElement.on("click", '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
            }
            return (
                i(t, [
                    {
                        key: "_showRecoverPassword",
                        value: function () {
                            "block" === this.customerLoginForm.style.display
                                ? this.timelineLite
                                      .fromTo(this.customerLoginForm, 0.5, { autoAlpha: 1, display: "block", y: 0 }, { autoAlpha: 0, y: 20, display: "none" })
                                      .fromTo(this.recoverPasswordForm, 0.5, { autoAlpha: 0, display: "none", y: 20 }, { autoAlpha: 1, display: "block", y: 0, delay: 0.25 })
                                : this.timelineLite
                                      .fromTo(this.recoverPasswordForm, 0.5, { autoAlpha: 1, display: "block", y: 0 }, { autoAlpha: 0, y: 20, display: "none" })
                                      .fromTo(this.customerLoginForm, 0.5, { autoAlpha: 0, display: "none", y: 20 }, { autoAlpha: 1, display: "block", y: 0, delay: 0.25 });
                        },
                    },
                ]),
                t
            );
        })(),
        G = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.options = JSON.parse(i.getAttribute("data-section-settings"))), this.options.apiKey && this.options.mapAddress && this._loadScript().then(this._initMap.bind(this));
            }
            return (
                i(t, [
                    {
                        key: "_loadScript",
                        value: function () {
                            var e = this;
                            return new Promise(function (t, i) {
                                var n = document.createElement("script");
                                document.body.appendChild(n), (n.onload = t), (n.onerror = i), (n.async = !0), (n.src = "https://maps.googleapis.com/maps/api/js?key=".concat(e.options.apiKey));
                            });
                        },
                    },
                    {
                        key: "_initMap",
                        value: function () {
                            var e = this;
                            new google.maps.Geocoder().geocode({ address: this.options.mapAddress }, function (t, i) {
                                if (i !== google.maps.GeocoderStatus.OK) Shopify.designMode;
                                else {
                                    var n = { zoom: e.options.zoom, center: t[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                        o = new google.maps.Map(e.element.querySelector(".FeaturedMap__GMap"), n),
                                        a = o.getCenter();
                                    o.setCenter(a);
                                    var s = {
                                        path:
                                            "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                                        fillColor: e.options.markerColor,
                                        fillOpacity: 1,
                                        anchor: new google.maps.Point(15, 55),
                                        strokeWeight: 0,
                                        scale: 0.6,
                                    };
                                    new google.maps.Marker({ map: o, position: o.getCenter(), icon: s });
                                    var r = new google.maps.StyledMapType(JSON.parse(e.element.querySelector("[data-gmap-style]").innerHTML));
                                    o.mapTypes.set("styled_map", r),
                                        o.setMapTypeId("styled_map"),
                                        google.maps.event.addDomListener(window, "resize", function () {
                                            google.maps.event.trigger(o, "resize"), o.setCenter(a);
                                        });
                                }
                            });
                        },
                    },
                ]),
                t
            );
        })(),
        X = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.delegateElement = new domDelegate.Delegate(this.element)), (this.options = JSON.parse(i.getAttribute("data-section-settings")));
                try {
                    "#newsletter-popup" === window.location.hash && null !== window.theme.pageType
                        ? this._openPopup()
                        : (!this.options.showOnlyOnce || (this.options.showOnlyOnce && null === localStorage.getItem("themePopup"))) && setTimeout(this._openPopup.bind(this), 1e3 * this.options.apparitionDelay);
                } catch (e) {}
                this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "onSelect",
                        value: function () {
                            this._openPopup();
                        },
                    },
                    {
                        key: "onDeselect",
                        value: function () {
                            this._closePopup();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this));
                        },
                    },
                    {
                        key: "_openPopup",
                        value: function () {
                            this.element.setAttribute("aria-hidden", "false"), localStorage.setItem("themePopup", "true");
                        },
                    },
                    {
                        key: "_closePopup",
                        value: function () {
                            this.element.setAttribute("aria-hidden", "true");
                        },
                    },
                ]),
                t
            );
        })(),
        $ = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    this.options.useRecommendations ? this._loadRecommendations().then(this._createSlideshow.bind(this)) : this._createSlideshow();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.carousel.destroy();
                        },
                    },
                    {
                        key: "_loadRecommendations",
                        value: function () {
                            var e = this,
                                t = ""
                                    .concat(window.routes.productRecommendationsUrl, "?section_id=")
                                    .concat(this.element.getAttribute("data-section-id"), "&product_id=")
                                    .concat(this.options.productId, "&limit=")
                                    .concat(this.options.recommendationsCount);
                            return fetch(t).then(function (t) {
                                return t.text().then(function (t) {
                                    var i = document.createElement("div");
                                    (i.innerHTML = t), (e.element.querySelector(".ProductRecommendations").innerHTML = i.querySelector(".ProductRecommendations").innerHTML);

                                  
                                         e.form_container_arr = e.element.querySelectorAll('.ProductFormWrapper'); 
            for (var i = 0; i < e.form_container_arr.length; ++i) {
              var form_container = e.form_container_arr[i];
              var form_options = JSON.parse(form_container.getAttribute('data-section-settings'));
                e.productVariants = new T(form_container, form_options);
            }	 
                                  
                                });
                            });
                        },
                    },
                    {
                        key: "_createSlideshow",
                        value: function () {
                            var e = this.element.querySelector("[data-flickity-config]");
                            e && ((this.carousel = new d(e)), new w(this.element));
                        },
                    },
                ]),
                t
            );
        })(),
        ee = (function () {
            function t(i) {
                var n = this;
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.viewInSpaceElement = this.element.querySelector("[data-shopify-xr]")),
                    (this.productVariants = new T(i, this.options,this)),
                    (this.productReviews = new L(i));
                var o = this.element.querySelector(".Product__Slideshow");
                o &&
                    ((this.productSlideshow = new d(o, { onSelect: this._onImageChanged.bind(this), onSettle: this._onImageSettled.bind(this) }, { draggable: !c.matchesBreakpoint("supports-hover") })),
                    (this.mediaList = {}),
                    (this.previouslySelectedMedia = null),
                    o.querySelectorAll('[data-media-type="model"]').forEach(function (e) {
                        n.mediaList[e.getAttribute("data-media-id")] = new S(e, n.options.stackProductImages);
                    }),
                    o.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (e) {
                        n.mediaList[e.getAttribute("data-media-id")] = new P(e, n.options.stackProductImages, n.options.enableVideoLooping);
                    }),
                    this.options.stackProductImages &&
                        ((this.slideshowNavDots = this.element.querySelector(".Product__SlideshowNav--dots")), (this.slideshowNavDotsItems = this.slideshowNavDots ? h.nodeListToArray(this.slideshowNavDots.querySelectorAll("a")) : [])),
                    this.options.showThumbnails &&
                        ((this.slideshowNavThumbnails = this.element.querySelector(".Product__SlideshowNav--thumbnails")),
                        (this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? h.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll(".Product__SlideshowNavImage")) : [])),
                    (this.slideshowImages = h.nodeListToArray(o.querySelectorAll(".Carousel__Cell"))),
                    this._setupSlideshowMobileNav()),
                    (this.productWrapperElement = this.element.querySelector(".Product__Wrapper")),
                    (this.productInfoElement = this.element.querySelector(".Product__Info")),
                    (this.productAsideElement = this.element.querySelector(".Product__Aside")),
                    (this.productGalleryElement = this.element.querySelector(".Product__Gallery")),
                    (this.quickNav = this.element.querySelector(".Product__QuickNav")),
                    this.options.enableImageZoom && (this.imageZoomInstance = new k(this.element, this.productSlideshow)),
                    Stickyfill.addOne(this.productInfoElement);
                var a = this.element.querySelector(".Product__OffScreen");
                a && this.element.appendChild(a), this._setupDeviceFeatures(), this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off("click"),
                                this.productReviews.destroy(),
                                this.productVariants && this.productVariants.destroy(),
                                this.productSlideshow && this.productSlideshow.destroy(),
                                this.options.enableImageZoom && this.imageZoomInstance.destroy(),
                                this.carouselNavScrollSpy && this.carouselNavScrollSpy.destroy(),
                                this.quickNav && window.removeEventListener("scroll", this._checkQuickNavListener),
                                this.productInfoScroller && this.productInfoScroller.destroy(),
                                this.productThumbnailsScroller && this.productThumbnailsScroller.destroy(),
                                window.ResizeObserver && this.productInfoResizeObserver && this.productInfoResizeObserver.disconnect(),
                                Stickyfill.removeOne(this.productInfoElement),
                                document.removeEventListener("breakpoint:changed", this._onBreakpointChangedListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this)),
                                (this._checkQuickNavListener = this._checkQuickNav.bind(this)),
                                this.delegateElement.on("click", '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this)),
                                this.delegateElement.on("variant:changed", this._updateSlideshowImage.bind(this)),
                                this.delegateElement.on("scrollspy:target:changed", this._onScrollTargetChanged.bind(this)),
                                this.delegateElement.on("model:played", this._onMediaPlayed.bind(this)),
                                this.delegateElement.on("video:played", this._onMediaPlayed.bind(this)),
                                this.delegateElement.on("model:paused", this._onMediaPaused.bind(this)),
                                this.delegateElement.on("video:paused", this._onMediaPaused.bind(this)),
                                document.addEventListener("breakpoint:changed", this._onBreakpointChangedListener),
                                this.quickNav && window.addEventListener("scroll", this._checkQuickNavListener),
                                !this.options.stackProductImages && this.options.showThumbnails && this.delegateElement.on("click", ".Product__SlideshowNavImage", this._switchToImage.bind(this));
                        },
                    },
                    {
                        key: "_setupSlideshowMobileNav",
                        value: function () {
                            var e = this;
                            if (((this.slideshowMobileNav = this.element.querySelector(".Product__SlideshowMobileNav")), this.slideshowMobileNav)) {
                                var t = new domDelegate.Delegate(this.slideshowMobileNav);
                                t.on("click", ".dot", function (t, i) {
                                    e._slideWillChange(), e.productSlideshow.selectCell(parseInt(i.getAttribute("data-index")));
                                }),
                                    t.on("click", ".Product__SlideshowNavArrow", function (t, i) {
                                        e._slideWillChange(), "next" === i.getAttribute("data-direction") ? e.productSlideshow.next() : e.productSlideshow.previous();
                                    });
                            }
                        },
                    },
                    {
                        key: "_updateSlideshowImage",
                        value: function (e) {
                            var t = e.detail.variant,
                                i = e.detail.previousVariant;
                            if (t && t.featured_media && (!i || !i.featured_media || i.featured_media.id !== t.featured_media.id))
                                if ((this._slideWillChange(), c.matchesBreakpoint("pocket") || !this.options.stackProductImages))
                                    for (var n = 0; n !== this.productSlideshow.flickityInstance.cells.length; ++n) {
                                        var o = this.productSlideshow.flickityInstance.cells[n].element;
                                        parseInt(o.getAttribute("data-media-id")) === t.featured_media.id && this.productSlideshow.selectCell(parseInt(o.getAttribute("data-media-position")) - 1);
                                    }
                                else document.querySelector('[href="#Media'.concat(t.featured_media.id, '"]')).click();
                        },
                    },
                    {
                        key: "_onMediaPlayed",
                        value: function (e) {
                            (this.productSlideshow.getFlickityInstance().options.draggable = !1),
                                this.productSlideshow.getFlickityInstance().unbindDrag(),
                                this.previouslySelectedMedia && this.previouslySelectedMedia !== e.target && this.mediaList[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected(),
                                this.options.stackProductImages && (this.previouslySelectedMedia = e.target);
                        },
                    },
                    {
                        key: "_onMediaPaused",
                        value: function () {
                            (this.productSlideshow.getFlickityInstance().options.draggable = !c.matchesBreakpoint("supports-hover")), this.productSlideshow.getFlickityInstance().bindDrag();
                        },
                    },
                    {
                        key: "_handleMedia",
                        value: function (e) {
                            if (this.previouslySelectedMedia && this.previouslySelectedMedia !== e) {
                                switch (this.previouslySelectedMedia.getAttribute("data-media-type")) {
                                    case "video":
                                    case "external_video":
                                    case "model":
                                        this.mediaList[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected();
                                }
                                "model" === this.previouslySelectedMedia.getAttribute("data-media-type") &&
                                    this.viewInSpaceElement &&
                                    this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"));
                            }
                            switch (e.getAttribute("data-media-type")) {
                                case "video":
                                case "external_video":
                                case "model":
                                    this.mediaList[e.getAttribute("data-media-id")].hasBeenSelected();
                            }
                            "model" === e.getAttribute("data-media-type") && this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", e.getAttribute("data-media-id")), (this.previouslySelectedMedia = e);
                        },
                    },
                    {
                        key: "_onScrollTargetChanged",
                        value: function (e) {
                            //console.log("here");
                            this.options.stackProductImages &&
                                (this.slideshowNavDotsItems.forEach(function (e) {
                                    return e.classList.remove("is-selected");
                                }),
                                this.slideshowNavDotsItems[parseInt(e.detail.newTarget.getAttribute("data-media-position")) - 1].classList.add("is-selected"),
                                this.options.showThumbnails &&
                                    (this.slideshowNavThumbnailsItems.forEach(function (e) {
                                        return e.classList.remove("is-selected");
                                    }),
                                    this.slideshowNavThumbnailsItems[parseInt(e.detail.newTarget.getAttribute("data-media-position")) - 1].classList.add("is-selected")));
                        },
                    },
                    {
                        key: "_switchToImage",
                        value: function (e, t) {
                            e.preventDefault(), this._slideWillChange();
                            for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
                                var n = this.productSlideshow.flickityInstance.cells[i].element;
                                parseInt(n.getAttribute("data-media-id")) === parseInt(t.getAttribute("data-media-id")) && this.productSlideshow.selectCell(parseInt(n.getAttribute("data-media-position")) - 1);
                            }
                        },
                    },
                    {
                        key: "_checkQuickNav",
                        value: function () {
                            var e = this,
                                t = !1;
                            fastdom.measure(function () {
                                t = window.scrollY >= e.productAsideElement.offsetTop - e.productAsideElement.clientHeight;
                            }),
                                fastdom.mutate(function () {
                                    t ? e.quickNav.classList.add("is-flipped") : e.quickNav.classList.remove("is-flipped");
                                });
                        },
                    },
                    {
                        key: "_toggleSocialShare",
                        value: function (e, t) {
                            t.classList.toggle("is-active"),
                                t.classList.toggle("RoundButton--secondaryState"),
                                t.setAttribute("aria-expanded", "true" === t.getAttribute("aria-expanded") ? "false" : "true"),
                                t.nextElementSibling.setAttribute("aria-hidden", "true" === t.nextElementSibling.getAttribute("aria-hidden") ? "false" : "true");
                        },
                    },
                    {
                        key: "_onImageChanged",
                        value: function (e, t) {
                            if (c.matchesBreakpoint("pocket")) {
                                var i = this.element.querySelector(".Product__Gallery .Product__ActionList");
                                i && (t.classList.contains("Product__SlideItem--image") ? i.classList.remove("is-hidden") : i.classList.add("is-hidden"));
                            }
                            if (!this.options.stackProductImages && this.options.showThumbnails) {
                                var n = t.getAttribute("data-media-id");
                                this.slideshowNavThumbnailsItems.forEach(function (e) {
                                    e.getAttribute("data-media-id") === n ? e.classList.add("is-selected") : e.classList.remove("is-selected");
                                });
                            }
                            if (this.slideshowMobileNav) {
                                var o = parseInt(t.getAttribute("data-media-position")) - 1;
                                h.nodeListToArray(this.slideshowMobileNav.querySelectorAll(".dot")).forEach(function (e, t) {
                                    t === o ? e.classList.add("is-selected") : e.classList.remove("is-selected");
                                });
                            }
                        },
                    },
                    {
                        key: "_onImageSettled",
                        value: function (e, t) {
                            (this._handleMedia(t), c.matchesBreakpoint("lap-and-up")) &&
                                this.element.querySelectorAll(".Product__SlideItem:not(.is-selected)").forEach(function (e) {
                                    e.classList.add("Product__SlideItem--hidden");
                                });
                        },
                    },
                    {
                        key: "_slideWillChange",
                        value: function () {
                            c.matchesBreakpoint("lap-and-up") &&
                                this.element.querySelectorAll(".Product__SlideItem").forEach(function (e) {
                                    e.classList.remove("Product__SlideItem--hidden");
                                });
                        },
                    },
                    {
                        key: "_setupDeviceFeatures",
                        value: function (e) {
                            var t = this,
                                i = e ? e.detail.currentBreakpoint : c.getCurrentBreakpoint();
                            if (i !== (e ? e.detail.previousBreakpoint : null))
                                if ("phone" === i || "tablet" === i)
                                    this.carouselNavScrollSpy && this.carouselNavScrollSpy.destroy(),
                                        this.productInfoScroller && this.productInfoScroller.destroy(),
                                        this.productThumbnailsScroller && this.productThumbnailsScroller.destroy(),
                                        this.productAsideElement ? (this.productAsideElement.style.minHeight = null) : (this.productWrapperElement.style.minHeight = null),
                                        (this.productInfoElement.parentNode.style.maxHeight = null);
                                else {
                                    if (this.slideshowImages && this.slideshowImages.length > 1) {
                                        var n = 0;
                                        this.options.stackProductImages && this.slideshowNavDots && (n = this.slideshowNavDots.firstElementChild.offsetTop),
                                            this.options.showThumbnails && c.matchesBreakpoint("desk") && (n = 250),
                                            (this.carouselNavScrollSpy = new x(this.element, this.slideshowImages, { rootMargin: "-".concat(n, "px 0px 0px 0px") }));
                                    }
                                    var o = window.getComputedStyle(this.productInfoElement),
                                        a = parseInt(o.paddingTop) + parseInt(o.paddingBottom),
                                        s = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0,
                                        r = function () {
                                            t.productAsideElement
                                                ? ((t.productAsideElement.style.minHeight = "".concat(t.productInfoElement.scrollHeight - a - s, "px")),
                                                  (t.productInfoElement.closest(".Product__InfoWrapper").style.maxHeight = t.productAsideElement.offsetTop + t.productInfoElement.scrollHeight - a + "px"))
                                                : (t.productWrapperElement.style.minHeight = "".concat(t.productInfoElement.scrollHeight - parseInt(o.paddingTop), "px"));
                                        };
                                    r(),
                                        window.ResizeObserver &&
                                            ((this.productInfoResizeObserver = new ResizeObserver(function () {
                                                r();
                                            })),
                                            this.productInfoResizeObserver.observe(this.productInfoElement)),
                                        (this.productInfoScroller = new R(this.productInfoElement)),
                                        this.options.showThumbnails && this.slideshowNavThumbnails && (this.productThumbnailsScroller = new R(this.slideshowNavThumbnails));
                                }
                        },
                    },
                ]),
                t
            );
        })(),
        te = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))), new w(this.element), this._fetchProducts();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.carousel && this.carousel.destroy();
                        },
                    },
                    {
                        key: "_fetchProducts",
                        value: function () {
                            var e = this,
                                t = this._getSearchQueryString();
                            "" !== t &&
                                fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&type=product&q=").concat(t), { credentials: "same-origin", method: "GET" }).then(function (t) {
                                    t.text().then(function (t) {
                                        var i = document.createElement("div");
                                        (i.innerHTML = t),
                                            (e.element.innerHTML = i.querySelector(".Section").innerHTML),
                                            (e.element.parentNode.style.display = "block"),
                                            (e.carousel = new d(e.element.querySelector("[data-flickity-config]")));

                                                                   
                                               e.form_container_arr = e.element.querySelectorAll('.ProductFormWrapper'); 
            for (var i = 0; i < e.form_container_arr.length; ++i) {
              var form_container = e.form_container_arr[i];
              var form_options = JSON.parse(form_container.getAttribute('data-section-settings'));
              e.productVariants = new T(form_container, form_options);
            }
                                      
                                    });
                                });
                        },
                    },
                    {
                        key: "_getSearchQueryString",
                        value: function () {
                            var e = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
                            return (
                                e.includes(this.options.productId) && e.splice(e.indexOf(this.options.productId), 1),
                                e
                                    .map(function (e) {
                                        return "id:" + e;
                                    })
                                    .join(" OR ")
                            );
                        },
                    },
                ]),
                t
            );
        })(),
        ie = (function () {
            function t() {
                e(this, t), (this.constructors = []), (this.instances = []), this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
                                document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
                                document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
                                document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
                                document.addEventListener("shopify:section:reorder", this._onReorder.bind(this)),
                                document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
                                document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
                        },
                    },
                    {
                        key: "register",
                        value: function (e, t) {
                            var i = this;
                            (this.constructors[e] = t),
                                h.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(e, "]"))).forEach(function (e) {
                                    i._createInstance(e, t);
                                });
                        },
                    },
                    {
                        key: "_findInstance",
                        value: function (e, t, i) {
                            for (var n = 0; n < e.length; n++) if (e[n][t] === i) return e[n];
                        },
                    },
                    {
                        key: "_removeInstance",
                        value: function (e, t, i) {
                            for (var n = e.length; n--; )
                                if (e[n][t] === i) {
                                    e.splice(n, 1);
                                    break;
                                }
                            return e;
                        },
                    },
                    {
                        key: "_onSectionLoad",
                        value: function (e) {
                            var t = e.target.querySelector("[data-section-id]");
                            t && this._createInstance(t);
                        },
                    },
                    {
                        key: "_onSectionUnload",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && ("function" == typeof t.onUnload && t.onUnload(e), (this.instances = this._removeInstance(this.instances, "id", e.detail.sectionId)));
                        },
                    },
                    {
                        key: "_onSelect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onSelect && t.onSelect(e);
                        },
                    },
                    {
                        key: "_onDeselect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onDeselect && t.onDeselect(e);
                        },
                    },
                    {
                        key: "_onReorder",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onReorder && t.onReorder(e);
                        },
                    },
                    {
                        key: "_onBlockSelect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                        },
                    },
                    {
                        key: "_onBlockDeselect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                        },
                    },
                    {
                        key: "_createInstance",
                        value: function (e, t) {
                            var i = e.getAttribute("data-section-id"),
                                n = e.getAttribute("data-section-type");
                            if (void 0 !== (t = t || this.constructors[n])) {
                                var o = Object.assign(new t(e), { id: i, type: n, container: e });
                                this.instances.push(o);
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        ne = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.carousel = new d(this.element.querySelector("[data-flickity-config]"))), new w(this.element);
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.carousel.destroy();
                        },
                    },
                ]),
                t
            );
        })(),
        oe = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.usePocketMode = c.matchesBreakpoint("pocket")),
                    (this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]')),
                    this._createOuterCarousel(),
                    this._createPocketPopovers(),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.outerCarousel.destroy(),
                                this.innerCarousels.forEach(function (e) {
                                    e.forEach(function (e) {
                                        return e.destroy();
                                    });
                                }),
                                this.popovers.forEach(function (e) {
                                    return e.destroy();
                                }),
                                this.delegateElement.off();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.outerCarousel.selectCell(e.target.getAttribute("data-slide-index"), !0, !e.detail.load);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", ".ShopTheLook__Dot", this._onDotClicked.bind(this));
                        },
                    },
                    {
                        key: "_createPocketPopovers",
                        value: function () {
                            var e = this;
                            (this.popovers = []),
                                h.nodeListToArray(this.element.querySelectorAll(".Popover")).forEach(function (t) {
                                    e.popovers.push(new g(t, { activator: e.pocketActivatorButton, showOverlay: !1, onOpen: e._openPocketZoom.bind(e), onClose: e._closePocketZoom.bind(e) }));
                                });
                        },
                    },
                    {
                        key: "_createOuterCarousel",
                        value: function () {
                            var e = this;
                            (this.outerCarousel = new d(this.element.querySelector(".ShopTheLook"), { onSelect: this._onLookChanged.bind(this) })), (this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length));
                            for (var t = 0; t !== this.innerCarousels.length; ++t) this.innerCarousels[t] = [];
                            h.nodeListToArray(this.element.querySelectorAll(".ShopTheLook__ProductList")).forEach(function (t) {
                                var i = parseInt(t.getAttribute("data-look-index"));
                                e.innerCarousels[i].push(new d(t, { onSelect: e._onProductChanged.bind(e) })), t.insertBefore(t.querySelector(".flickity-viewport"), t.querySelector(".ShopTheLook__ViewButton"));
                            }),
                                this.outerCarousel.resize();
                        },
                    },
                    {
                        key: "_onLookChanged",
                        value: function (e, t) {
                            this.pocketActivatorButton.setAttribute("aria-controls", "".concat(t.getAttribute("id"), "-popover"));
                        },
                    },
                    {
                        key: "_onProductChanged",
                        value: function (e, t) {
                            var i = this.outerCarousel.getSelectedCell(),
                                n = null;
                            h.nodeListToArray(i.querySelectorAll(".ShopTheLook__Dot")).forEach(function (t, i) {
                                t.classList.remove("is-active"), i === e && (t.classList.add("is-active"), (n = t));
                            }),
                                i.querySelector(".ShopTheLook__ViewButton").setAttribute("href", t.getAttribute("data-product-url")),
                                i.dispatchEvent(new CustomEvent("product:changed", { detail: { dot: n } }));
                        },
                    },
                    {
                        key: "_onDotClicked",
                        value: function (e, t) {
                            var i = !1,
                                n = !1,
                                o = this.outerCarousel.getSelectedIndex();
                            this.popovers.forEach(function (e) {
                                e.isOpen && ((n = !0), (i = !0));
                            }),
                                this.innerCarousels[o].forEach(function (e) {
                                    e.selectCell(parseInt(t.getAttribute("data-product-index")) - 1, !1, i);
                                }),
                                this.usePocketMode && !n && this.popovers[o].open();
                        },
                    },
                    {
                        key: "_openPocketZoom",
                        value: function (e) {
                            var t = this;
                            this._calculateImageTransform(e),
                                fastdom.mutate(function () {
                                    (document.getElementById("shopify-section-header").style.cssText = "transform: translateY(-100%); transition: transform 0.3s ease-in-out;"),
                                        t.outerCarousel.flickityInstance.unbindDrag(),
                                        t.outerCarousel.flickityInstance.element.classList.add("is-zoomed"),
                                        t.outerCarousel.getSelectedCell().classList.add("is-expanded");
                                });
                        },
                    },
                    {
                        key: "_calculateImageTransform",
                        value: function (e) {
                            var t = this,
                                i = this.outerCarousel.getSelectedCell();
                            fastdom.measure(function () {
                                var n = window.innerWidth / (i.offsetWidth - 2 * parseInt(window.getComputedStyle(i).paddingLeft)),
                                    o = Math.round(i.offsetHeight * n),
                                    a = Math.round(Math.max(o - (window.innerHeight - e.element.offsetHeight), 0)),
                                    s = o - a,
                                    r = Math.round(-(i.getBoundingClientRect().top - (o - i.offsetHeight) / 2)),
                                    l = Math.round(r - a);
                                (t._calculateTransformForDotListener = function (e) {
                                    var i = Math.round((e.detail.dot.offsetTop + e.detail.dot.offsetHeight / 2) * n),
                                        o = Math.round(i - s / 2),
                                        a = Math.min(Math.max(r - o, l), r);
                                    fastdom.mutate(function () {
                                        t.outerCarousel.flickityInstance.viewport.style.transform = "translate3d(0, ".concat(Math.round(a), "px, 0) scale(").concat(n, ")");
                                    });
                                }),
                                    i.addEventListener("product:changed", t._calculateTransformForDotListener),
                                    i.dispatchEvent(new CustomEvent("product:changed", { detail: { dot: i.querySelector(".ShopTheLook__Dot.is-active") } }));
                            });
                        },
                    },
                    {
                        key: "_closePocketZoom",
                        value: function () {
                            var e = this,
                                t = this.outerCarousel.getSelectedCell();
                            t.removeEventListener("product:changed", this._calculateTransformForDotListener),
                                fastdom.mutate(function () {
                                    (document.getElementById("shopify-section-header").style.cssText = "transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;"),
                                        e.outerCarousel.flickityInstance.bindDrag(),
                                        e.outerCarousel.flickityInstance.element.classList.remove("is-zoomed"),
                                        (e.outerCarousel.flickityInstance.viewport.style.transform = null),
                                        t.classList.remove("is-expanded");
                                });
                        },
                    },
                ]),
                t
            );
        })(),
        ae = (function () {
            function t(i) {
                e(this, t), (this.element = i), (this.sidebarDrawer = new v(i));
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.sidebarDrawer.destroy();
                        },
                    },
                    {
                        key: "onSelect",
                        value: function () {
                            this.sidebarDrawer.open();
                        },
                    },
                    {
                        key: "onDeselect",
                        value: function () {
                            this.sidebarDrawer.close();
                        },
                    },
                ]),
                t
            );
        })(),
        se = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.slideshow = new d(this.element.querySelector("[data-flickity-config]"), { onSelect: this._onSlideChanged.bind(this) })),
                    (this.selectedSlide = null),
                    (this.shouldAnimate = !0),
                    (this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 })),
                    this.slideshow.flickityInstance.cells.length > 0 && this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, !0),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.slideshow.destroy(), this.timeline.kill(), this.delegateElement.off(), document.removeEventListener("breakpoint:changed", this._onBreakpointChangedListener);
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.stopPlayer(),
                                (this.shouldAnimate = !e.detail.load),
                                this.slideshow.selectCell(e.target.getAttribute("data-slide-index"), !1, !e.detail.load);
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function () {
                            (this.shouldAnimate = !0), this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.playPlayer();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this)),
                                this.delegateElement.on("mouseenter", ".Button", this._pauseSlideshow.bind(this), !0),
                                this.delegateElement.on("mouseleave", ".Button", this._resumeSlideshow.bind(this), !0),
                                document.addEventListener("breakpoint:changed", this._onBreakpointChangedListener);
                        },
                    },
                    {
                        key: "_pauseSlideshow",
                        value: function () {
                            this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.pausePlayer();
                        },
                    },
                    {
                        key: "_resumeSlideshow",
                        value: function () {
                            this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.unpausePlayer();
                        },
                    },
                    {
                        key: "_onSlideChanged",
                        value: function (e, t) {
                            this._transitionToSlide(t);
                            var allVidos = this.element.querySelectorAll('video');
                            var curentVideos = t.querySelectorAll('video');
                          
                            if (allVidos.length) {
                              allVidos.forEach(function (item) {
                                item.pause();
                              });
                            }

                            if (curentVideos.length) {
                              curentVideos.forEach(function (item) {
                                item.play();
                              });
                            }
                        },
                    },
                    {
                        key: "_transitionToSlide",
                        value: function (e) {
                            var t = this;
                            this.timeline.clear(),
                                this.selectedSlide && (this._slideLeave(this.selectedSlide), this.timeline.addLabel("enter", this.shouldAnimate ? "-=0.4" : 0)),
                                this._lazyLoadNextImage(),
                                this.timeline.fromTo(e, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, { autoAlpha: 0 }, { autoAlpha: 1, ease: Cubic.easeInOut }, "enter"),
                                this.slideshow.flickityInstance.options.autoPlay && "playing" === this.slideshow.flickityInstance.player.state && this.slideshow.flickityInstance.pausePlayer(),
                                h.nodeListToArray(e.querySelectorAll(".Slideshow__Image")).forEach(function (i) {
                                    i.classList.contains("Image--lazyLoading") || i.classList.contains("Image--lazyLoad") ? i.addEventListener("lazyloaded", t._slideEnter.bind(t, e)) : t._slideEnter(e);
                                }),
                                (this.selectedSlide = e);
                        },
                    },
                    {
                        key: "_slideLeave",
                        value: function (e) {
                            var t = e.querySelector(".SectionHeader"),
                                i = e.querySelector(".SectionHeader__ButtonWrapper");
                            this.timeline.fromTo(e, this.shouldAnimate ? 0.3 : 0, { autoAlpha: 1 }, { autoAlpha: 0, ease: Cubic.easeInOut, delay: this.shouldAnimate ? 0.35 : 0 }),
                                t && this.timeline.fromTo(t, this.shouldAnimate ? 0.4 : 0, { autoAlpha: 1, y: 0 }, { autoAlpha: 0, y: 20, ease: Cubic.easeIn }, 0),
                                i && this.timeline.fromTo(i, this.shouldAnimate ? 0.4 : 0, { autoAlpha: 1, y: 0 }, { autoAlpha: 0, y: 10, ease: Cubic.easeIn }, 0);
                        },
                    },
                    {
                        key: "_slideEnter",
                        value: function (e) {
                            var t = e.querySelectorAll(".Slideshow__Image"),
                                i = e.querySelector(".SectionHeader"),
                                n = e.querySelector(".SectionHeader__ButtonWrapper");
                            this.slideshow.flickityInstance.options.autoPlay && "paused" === this.slideshow.flickityInstance.player.state && this.slideshow.flickityInstance.unpausePlayer(),
                                window.CSS &&
                                    window.CSS.supports("(object-fit: cover) or (-o-object-fit: cover)") &&
                                    (window.theme.showImageZooming
                                        ? this.timeline.fromTo(t, this.shouldAnimate ? 1.2 : 0, { opacity: 0, scale: 1.2 }, { opacity: 1, scale: 1, ease: Quad.easeOut }, "enter")
                                        : this.timeline.fromTo(t, this.shouldAnimate ? 1.2 : 0, { opacity: 0 }, { opacity: 1, ease: Quad.easeOut }, "enter")),
                                i && this.timeline.fromTo(i, this.shouldAnimate ? 0.8 : 0, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, delay: this.shouldAnimate ? 0.8 : 0, ease: Cubic.easeOut }, "enter"),
                                n && this.timeline.fromTo(n, this.shouldAnimate ? 0.8 : 0, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: this.shouldAnimate ? 0.8 : 0, ease: Cubic.easeOut }, "enter");
                        },
                    },
                    {
                        key: "_lazyLoadNextImage",
                        value: function () {
                            var e = this.slideshow.flickityInstance.selectedIndex,
                                t = c.getCurrentBreakpoint();
                            if (this.slideshow.flickityInstance.cells.length - 1 > e) {
                                var i = this.slideshow.flickityInstance.cells[e + 1].element,
                                    n = h.nodeListToArray(i.querySelectorAll(".Slideshow__ImageContainer")),
                                    o = null;
                                (o = "phone" === t ? n[0] : n[1]), window.lazySizes && o && o.classList.contains("Image--lazyLoad") && lazySizes.loader.unveil(o.firstElementChild);
                            }
                        },
                    },
                    {
                        key: "_onBreakpointChanged",
                        value: function (e) {
                            (("phone" === e.detail.previousBreakpoint && "phone" !== e.detail.currentBreakpoint) || ("phone" !== e.detail.previousBreakpoint && "phone" === e.detail.currentBreakpoint)) &&
                                ((this.selectedSlide = null), this._transitionToSlide(this.slideshow.flickityInstance.selectedElement));
                        },
                    },
                ]),
                t
            );
        })(),
        re = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.navItems = h.nodeListToArray(this.element.querySelectorAll(".TestimonialNav__Item"))),
                    (this.carousel = new d(this.element.querySelector(".TestimonialList"), { onSelect: this._testimonialChanged.bind(this) })),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.carousel.destroy(), this.delegateElement.off("click");
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.carousel.selectCell(e.target.getAttribute("data-slide-index"), !0);
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function () {
                            this.carousel.unpausePlayer();
                        },
                    },
                    {
                        key: "_testimonialClicked",
                        value: function (e, t) {
                            this.carousel.pausePlayer(), this.carousel.selectCell(parseInt(t.getAttribute("data-index"))), this.carousel.unpausePlayer();
                        },
                    },
                    {
                        key: "_testimonialChanged",
                        value: function (e) {
                            this.navItems.forEach(function (t, i) {
                                t.classList.remove("is-selected"), e === i && t.classList.add("is-selected");
                            });
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", ".TestimonialNav__Item", this._testimonialClicked.bind(this));
                        },
                    },
                ]),
                t
            );
        })(),
        le = (function () {
            function t(i) {
                e(this, t),
                    (this.element = i),
                    (this.delegateElement = new domDelegate.Delegate(this.element)),
                    (this.items = h.nodeListToArray(this.element.querySelectorAll(".Timeline__Item"))),
                    (this.navItems = h.nodeListToArray(this.element.querySelectorAll(".Timeline__NavItem"))),
                    this._attachListeners();
            }
            return (
                i(t, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off("click");
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.navItems[parseInt(e.target.getAttribute("data-index"))].click();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", ".Timeline__NavItem", this._clickOnNavItem.bind(this));
                        },
                    },
                    {
                        key: "_clickOnNavItem",
                        value: function (e, t) {
                            var i = this.items[parseInt(t.getAttribute("data-index"))];
                            if (!i.classList.contains("is-selected")) {
                                var n = !1,
                                    o = t.parentNode,
                                    a = 0;
                                fastdom.measure(function () {
                                    var e = o.scrollWidth,
                                        i = o.offsetWidth;
                                    if ((n = i < e)) {
                                        var s = t.offsetLeft,
                                            r = null,
                                            l = (r = s <= i - (s + t.offsetWidth) ? t.previousElementSibling || t : t.nextElementSibling || t).offsetLeft - o.scrollLeft,
                                            c = l + r.offsetWidth;
                                        c > i ? (a = c - i) : l < 0 && (a = l);
                                    }
                                }),
                                    fastdom.mutate(function () {
                                        n && o.scrollBy({ behavior: "smooth", left: a }),
                                            t.classList.add("is-selected"),
                                            h.getSiblings(t, ".is-selected").forEach(function (e) {
                                                e.classList.remove("is-selected");
                                            }),
                                            i.classList.add("is-selected"),
                                            h.getSiblings(i, ".is-selected").forEach(function (e) {
                                                e.classList.remove("is-selected");
                                            });
                                    });
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        ce = (function (t) {
            !(function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), t && o(e, t);
            })(u, r(HTMLElement));
            var s,
                c,
                d =
                    ((s = u),
                    (c = a()),
                    function () {
                        var e,
                            t = n(s);
                        if (c) {
                            var i = n(this).constructor;
                            e = Reflect.construct(t, arguments, i);
                        } else e = t.apply(this, arguments);
                        return l(this, e);
                    });
            function u() {
                return e(this, u), d.apply(this, arguments);
            }
            return (
                i(u, [
                    {
                        key: "connectedCallback",
                        value: function () {
                            var e = this;
                            (this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child")),
                                (this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child")),
                                (this.textInputLowerBound = this.querySelector(".price-range__input:first-child input")),
                                (this.textInputHigherBound = this.querySelector(".price-range__input:last-child input")),
                                this.textInputLowerBound.addEventListener("focus", function () {
                                    return e.textInputLowerBound.select();
                                }),
                                this.textInputHigherBound.addEventListener("focus", function () {
                                    return e.textInputHigherBound.select();
                                }),
                                this.textInputLowerBound.addEventListener("change", function (t) {
                                    (t.target.value = Math.max(Math.min(parseInt(t.target.value), parseInt(e.textInputHigherBound.value || t.target.max) - 1), t.target.min)),
                                        (e.rangeLowerBound.value = t.target.value),
                                        e.rangeLowerBound.parentElement.style.setProperty("--range-min", "".concat((parseInt(e.rangeLowerBound.value) / parseInt(e.rangeLowerBound.max)) * 100, "%"));
                                }),
                                this.textInputHigherBound.addEventListener("change", function (t) {
                                    (t.target.value = Math.min(Math.max(parseInt(t.target.value), parseInt(e.textInputLowerBound.value || t.target.min) + 1), t.target.max)),
                                        (e.rangeHigherBound.value = t.target.value),
                                        e.rangeHigherBound.parentElement.style.setProperty("--range-max", "".concat((parseInt(e.rangeHigherBound.value) / parseInt(e.rangeHigherBound.max)) * 100, "%"));
                                }),
                                this.rangeLowerBound.addEventListener("change", function (t) {
                                    (e.textInputLowerBound.value = t.target.value), e.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: !0 }));
                                }),
                                this.rangeHigherBound.addEventListener("change", function (t) {
                                    (e.textInputHigherBound.value = t.target.value), e.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: !0 }));
                                }),
                                this.rangeLowerBound.addEventListener("input", function (t) {
                                    (t.target.value = Math.min(parseInt(t.target.value), parseInt(e.textInputHigherBound.value || t.target.max) - 1)),
                                        t.target.parentElement.style.setProperty("--range-min", "".concat((parseInt(t.target.value) / parseInt(t.target.max)) * 100, "%")),
                                        (e.textInputLowerBound.value = t.target.value);
                                }),
                                this.rangeHigherBound.addEventListener("input", function (t) {
                                    (t.target.value = Math.max(parseInt(t.target.value), parseInt(e.textInputLowerBound.value || t.target.min) + 1)),
                                        t.target.parentElement.style.setProperty("--range-max", "".concat((parseInt(t.target.value) / parseInt(t.target.max)) * 100, "%")),
                                        (e.textInputHigherBound.value = t.target.value);
                                });
                        },
                    },
                ]),
                u
            );
        })();
    window.customElements.define("price-range", ce),
        (function () {
            new p(), new y(), new c(), "password" !== window.theme.pageType && "gift_card" !== window.theme.pageType && new f();
            var e,
                t,
                i,
                n,
                o,
                a,
                s = new ie();
            s.register("header", Q),
                s.register("footer", K),
                s.register("sidebar-menu", ae),
                s.register("cart", N),
                s.register("newsletter-popup", X),
                s.register("slideshow", se),
                s.register("collection-list", V),
                s.register("article-list", H),
                s.register("featured-product", W),
                s.register("image-with-text-block", Z),
                s.register("timeline", le),
                s.register("map", G),
                s.register("featured-collections", U),
                s.register("shop-the-look", oe),
                s.register("testimonials", re),
                s.register("background-video", j),
                s.register("product", ee),
                s.register("product-recommendations", $),
                s.register("collection", F),
                s.register("article-list", H),
                s.register("article", B),
                s.register("faq", z),
                s.register("login", J),
                s.register("addresses", D),
                s.register("gift-card", Y),
                s.register("recently-viewed-products", te),
                s.register("shop-now", ne),
                (Flickity.defaults.dragThreshold = 7),
                (t = !1),
                document.body.addEventListener("touchstart", function (i) {
                    i.target.closest(".flickity-slider") ? ((t = !0), (e = { x: i.touches[0].pageX, y: i.touches[0].pageY })) : (t = !1);
                }),
                document.body.addEventListener(
                    "touchmove",
                    function (i) {
                        if (t && i.cancelable) {
                            var n = { x: i.touches[0].pageX - e.x, y: i.touches[0].pageY - e.y };
                            Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
                        }
                    },
                    { passive: !1 }
                ),
                (function () {
                    if (window.Flickity) {
                        var e = window.Flickity.prototype.resize,
                            t = window.innerWidth;
                        window.Flickity.prototype.resize = function () {
                            (window.innerWidth === t && this.maxCellHeight > 0) || ((t = window.innerWidth), e.apply(this, arguments));
                        };
                    }
                })(),
                h.nodeListToArray(document.querySelectorAll(".Rte table")).forEach(function (e) {
                    e.outerHTML = '<div class="TableWrapper">' + e.outerHTML + "</div>";
                }),
                h.nodeListToArray(document.querySelectorAll(".Rte iframe")).forEach(function (e) {
                    (-1 === e.src.indexOf("youtube") && -1 === e.src.indexOf("youtu.be") && -1 === e.src.indexOf("vimeo")) || ((e.outerHTML = '<div class="VideoWrapper">' + e.outerHTML + "</div>"), (e.src = e.src));
                }),
                (i = new domDelegate.Delegate(document.body)),
                (n = document.querySelector(".AnnouncementBar")),
                i.on("click", '[href^="#"], [data-href]', function (e, t) {
                    var i = t.hasAttribute("href") ? t.getAttribute("href") : t.getAttribute("data-href");
                    if ("#" !== i && "#main" !== i) {
                        var o = document.querySelector(i),
                            a = parseInt(t.getAttribute("data-offset") || 0);
                        if ((n && (a -= n.clientHeight), t.hasAttribute("data-focus-on-click"))) {
                            var s = window.pageYOffset;
                            o.focus({ preventScroll: !0 }), window.pageYOffset !== s && window.scrollTo(window.pageXOffset, s), o.focus();
                        }
                        window.scrollTo({ behavior: "smooth", top: o.offsetTop - a }), e.preventDefault();
                    }
                }),
                (o = window.innerWidth),
                (a = document.getElementById("shopify-section-header")),
                window.addEventListener("resize", function () {
                    var e = -1;
                    fastdom.measure(function () {
                        e = window.innerWidth;
                    }),
                        fastdom.mutate(function () {
                            e !== o && ((o = e), document.documentElement.style.setProperty("--window-height", window.innerHeight + "px"), a && document.documentElement.style.setProperty("--header-height", a.clientHeight + "px"));
                        });
                }),
                (function () {
                    window.addEventListener("keydown", function e(t) {
                        9 === t.keyCode && (document.body.classList.add("is-tabbing"), window.removeEventListener("keydown", e));
                    });
                })(),
                window.theme.showPageTransition && _.getInstance();


          
      if(document.querySelectorAll(".FeatureText [data-action='add-to-cart']").length){
        document.querySelectorAll(".FeatureText [data-action='add-to-cart'],.Slideshow__Content [data-action='add-to-cart']").forEach(function(item){
          item.addEventListener("click",function(event){
              event.preventDefault();
              var i = event.target;
              i.setAttribute("disabled", "disabled");
              document.dispatchEvent(new CustomEvent("theme:loading:start"));
              var n = i.closest('form[action*="/cart/add"]');
              fetch("".concat(window.routes.cartAddUrl, ".js"), {
                  body: JSON.stringify(E.serialize(n)),
                  credentials: "same-origin",
                  method: "POST",
                  headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
              }).then(function (e) {
                  document.dispatchEvent(new CustomEvent("theme:loading:end"));
                  var o = n.querySelector('[name="quantity"]');
                  e.ok
                      ? (i.removeAttribute("disabled"), document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { quantity: o ? parseInt(o.value) : 1 } })))
                      : e.json().then(function (e) {
                            var t = document.createElement("span");
                            (t.className = "ProductForm__Error Alert Alert--error"),
                                (t.innerHTML = e.description),
                                i.removeAttribute("disabled"),
                                i.insertAdjacentElement("afterend", t),
                                setTimeout(function () {
                                    t.remove();
                                }, 2500);
                        });
              })
          });
        });
      }

          
        })();
}),
    (function () {
      if(document.getElementById("toDate")) {
        var e = Date.today().addDays(3);
        e.is().sunday() && (e = e.next().monday()), (document.getElementById("toDate").innerHTML = e.toString("ddd, MMM dd"));
      }
    })();

// js/custom-element/section/cart/free-shipping-bar.js
var FreeShippingBar = class extends HTMLElement {
    connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));

        console.log("FreeShippingBar");
    }
    get threshold() {
        return parseFloat(this.getAttribute("threshold"));
    }
    _onCartUpdated(event) {
        const totalPrice = event.detail["cart"]["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0);
        this.style.setProperty("--progress", Math.min(totalPrice / this.threshold, 1));
    }
};
window.customElements.define("free-shipping-bar", FreeShippingBar);
